export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
    };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  /** An ISO 8601-encoded date */
  ISO8601Date: { input: string; output: string };
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: { input: string; output: string };
  /** Represents untyped JSON */
  JSON: { input: any; output: any };
  /** A float value that must be zero or positive (non-negative) */
  PositiveFloat: { input: number; output: number };
};

export type AccountList = {
  __typename?: 'AccountList';
  activeMpdFinishAt?: Maybe<Scalars['ISO8601Date']['output']>;
  activeMpdMonthlyGoal?: Maybe<Scalars['Float']['output']>;
  activeMpdStartAt?: Maybe<Scalars['ISO8601Date']['output']>;
  appeals?: Maybe<Array<Appeal>>;
  balance: Scalars['Float']['output'];
  churches: Array<Scalars['String']['output']>;
  coaches: UserScopedToAccountListConnection;
  contactFilterGroups: Array<FilterGroup>;
  contactTagList: Array<Scalars['String']['output']>;
  contacts: ContactConnection;
  createdAt: Scalars['ISO8601DateTime']['output'];
  currency: Scalars['String']['output'];
  designationAccounts: Array<DesignationAccount>;
  id: Scalars['ID']['output'];
  monthlyGoal?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  partnerGivingAnalysisFilterGroups: Array<FilterGroup>;
  primaryAppeal?: Maybe<Appeal>;
  receivedPledges: Scalars['Float']['output'];
  salaryOrganizationId?: Maybe<Scalars['String']['output']>;
  settings?: Maybe<AccountListSettings>;
  taskFilterGroups: Array<FilterGroup>;
  taskTagList: Array<Scalars['String']['output']>;
  totalPledges: Scalars['Float']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  users: UserScopedToAccountListConnection;
  weeksOnMpd: Scalars['Int']['output'];
};

export type AccountListChurchesArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
};

export type AccountListCoachesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AccountListContactsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ContactFilterSetInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AccountListUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AccountListAnalytics = {
  __typename?: 'AccountListAnalytics';
  appointments: AppointmentsAccountListAnalytics;
  contacts: ContactsAccountListAnalytics;
  contactsByStatus: ContactsByStatus;
  correspondence: CorrespondenceAccountListAnalytics;
  electronic: ElectronicAccountListAnalytics;
  email: EmailsAccountListAnalytics;
  endDate: Scalars['ISO8601DateTime']['output'];
  facebook: FacebookAccountListAnalytics;
  phone: PhoneAccountListAnalytics;
  startDate: Scalars['ISO8601DateTime']['output'];
  textMessage: TextMessageAccountListAnalytics;
};

/** Autogenerated input type of AccountListCoachDeleteMutation */
export type AccountListCoachDeleteMutationInput = {
  /** account list id */
  accountListId?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the coach to remove */
  coachId?: InputMaybe<Scalars['ID']['input']>;
  /** account list id (DEPRECATED: please use account_list_id AND coach_id instead) */
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of AccountListCoachDeleteMutation. */
export type AccountListCoachDeleteMutationPayload = {
  __typename?: 'AccountListCoachDeleteMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type AccountListCoaches = {
  __typename?: 'AccountListCoaches';
  accountListsId?: Maybe<Scalars['ID']['output']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  updatedInDbAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  userCoachesId?: Maybe<Scalars['ID']['output']>;
};

/** The connection type for AccountList. */
export type AccountListConnection = {
  __typename?: 'AccountListConnection';
  /** A list of edges. */
  edges: Array<AccountListEdge>;
  /** A list of nodes. */
  nodes: Array<AccountList>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total # of objects returned from this Plural Query */
  totalCount: Scalars['Int']['output'];
  /** Total # of pages, based on total count and pagesize */
  totalPageCount: Scalars['Int']['output'];
};

export type AccountListDesignationAccounts = {
  __typename?: 'AccountListDesignationAccounts';
  displayName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  organization?: Maybe<AccountListOrganization>;
};

export type AccountListDonorAccount = {
  __typename?: 'AccountListDonorAccount';
  accountNumber: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

/** An edge in a connection. */
export type AccountListEdge = {
  __typename?: 'AccountListEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<AccountList>;
};

export type AccountListEmailAddresses = {
  __typename?: 'AccountListEmailAddresses';
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  primary?: Maybe<Scalars['Boolean']['output']>;
};

export type AccountListInvite = {
  __typename?: 'AccountListInvite';
  accountListId: Scalars['ID']['output'];
  cancelledByUser?: Maybe<UserScopedToAccountList>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  inviteUserAs?: Maybe<InviteTypeEnum>;
  invitedByUser: UserScopedToAccountList;
  recipientEmail: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** The connection type for AccountListInvite. */
export type AccountListInviteConnection = {
  __typename?: 'AccountListInviteConnection';
  /** A list of edges. */
  edges: Array<AccountListInviteEdge>;
  /** A list of nodes. */
  nodes: Array<AccountListInvite>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total # of objects returned from this Plural Query */
  totalCount: Scalars['Int']['output'];
  /** Total # of pages, based on total count and pagesize */
  totalPageCount: Scalars['Int']['output'];
};

export type AccountListInviteCreateInput = {
  accountListId: Scalars['ID']['input'];
  inviteUserAs: InviteTypeEnum;
  recipientEmail: Scalars['String']['input'];
};

/** An edge in a connection. */
export type AccountListInviteEdge = {
  __typename?: 'AccountListInviteEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<AccountListInvite>;
};

export type AccountListInvitedByUser = {
  __typename?: 'AccountListInvitedByUser';
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
};

export type AccountListInvites = {
  __typename?: 'AccountListInvites';
  id?: Maybe<Scalars['ID']['output']>;
  inviteUserAs?: Maybe<Scalars['String']['output']>;
  invitedByUser?: Maybe<AccountListInvitedByUser>;
  recipientEmail?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of AccountListMergeMutation */
export type AccountListMergeMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  losingAccountListId: Scalars['ID']['input'];
  winningAccountListId: Scalars['ID']['input'];
};

/** Autogenerated return type of AccountListMergeMutation. */
export type AccountListMergeMutationPayload = {
  __typename?: 'AccountListMergeMutationPayload';
  accountList: AccountList;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type AccountListOrganization = {
  __typename?: 'AccountListOrganization';
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of AccountListPledgeCreateMutation */
export type AccountListPledgeCreateMutationInput = {
  /** AccountList ID that the appeal will be found from */
  accountListId: Scalars['ID']['input'];
  /** Attributes of created pledge */
  attributes: PledgeCreateInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of AccountListPledgeCreateMutation. */
export type AccountListPledgeCreateMutationPayload = {
  __typename?: 'AccountListPledgeCreateMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  pledge: Pledge;
};

/** Autogenerated input type of AccountListPledgeDeleteMutation */
export type AccountListPledgeDeleteMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the pledge to remove */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of AccountListPledgeDeleteMutation. */
export type AccountListPledgeDeleteMutationPayload = {
  __typename?: 'AccountListPledgeDeleteMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

/** Autogenerated input type of AccountListPledgeUpdateMutation */
export type AccountListPledgeUpdateMutationInput = {
  /** Attributes of updated pledge */
  attributes: PledgeUpdateInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Pledge ID that will be updated */
  pledgeId: Scalars['ID']['input'];
};

/** Autogenerated return type of AccountListPledgeUpdateMutation. */
export type AccountListPledgeUpdateMutationPayload = {
  __typename?: 'AccountListPledgeUpdateMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  pledge: Pledge;
};

/** Autogenerated input type of AccountListResetMutation */
export type AccountListResetMutationInput = {
  accountListId?: InputMaybe<Scalars['String']['input']>;
  accountListName?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  reason: Scalars['String']['input'];
  resettedUserEmail?: InputMaybe<Scalars['String']['input']>;
  resettedUserId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of AccountListResetMutation. */
export type AccountListResetMutationPayload = {
  __typename?: 'AccountListResetMutationPayload';
  accountList: AccountList;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type AccountListSettings = {
  __typename?: 'AccountListSettings';
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Currency the user receives paychecks in */
  currency?: Maybe<Scalars['String']['output']>;
  /** Location used for the geographic salary multiplier */
  geographicLocation?: Maybe<Scalars['String']['output']>;
  /** Country the user is located in */
  homeCountry?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** The target monthly goal for the account list */
  monthlyGoal?: Maybe<Scalars['Float']['output']>;
  /** User opt-in to be a tester for new features */
  tester?: Maybe<Scalars['Boolean']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type AccountListSettingsInput = {
  /** Currency the user receives paychecks in */
  currency?: InputMaybe<Scalars['String']['input']>;
  /** Location used for the geographic salary multiplier */
  geographicLocation?: InputMaybe<Scalars['String']['input']>;
  /** Country the user is located in */
  homeCountry?: InputMaybe<Scalars['String']['input']>;
  /** The target monthly goal for the account list */
  monthlyGoal?: InputMaybe<Scalars['Float']['input']>;
  /** User opt-in to be a tester for new features */
  tester?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AccountListUpdateInput = {
  activeMpdFinishAt?: InputMaybe<Scalars['ISO8601Date']['input']>;
  activeMpdMonthlyGoal?: InputMaybe<Scalars['Float']['input']>;
  activeMpdStartAt?: InputMaybe<Scalars['ISO8601Date']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  salaryOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  settings?: InputMaybe<AccountListSettingsInput>;
};

/** Autogenerated input type of AccountListUpdateMutation */
export type AccountListUpdateMutationInput = {
  attributes: AccountListUpdateInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of AccountListUpdateMutation. */
export type AccountListUpdateMutationPayload = {
  __typename?: 'AccountListUpdateMutationPayload';
  accountList: AccountList;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type AccountListUser = {
  __typename?: 'AccountListUser';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  user: UserScopedToAccountList;
};

/** The connection type for AccountListUser. */
export type AccountListUserConnection = {
  __typename?: 'AccountListUserConnection';
  /** A list of edges. */
  edges: Array<AccountListUserEdge>;
  /** A list of nodes. */
  nodes: Array<AccountListUser>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total # of objects returned from this Plural Query */
  totalCount: Scalars['Int']['output'];
  /** Total # of pages, based on total count and pagesize */
  totalPageCount: Scalars['Int']['output'];
};

/** Autogenerated input type of AccountListUserDeleteMutation */
export type AccountListUserDeleteMutationInput = {
  /** account list id */
  accountListId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the user to remove */
  userId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of AccountListUserDeleteMutation. */
export type AccountListUserDeleteMutationPayload = {
  __typename?: 'AccountListUserDeleteMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

/** An edge in a connection. */
export type AccountListUserEdge = {
  __typename?: 'AccountListUserEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<AccountListUser>;
};

export type AccountListUsers = {
  __typename?: 'AccountListUsers';
  allowDeletion?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  lastSyncedAt?: Maybe<Scalars['String']['output']>;
  organizationCount?: Maybe<Scalars['Int']['output']>;
  userEmailAddresses?: Maybe<Array<Maybe<AccountListEmailAddresses>>>;
  userFirstName?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['ID']['output']>;
  userLastName?: Maybe<Scalars['String']['output']>;
};

export type AccountSummaryTransaction = {
  __typename?: 'AccountSummaryTransaction';
  amount: Scalars['Float']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  personNumber?: Maybe<Scalars['String']['output']>;
  transactedAt: Scalars['ISO8601DateTime']['output'];
};

/** Autogenerated input type of AcknowledgeAllUserNotificationsMutation */
export type AcknowledgeAllUserNotificationsMutationInput = {
  accountListId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of AcknowledgeAllUserNotificationsMutation. */
export type AcknowledgeAllUserNotificationsMutationPayload = {
  __typename?: 'AcknowledgeAllUserNotificationsMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  notificationIds: Array<Scalars['ID']['output']>;
};

/** Autogenerated input type of AcknowledgeAnnouncementMutation */
export type AcknowledgeAnnouncementMutationInput = {
  /** action being triggered by user (must belong to announcement being acknowledged) */
  actionId?: InputMaybe<Scalars['ID']['input']>;
  /** announcement to acknowledge (will no longer be visible under announcements query) */
  announcementId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of AcknowledgeAnnouncementMutation. */
export type AcknowledgeAnnouncementMutationPayload = {
  __typename?: 'AcknowledgeAnnouncementMutationPayload';
  announcement: Announcement;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of AcknowledgeUserNotificationMutation */
export type AcknowledgeUserNotificationMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** userNotification to acknowledge (will mark userNotification as read) */
  notificationId: Scalars['ID']['input'];
};

/** Autogenerated return type of AcknowledgeUserNotificationMutation. */
export type AcknowledgeUserNotificationMutationPayload = {
  __typename?: 'AcknowledgeUserNotificationMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  notification: UserNotification;
};

export type Action = {
  __typename?: 'Action';
  action?: Maybe<ActionEnum>;
  args?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  style?: Maybe<ActionStyleEnum>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export enum ActionEnum {
  /** this action should create an appeal. */
  AppealCreate = 'appeal_create',
  /** this action should navigate to a specific location (use args to determine destination) */
  Go = 'go',
  /** this action should dispatch an event to adobe analytics (use args to determine event to dispatch) */
  Track = 'track',
}

export enum ActionStyleEnum {
  /** announcement should be colored as a danger button */
  Danger = 'danger',
  /** action should not have coloring */
  Default = 'default',
  /** announcement should be colored as a font-awesome icon (use label as icon type) */
  Icon = 'icon',
  /** action should be colored as an infomational button */
  Info = 'info',
  /** announcement should be colored as a link */
  Link = 'link',
  /** action should be colored as a primary button */
  Primary = 'primary',
  /** announcement should be colored as a reverse button */
  ReverseAction = 'reverse_action',
  /** action should be colored as a secondary button */
  Secondary = 'secondary',
  /** announcement should be colored as a success button */
  Success = 'success',
  /** action should be colored as a warning button */
  Warning = 'warning',
}

export type ActivitiesConstant = {
  __typename?: 'ActivitiesConstant';
  action: Scalars['String']['output'];
  id: ActivityTypeEnum;
  name: Scalars['String']['output'];
  phase: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ActivityResults = {
  __typename?: 'ActivityResults';
  periods: Array<ActivityResultsPeriod>;
};

export type ActivityResultsPeriod = {
  __typename?: 'ActivityResultsPeriod';
  appointmentInPerson: Scalars['Int']['output'];
  appointmentPhoneCall: Scalars['Int']['output'];
  appointmentTotal: Scalars['Int']['output'];
  appointmentVideoCall: Scalars['Int']['output'];
  callsWithAppointmentNext: Scalars['Int']['output'];
  completedCall: Scalars['Int']['output'];
  completedPreCallLetter: Scalars['Int']['output'];
  completedReminderLetter: Scalars['Int']['output'];
  completedSupportLetter: Scalars['Int']['output'];
  completedThank: Scalars['Int']['output'];
  contactsAdded: Scalars['Int']['output'];
  contactsReferred: Scalars['Int']['output'];
  contactsTotal: Scalars['Int']['output'];
  dials: Scalars['Int']['output'];
  electronicMessageSent: Scalars['Int']['output'];
  electronicMessageWithAppointmentNext: Scalars['Int']['output'];
  endDate: Scalars['ISO8601Date']['output'];
  followUpEmail: Scalars['Int']['output'];
  followUpInPerson: Scalars['Int']['output'];
  followUpLetterCard: Scalars['Int']['output'];
  followUpPhoneCall: Scalars['Int']['output'];
  followUpSocialMedia: Scalars['Int']['output'];
  followUpTextMessage: Scalars['Int']['output'];
  followUpToDo: Scalars['Int']['output'];
  followUpTotal: Scalars['Int']['output'];
  initiationEmail: Scalars['Int']['output'];
  initiationInPerson: Scalars['Int']['output'];
  initiationLetter: Scalars['Int']['output'];
  initiationPhoneCall: Scalars['Int']['output'];
  initiationSocialMedia: Scalars['Int']['output'];
  initiationSpecialGiftAppeal: Scalars['Int']['output'];
  initiationTextMessage: Scalars['Int']['output'];
  initiationToDo: Scalars['Int']['output'];
  initiationTotal: Scalars['Int']['output'];
  partnerCareDigitalNewsletter: Scalars['Int']['output'];
  partnerCareEmail: Scalars['Int']['output'];
  partnerCareInPerson: Scalars['Int']['output'];
  partnerCareLetterCard: Scalars['Int']['output'];
  partnerCarePhoneCall: Scalars['Int']['output'];
  partnerCarePhysicalNewsletter: Scalars['Int']['output'];
  partnerCarePrayerRequest: Scalars['Int']['output'];
  partnerCareSocialMedia: Scalars['Int']['output'];
  partnerCareTextMessage: Scalars['Int']['output'];
  partnerCareThank: Scalars['Int']['output'];
  partnerCareToDo: Scalars['Int']['output'];
  partnerCareTotal: Scalars['Int']['output'];
  partnerCareUpdateInformation: Scalars['Int']['output'];
  startDate: Scalars['ISO8601Date']['output'];
};

export enum ActivityTypeEnum {
  AppointmentInPerson = 'APPOINTMENT_IN_PERSON',
  AppointmentPhoneCall = 'APPOINTMENT_PHONE_CALL',
  AppointmentVideoCall = 'APPOINTMENT_VIDEO_CALL',
  FollowUpEmail = 'FOLLOW_UP_EMAIL',
  FollowUpInPerson = 'FOLLOW_UP_IN_PERSON',
  FollowUpLetterCard = 'FOLLOW_UP_LETTER_CARD',
  FollowUpPhoneCall = 'FOLLOW_UP_PHONE_CALL',
  FollowUpSocialMedia = 'FOLLOW_UP_SOCIAL_MEDIA',
  FollowUpTextMessage = 'FOLLOW_UP_TEXT_MESSAGE',
  FollowUpToDo = 'FOLLOW_UP_TO_DO',
  InitiationEmail = 'INITIATION_EMAIL',
  InitiationInPerson = 'INITIATION_IN_PERSON',
  InitiationLetter = 'INITIATION_LETTER',
  InitiationPhoneCall = 'INITIATION_PHONE_CALL',
  InitiationSocialMedia = 'INITIATION_SOCIAL_MEDIA',
  InitiationSpecialGiftAppeal = 'INITIATION_SPECIAL_GIFT_APPEAL',
  InitiationTextMessage = 'INITIATION_TEXT_MESSAGE',
  InitiationToDo = 'INITIATION_TO_DO',
  /** special type when filtered by will return any task with no activityType */
  None = 'NONE',
  PartnerCareDigitalNewsletter = 'PARTNER_CARE_DIGITAL_NEWSLETTER',
  PartnerCareEmail = 'PARTNER_CARE_EMAIL',
  PartnerCareInPerson = 'PARTNER_CARE_IN_PERSON',
  PartnerCareLetterCard = 'PARTNER_CARE_LETTER_CARD',
  PartnerCarePhoneCall = 'PARTNER_CARE_PHONE_CALL',
  PartnerCarePhysicalNewsletter = 'PARTNER_CARE_PHYSICAL_NEWSLETTER',
  PartnerCarePrayerRequest = 'PARTNER_CARE_PRAYER_REQUEST',
  PartnerCareSocialMedia = 'PARTNER_CARE_SOCIAL_MEDIA',
  PartnerCareTextMessage = 'PARTNER_CARE_TEXT_MESSAGE',
  PartnerCareThank = 'PARTNER_CARE_THANK',
  PartnerCareToDo = 'PARTNER_CARE_TO_DO',
  PartnerCareUpdateInformation = 'PARTNER_CARE_UPDATE_INFORMATION',
}

export type AdditionalSalaryRequest = {
  __typename?: 'AdditionalSalaryRequest';
  /** Explanation for why a user is over the cap */
  additionalInfo?: Maybe<Scalars['String']['output']>;
  /** Additional salary not exceeding your Maximum Allowable Salary level */
  additionalSalaryWithinMax?: Maybe<Scalars['PositiveFloat']['output']>;
  /** Adoption */
  adoption?: Maybe<Scalars['PositiveFloat']['output']>;
  /** Timestamp when the request was approved */
  approvedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Auto purchase */
  autoPurchase?: Maybe<Scalars['PositiveFloat']['output']>;
  /** Babysitting for ministry meetings, training, and retreats */
  babysittingMinistryEvents?: Maybe<Scalars['PositiveFloat']['output']>;
  calculations: AdditionalSalaryRequestCalculations;
  /** Timestamp when the request was canceled */
  canceledAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Timestamp when changes were requested */
  changesRequestedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Children's college education */
  childrenCollegeEducation?: Maybe<Scalars['PositiveFloat']['output']>;
  /** Children's expenses on a ministry trip */
  childrenMinistryTripExpenses?: Maybe<Scalars['PositiveFloat']['output']>;
  /** Counseling that is not for the treatment of a medical condition */
  counselingNonMedical?: Maybe<Scalars['PositiveFloat']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Current year's (2025) salary not received due to inadequate support */
  currentYearSalaryNotReceived?: Maybe<Scalars['PositiveFloat']['output']>;
  /** Election type for 403(b) contribution requested as additional salary */
  electionType403b?: Maybe<ElectionType403bEnum>;
  /** Email Address */
  emailAddress?: Maybe<Scalars['String']['output']>;
  /** Reimbursable expenses that were not approved within 90 days */
  expensesNotApprovedWithin90Days?: Maybe<Scalars['PositiveFloat']['output']>;
  /** Feedback from reviewers */
  feedback?: Maybe<Scalars['String']['output']>;
  /** Healthcare expenses that exceed the annual reimbursable limit. */
  healthcareExpensesExceedingLimit?: Maybe<Scalars['PositiveFloat']['output']>;
  /** Housing Down Payment */
  housingDownPayment?: Maybe<Scalars['PositiveFloat']['output']>;
  id: Scalars['ID']['output'];
  /** Moving Expense */
  movingExpense?: Maybe<Scalars['PositiveFloat']['output']>;
  /** Timestamp when the request was marked as paid */
  paidAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** HR person number associated with this request */
  personNumber: Scalars['String']['output'];
  /** Phone Number */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** Previous year's salary not received due to inadequate support */
  previousYearSalaryNotReceived?: Maybe<Scalars['PositiveFloat']['output']>;
  /** The progressive approval tier required based on predicted income with ASR */
  progressiveApprovalTier?: Maybe<ProgressiveApprovalTier>;
  /** Reason why the progressive approval is required */
  progressiveApprovalTierReason?: Maybe<ProgressiveApprovalTierReasonEnum>;
  /** Seminary */
  seminary?: Maybe<Scalars['PositiveFloat']['output']>;
  spouseCalculations?: Maybe<AdditionalSalaryRequestCalculations>;
  /** Current status of the request in the approval workflow */
  status: AsrStatusEnum;
  /** Timestamp when the request was submitted */
  submittedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Total Additional Salary Requested */
  totalAdditionalSalaryRequested?: Maybe<Scalars['PositiveFloat']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** User who created this request */
  user?: Maybe<User>;
  /** Using Spouse Salary */
  usingSpouseSalary?: Maybe<Scalars['Boolean']['output']>;
};

export type AdditionalSalaryRequestAttributesInput = {
  /** Explanation for why a user is over the cap */
  additionalInfo?: InputMaybe<Scalars['String']['input']>;
  /** Additional salary not exceeding your Maximum Allowable Salary level */
  additionalSalaryWithinMax?: InputMaybe<Scalars['PositiveFloat']['input']>;
  /** Adoption */
  adoption?: InputMaybe<Scalars['PositiveFloat']['input']>;
  /** Auto purchase */
  autoPurchase?: InputMaybe<Scalars['PositiveFloat']['input']>;
  /** Babysitting for ministry meetings, training, and retreats */
  babysittingMinistryEvents?: InputMaybe<Scalars['PositiveFloat']['input']>;
  /** Children's college education */
  childrenCollegeEducation?: InputMaybe<Scalars['PositiveFloat']['input']>;
  /** Children's expenses on a ministry trip */
  childrenMinistryTripExpenses?: InputMaybe<Scalars['PositiveFloat']['input']>;
  /** Counseling that is not for the treatment of a medical condition */
  counselingNonMedical?: InputMaybe<Scalars['PositiveFloat']['input']>;
  /** Current year's (2025) salary not received due to inadequate support */
  currentYearSalaryNotReceived?: InputMaybe<Scalars['PositiveFloat']['input']>;
  /** Election type for 403(b) contribution requested as additional salary */
  electionType403b?: InputMaybe<ElectionType403bEnum>;
  /** Email Address */
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  /** Reimbursable expenses that were not approved within 90 days */
  expensesNotApprovedWithin90Days?: InputMaybe<
    Scalars['PositiveFloat']['input']
  >;
  /** Healthcare expenses that exceed the annual reimbursable limit. */
  healthcareExpensesExceedingLimit?: InputMaybe<
    Scalars['PositiveFloat']['input']
  >;
  /** Housing Down Payment */
  housingDownPayment?: InputMaybe<Scalars['PositiveFloat']['input']>;
  /** Moving Expense */
  movingExpense?: InputMaybe<Scalars['PositiveFloat']['input']>;
  /** Phone Number */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Previous year's salary not received due to inadequate support */
  previousYearSalaryNotReceived?: InputMaybe<Scalars['PositiveFloat']['input']>;
  /** Seminary */
  seminary?: InputMaybe<Scalars['PositiveFloat']['input']>;
  /** Using Spouse Salary */
  usingSpouseSalary?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AdditionalSalaryRequestCalculations = {
  __typename?: 'AdditionalSalaryRequestCalculations';
  /** The most this ASR may total, backpay included: the Primary balance plus its deficit limit, minus both spouses' other unpaid ASRs */
  availableStaffAccountBalance: Scalars['Float']['output'];
  /** Combined salary cap for the family unit */
  combinedCap?: Maybe<Scalars['Float']['output']>;
  /** Current salary cap from SalaryCapCalculator */
  currentSalaryCap?: Maybe<Scalars['Float']['output']>;
  /** Geographic location used to calculate the salary cap */
  geographicLocation?: Maybe<Scalars['String']['output']>;
  /**
   * Projected gross annual salary, taking into account any submitted salary requests.
   * A salary request still in review is only used when it raises the salary. Does not include any ASRs.
   */
  grossAnnualSalary: Scalars['Float']['output'];
  /** Whether the gross annual salary came from an outstanding salary request instead of HCM */
  outstandingSalaryRequest: Scalars['Boolean']['output'];
  /** How much more additional salary fits under currentSalaryCap, never below 0. Counts this ASR once it is pending or approved and counts toward this year. Null when there is no cap. */
  remainingAllowableSalary?: Maybe<Scalars['Float']['output']>;
  /** Current staff account balance */
  staffAccountBalance: Scalars['Float']['output'];
  /**
   * This year's additional salary that counts toward the user's salary cap: HCM's year-to-date
   * additional salary (all payroll systems, not counting current-year backpay on paid ASRs) plus the non-backpay portion
   * of pending, action required and approved-but-unpaid ASRs and of paid ASRs whose pay date HCM's year-to-date hasn't
   * reached.
   */
  ytdAsrAmount: Scalars['Float']['output'];
};

/** Autogenerated input type of AdditionalSalaryRequestCreateMutation */
export type AdditionalSalaryRequestCreateMutationInput = {
  /** JSON object containing the form data for the additional salary request */
  attributes?: InputMaybe<AdditionalSalaryRequestAttributesInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Indicates if the request is for a spouse */
  isSpouse?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of AdditionalSalaryRequestCreateMutation. */
export type AdditionalSalaryRequestCreateMutationPayload = {
  __typename?: 'AdditionalSalaryRequestCreateMutationPayload';
  additionalSalaryRequest: AdditionalSalaryRequest;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of AdditionalSalaryRequestDeleteMutation */
export type AdditionalSalaryRequestDeleteMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Request ID to delete */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of AdditionalSalaryRequestDeleteMutation. */
export type AdditionalSalaryRequestDeleteMutationPayload = {
  __typename?: 'AdditionalSalaryRequestDeleteMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

/** Autogenerated input type of AdditionalSalaryRequestSubmitMutation */
export type AdditionalSalaryRequestSubmitMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Request ID */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of AdditionalSalaryRequestSubmitMutation. */
export type AdditionalSalaryRequestSubmitMutationPayload = {
  __typename?: 'AdditionalSalaryRequestSubmitMutationPayload';
  additionalSalaryRequest: AdditionalSalaryRequest;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of AdditionalSalaryRequestUpdateMutation */
export type AdditionalSalaryRequestUpdateMutationInput = {
  /** Structured form data for the Additional Salary Request */
  attributes: AdditionalSalaryRequestAttributesInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Request ID to update */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of AdditionalSalaryRequestUpdateMutation. */
export type AdditionalSalaryRequestUpdateMutationPayload = {
  __typename?: 'AdditionalSalaryRequestUpdateMutationPayload';
  additionalSalaryRequest: AdditionalSalaryRequest;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type Address = {
  __typename?: 'Address';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  geo?: Maybe<Scalars['String']['output']>;
  historic: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  location?: Maybe<Scalars['String']['output']>;
  metroArea?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  primaryMailingAddress: Scalars['Boolean']['output'];
  region?: Maybe<Scalars['String']['output']>;
  source: Scalars['String']['output'];
  sourceDonorAccount?: Maybe<DonorAccount>;
  startDate?: Maybe<Scalars['ISO8601Date']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  validValues: Scalars['Boolean']['output'];
};

/** The connection type for Address. */
export type AddressConnection = {
  __typename?: 'AddressConnection';
  /** A list of edges. */
  edges: Array<AddressEdge>;
  /** A list of nodes. */
  nodes: Array<Address>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total # of objects returned from this Plural Query */
  totalCount: Scalars['Int']['output'];
  /** Total # of pages, based on total count and pagesize */
  totalPageCount: Scalars['Int']['output'];
};

export type AddressCreateInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  contactId: Scalars['String']['input'];
  country?: InputMaybe<Scalars['String']['input']>;
  historic?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  metroArea?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street: Scalars['String']['input'];
};

/** Autogenerated input type of AddressCreateMutation */
export type AddressCreateMutationInput = {
  /** AccountList ID that address is associated with */
  accountListId: Scalars['ID']['input'];
  /** attributes to create address */
  attributes: AddressCreateInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of AddressCreateMutation. */
export type AddressCreateMutationPayload = {
  __typename?: 'AddressCreateMutationPayload';
  address: Address;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of AddressDeleteMutation */
export type AddressDeleteMutationInput = {
  accountListId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of AddressDeleteMutation. */
export type AddressDeleteMutationPayload = {
  __typename?: 'AddressDeleteMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

/** An edge in a connection. */
export type AddressEdge = {
  __typename?: 'AddressEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Address>;
};

export type AddressUpdateInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  historic?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  location?: InputMaybe<Scalars['String']['input']>;
  metroArea?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  primaryMailingAddress?: InputMaybe<Scalars['Boolean']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  validValues?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated input type of AddressUpdateMutation */
export type AddressUpdateMutationInput = {
  accountListId: Scalars['ID']['input'];
  /** attributes to update address */
  attributes: AddressUpdateInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of AddressUpdateMutation. */
export type AddressUpdateMutationPayload = {
  __typename?: 'AddressUpdateMutationPayload';
  address: Address;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type AddressWithPrimary = {
  __typename?: 'AddressWithPrimary';
  id: Scalars['ID']['output'];
  primaryMailingAddress: Scalars['Boolean']['output'];
};

export type AdminDeleteOrganizationCoachInput = {
  accountListId: Scalars['ID']['input'];
  coachId: Scalars['ID']['input'];
};

export type AdminDeleteOrganizationInviteInput = {
  accountListId: Scalars['ID']['input'];
  inviteId: Scalars['ID']['input'];
};

export type AdminDeleteOrganizationUserInput = {
  accountListId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type AdminList = {
  __typename?: 'AdminList';
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
};

export type AllOrganizations = {
  __typename?: 'AllOrganizations';
  organizations: Array<Maybe<Organizations>>;
  pagination: AllOrganizationsPagination;
};

export type AllOrganizationsPagination = {
  __typename?: 'AllOrganizationsPagination';
  page: Scalars['Int']['output'];
  perPage: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type Announcement = {
  __typename?: 'Announcement';
  actions: Array<Action>;
  body?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  displayMethod: DisplayMethodEnum;
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  style?: Maybe<StyleEnum>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** The connection type for Announcement. */
export type AnnouncementConnection = {
  __typename?: 'AnnouncementConnection';
  /** A list of edges. */
  edges: Array<AnnouncementEdge>;
  /** A list of nodes. */
  nodes: Array<Announcement>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total # of objects returned from this Plural Query */
  totalCount: Scalars['Int']['output'];
  /** Total # of pages, based on total count and pagesize */
  totalPageCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AnnouncementEdge = {
  __typename?: 'AnnouncementEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Announcement>;
};

/** Autogenerated input type of ApiOauthSignInMutation */
export type ApiOauthSignInMutationInput = {
  accessToken: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of ApiOauthSignInMutation. */
export type ApiOauthSignInMutationPayload = {
  __typename?: 'ApiOauthSignInMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export type Appeal = {
  __typename?: 'Appeal';
  active: Scalars['Boolean']['output'];
  amount?: Maybe<Scalars['Float']['output']>;
  amountCurrency: Scalars['String']['output'];
  contactIds?: Maybe<Array<Scalars['String']['output']>>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  currencies?: Maybe<Array<Scalars['String']['output']>>;
  description: Scalars['String']['output'];
  endDate?: Maybe<Scalars['ISO8601Date']['output']>;
  excludedAppealContacts?: Maybe<Array<ExcludedAppealContact>>;
  excludedContacts?: Maybe<Array<Contact>>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  pledges: PledgeConnection;
  pledgesAmountNotReceivedNotProcessed: Scalars['Float']['output'];
  pledgesAmountProcessed: Scalars['Float']['output'];
  pledgesAmountReceivedNotProcessed: Scalars['Float']['output'];
  pledgesAmountTotal: Scalars['Float']['output'];
  primary: Scalars['Boolean']['output'];
  totalCurrency?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type AppealPledgesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for Appeal. */
export type AppealConnection = {
  __typename?: 'AppealConnection';
  /** A list of edges. */
  edges: Array<AppealEdge>;
  /** A list of nodes. */
  nodes: Array<Appeal>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total # of objects returned from this Plural Query */
  totalCount: Scalars['Int']['output'];
  /** Total # of pages, based on total count and pagesize */
  totalPageCount: Scalars['Int']['output'];
};

export type AppealContact = {
  __typename?: 'AppealContact';
  contact: Contact;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  pledgedToAppeal: Scalars['Boolean']['output'];
  pledges?: Maybe<Array<Pledge>>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** The connection type for AppealContact. */
export type AppealContactConnection = {
  __typename?: 'AppealContactConnection';
  /** A list of edges. */
  edges: Array<AppealContactEdge>;
  /** A list of nodes. */
  nodes: Array<AppealContact>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total # of objects returned from this Plural Query */
  totalCount: Scalars['Int']['output'];
  /** Total # of pages, based on total count and pagesize */
  totalPageCount: Scalars['Int']['output'];
};

/** Autogenerated input type of AppealContactDeleteMutation */
export type AppealContactDeleteMutationInput = {
  /** ID of the appeal associated with the appeal_contact to be deleted */
  appealId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the contact associated with the appeal_contact to be deleted */
  contactId: Scalars['ID']['input'];
};

/** Autogenerated return type of AppealContactDeleteMutation. */
export type AppealContactDeleteMutationPayload = {
  __typename?: 'AppealContactDeleteMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

/** An edge in a connection. */
export type AppealContactEdge = {
  __typename?: 'AppealContactEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<AppealContact>;
};

export type AppealCreateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** A json hash of exclusion filters (see app/services/contact/filter/ for all options) to determine which contacts to exclude */
  exclusionFilter?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** A json hash of inclusion filters (see app/services/contact/filter/ for all options) to determine which contacts to include */
  inclusionFilter?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  primary?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated input type of AppealCreateMutation */
export type AppealCreateMutationInput = {
  /** AccountList ID that the contact is associated with */
  accountListId: Scalars['ID']['input'];
  /** attributes to create */
  attributes: AppealCreateInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of AppealCreateMutation. */
export type AppealCreateMutationPayload = {
  __typename?: 'AppealCreateMutationPayload';
  appeal: Appeal;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of AppealDeleteMutation */
export type AppealDeleteMutationInput = {
  /** AccountList ID that the appeal is associated with */
  accountListId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of appeal to delete */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of AppealDeleteMutation. */
export type AppealDeleteMutationPayload = {
  __typename?: 'AppealDeleteMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

/** An edge in a connection. */
export type AppealEdge = {
  __typename?: 'AppealEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Appeal>;
};

export type AppealUpdateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  primary?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated input type of AppealUpdateMutation */
export type AppealUpdateMutationInput = {
  /** AccountList ID that the appeal is associated with */
  accountListId: Scalars['ID']['input'];
  /** attributes to update */
  attributes: AppealUpdateInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of AppealUpdateMutation. */
export type AppealUpdateMutationPayload = {
  __typename?: 'AppealUpdateMutationPayload';
  appeal: Appeal;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type AppointmentsAccountListAnalytics = {
  __typename?: 'AppointmentsAccountListAnalytics';
  completed: Scalars['Int']['output'];
};

export type AsrEit = {
  __typename?: 'AsrEit';
  /** Indicates whether the user is eligible to create ASR requests */
  asrEligibility: Scalars['Boolean']['output'];
  /** Reason why the user is ineligible to create ASR requests */
  ineligibilityReason?: Maybe<Scalars['String']['output']>;
};

export enum AsrStatusEnum {
  /** Request needs changes from the user */
  ActionRequired = 'ACTION_REQUIRED',
  /** Request has been approved and paid */
  ApprovedAndPaid = 'APPROVED_AND_PAID',
  /** Request has been approved but not paid */
  ApprovedNotPaid = 'APPROVED_NOT_PAID',
  /** Request has been canceled */
  Canceled = 'CANCELED',
  /** Request is being drafted by the user */
  InProgress = 'IN_PROGRESS',
  /** Request has been submitted and is awaiting review */
  Pending = 'PENDING',
}

export type AssignContactsToAppealInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  contactIds: Array<Scalars['ID']['input']>;
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  forceListDeletion?: InputMaybe<Scalars['Boolean']['input']>;
  /** ID blank if you want to create the new Appeal */
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  primary?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated input type of AssignContactsToAppealMutation */
export type AssignContactsToAppealMutationInput = {
  /** AccountList ID that the appeal is associated with */
  accountListId: Scalars['ID']['input'];
  /** attributes to assign */
  attributes: AssignContactsToAppealInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of AssignContactsToAppealMutation. */
export type AssignContactsToAppealMutationPayload = {
  __typename?: 'AssignContactsToAppealMutationPayload';
  appeal: Appeal;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export enum AssignmentCategoryEnum {
  /** Full-time regular */
  FullTimeRegular = 'FULL_TIME_REGULAR',
  /** Full-time temporary */
  FullTimeTemporary = 'FULL_TIME_TEMPORARY',
  /** On Call */
  OnCall = 'ON_CALL',
  /** Part-time regular */
  PartTimeRegular = 'PART_TIME_REGULAR',
  /** Part-time temporary */
  PartTimeTemporary = 'PART_TIME_TEMPORARY',
}

export enum AssignmentLengthEnum {
  /** Intl Intern */
  IntlIntern = 'INTL_INTERN',
  /** Intl Staff */
  IntlStaff = 'INTL_STAFF',
  /** Short Term */
  ShortTerm = 'SHORT_TERM',
  /** Staff Stint */
  StaffStint = 'STAFF_STINT',
  /** US Based Perm */
  UsBasedPerm = 'US_BASED_PERM',
}

export enum AssignmentStatusEnum {
  /** Active - FMLA Leave */
  ActiveFmlaLeave = 'ACTIVE_FMLA_LEAVE',
  /** Active - No Payroll */
  ActiveNoPayroll = 'ACTIVE_NO_PAYROLL',
  /** Active - Paid Leave */
  ActivePaidLeave = 'ACTIVE_PAID_LEAVE',
  /** Active - Payroll Eligible */
  ActivePayrollEligible = 'ACTIVE_PAYROLL_ELIGIBLE',
  /** Active - Unpaid Leave */
  ActiveUnpaidLeave = 'ACTIVE_UNPAID_LEAVE',
  /** Disability - Payroll Eligible */
  DisabilityPayrollEligible = 'DISABILITY_PAYROLL_ELIGIBLE',
  /** Inactive - No Payroll */
  InactiveNoPayroll = 'INACTIVE_NO_PAYROLL',
  /** Inactive - Payroll Eligible */
  InactivePayrollEligible = 'INACTIVE_PAYROLL_ELIGIBLE',
  /** Inactive - Process when Earnings */
  InactiveProcessWhenEarnings = 'INACTIVE_PROCESS_WHEN_EARNINGS',
  /** Pending - No Payroll */
  PendingNoPayroll = 'PENDING_NO_PAYROLL',
  /** Raising Initial Support - No Payroll */
  RaisingInitialSupportNoPayroll = 'RAISING_INITIAL_SUPPORT_NO_PAYROLL',
  /** Raising Initial Support - Payroll Eligible */
  RaisingInitialSupportPayrollEligible = 'RAISING_INITIAL_SUPPORT_PAYROLL_ELIGIBLE',
}

export type BenefitsPlan = {
  __typename?: 'BenefitsPlan';
  /** Healthcare plan, or null when nobody is covering the user */
  plan?: Maybe<MpdGoalBenefitsConstantPlanEnum>;
  /** Healthcare plan family size, or null when there is no plan to price */
  size?: Maybe<MpdGoalBenefitsConstantSizeEnum>;
};

export type BreakdownByMonth = {
  __typename?: 'BreakdownByMonth';
  month: Scalars['ISO8601Date']['output'];
  total: Scalars['Float']['output'];
};

export type BreakdownByMonthWithTransactions = {
  __typename?: 'BreakdownByMonthWithTransactions';
  month: Scalars['ISO8601Date']['output'];
  total: Scalars['Float']['output'];
  transactions?: Maybe<Array<AccountSummaryTransaction>>;
};

export type BudgetFamily = {
  __typename?: 'BudgetFamily';
  category: BudgetFamilyCategoryEnum;
  createdAt: Scalars['ISO8601DateTime']['output'];
  directInput?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  primaryBudgetCategories: Array<PrimaryBudgetCategory>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export enum BudgetFamilyCategoryEnum {
  Household = 'HOUSEHOLD',
  Ministry = 'MINISTRY',
  Special = 'SPECIAL',
}

export type BudgetFamilyUpdateInput = {
  /** direct input attribute, clear with null */
  directInput?: InputMaybe<Scalars['Float']['input']>;
  /** ID of the budget family */
  id: Scalars['ID']['input'];
};

/** Autogenerated input type of BudgetFamilyUpdateMutation */
export type BudgetFamilyUpdateMutationInput = {
  /** AccountList ID that the budget family is associated with */
  accountListId: Scalars['ID']['input'];
  /** attributes to update */
  attributes?: InputMaybe<BudgetFamilyUpdateInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of BudgetFamilyUpdateMutation. */
export type BudgetFamilyUpdateMutationPayload = {
  __typename?: 'BudgetFamilyUpdateMutationPayload';
  budgetFamily: BudgetFamily;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type CanUserExportData = {
  __typename?: 'CanUserExportData';
  allowed: Scalars['Boolean']['output'];
  exportedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Autogenerated input type of CancelAccountListInvite */
export type CancelAccountListInviteInput = {
  /** if not an admin or Organization::Admin must pass in current account_list_id */
  accountListId?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of CancelAccountListInvite. */
export type CancelAccountListInvitePayload = {
  __typename?: 'CancelAccountListInvitePayload';
  accountListInvite: AccountListInvite;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type Category = {
  __typename?: 'Category';
  code?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  entryType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['ID']['output'];
  remoteId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** The connection type for Category. */
export type CategoryConnection = {
  __typename?: 'CategoryConnection';
  /** A list of edges. */
  edges: Array<CategoryEdge>;
  /** A list of nodes. */
  nodes: Array<Category>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total # of objects returned from this Plural Query */
  totalCount: Scalars['Int']['output'];
  /** Total # of pages, based on total count and pagesize */
  totalPageCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CategoryEdge = {
  __typename?: 'CategoryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Category>;
};

export type CheckboxFilter = Filter & {
  __typename?: 'CheckboxFilter';
  filterKey: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type CoachingAccountList = {
  __typename?: 'CoachingAccountList';
  activeMpdFinishAt?: Maybe<Scalars['ISO8601Date']['output']>;
  activeMpdMonthlyGoal?: Maybe<Scalars['Float']['output']>;
  activeMpdStartAt?: Maybe<Scalars['ISO8601Date']['output']>;
  balance: Scalars['Float']['output'];
  coaches: UserScopedToAccountListConnection;
  contactTagList: Array<Scalars['String']['output']>;
  contacts: CoachingContactConnection;
  createdAt: Scalars['ISO8601DateTime']['output'];
  currency: Scalars['String']['output'];
  designationAccounts: Array<DesignationAccount>;
  id: Scalars['ID']['output'];
  monthlyGoal?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  primaryAppeal?: Maybe<CoachingAppeal>;
  receivedPledges: Scalars['Float']['output'];
  taskTagList: Array<Scalars['String']['output']>;
  totalPledges: Scalars['Float']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  users: UserScopedToAccountListConnection;
  weeksOnMpd: Scalars['Int']['output'];
};

export type CoachingAccountListCoachesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CoachingAccountListContactsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ContactFilterSetInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CoachingAccountListUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for CoachingAccountList. */
export type CoachingAccountListConnection = {
  __typename?: 'CoachingAccountListConnection';
  /** A list of edges. */
  edges: Array<CoachingAccountListEdge>;
  /** A list of nodes. */
  nodes: Array<CoachingAccountList>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total # of objects returned from this Plural Query */
  totalCount: Scalars['Int']['output'];
  /** Total # of pages, based on total count and pagesize */
  totalPageCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CoachingAccountListEdge = {
  __typename?: 'CoachingAccountListEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<CoachingAccountList>;
};

export type CoachingAnswer = {
  __typename?: 'CoachingAnswer';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  question: CoachingQuestion;
  response?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type CoachingAnswerSet = {
  __typename?: 'CoachingAnswerSet';
  answers: Array<CoachingAnswer>;
  completedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  questions: Array<CoachingQuestion>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type CoachingAppeal = {
  __typename?: 'CoachingAppeal';
  active: Scalars['Boolean']['output'];
  amount?: Maybe<Scalars['Float']['output']>;
  amountCurrency: Scalars['String']['output'];
  contactIds?: Maybe<Array<Scalars['String']['output']>>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  currencies?: Maybe<Array<Scalars['String']['output']>>;
  description: Scalars['String']['output'];
  endDate?: Maybe<Scalars['ISO8601Date']['output']>;
  excludedAppealContacts?: Maybe<Array<ExcludedAppealContact>>;
  excludedContacts?: Maybe<Array<Contact>>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  pledges: CoachingPledgeConnection;
  pledgesAmountNotReceivedNotProcessed: Scalars['Float']['output'];
  pledgesAmountProcessed: Scalars['Float']['output'];
  pledgesAmountReceivedNotProcessed: Scalars['Float']['output'];
  pledgesAmountTotal: Scalars['Float']['output'];
  primary: Scalars['Boolean']['output'];
  totalCurrency?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type CoachingAppealPledgesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CoachingContact = {
  __typename?: 'CoachingContact';
  contactPhase?: Maybe<PhaseEnum>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  lateAt?: Maybe<Scalars['ISO8601Date']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  pledgeAmount?: Maybe<Scalars['Float']['output']>;
  pledgeCurrency?: Maybe<Scalars['String']['output']>;
  /** Attempted conversion of pledgeCurrency to symbol with fallback to pledgeCurrency value */
  pledgeCurrencySymbol?: Maybe<Scalars['String']['output']>;
  pledgeFrequency?: Maybe<PledgeFrequencyEnum>;
  pledgeReceived: Scalars['Boolean']['output'];
  pledgeStartDate?: Maybe<Scalars['ISO8601Date']['output']>;
  pledges: Array<Pledge>;
  status?: Maybe<StatusEnum>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** The connection type for CoachingContact. */
export type CoachingContactConnection = {
  __typename?: 'CoachingContactConnection';
  /** A list of edges. */
  edges: Array<CoachingContactEdge>;
  /** A list of nodes. */
  nodes: Array<CoachingContact>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total # of objects returned from this Plural Query */
  totalCount: Scalars['Int']['output'];
  /** Total # of pages, based on total count and pagesize */
  totalPageCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CoachingContactEdge = {
  __typename?: 'CoachingContactEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<CoachingContact>;
};

export type CoachingPledge = {
  __typename?: 'CoachingPledge';
  amount: Scalars['Float']['output'];
  amountCurrency?: Maybe<Scalars['String']['output']>;
  appeal: CoachingAppeal;
  contact: CoachingContact;
  createdAt: Scalars['ISO8601DateTime']['output'];
  expectedDate: Scalars['ISO8601Date']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** The connection type for CoachingPledge. */
export type CoachingPledgeConnection = {
  __typename?: 'CoachingPledgeConnection';
  /** A list of edges. */
  edges: Array<CoachingPledgeEdge>;
  /** A list of nodes. */
  nodes: Array<CoachingPledge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total # of objects returned from this Plural Query */
  totalCount: Scalars['Int']['output'];
  /** Total # of pages, based on total count and pagesize */
  totalPageCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CoachingPledgeEdge = {
  __typename?: 'CoachingPledgeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<CoachingPledge>;
};

export type CoachingQuestion = {
  __typename?: 'CoachingQuestion';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  position: Scalars['Int']['output'];
  prompt: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
  responseOptions?: Maybe<Array<Scalars['String']['output']>>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type Comment = {
  __typename?: 'Comment';
  body: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  me: Scalars['Boolean']['output'];
  person?: Maybe<UserScopedToAccountList>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** The connection type for Comment. */
export type CommentConnection = {
  __typename?: 'CommentConnection';
  /** A list of edges. */
  edges: Array<CommentEdge>;
  /** A list of nodes. */
  nodes: Array<Comment>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total # of objects returned from this Plural Query */
  totalCount: Scalars['Int']['output'];
  /** Total # of pages, based on total count and pagesize */
  totalPageCount: Scalars['Int']['output'];
};

export type CommentDeleteMutationInput = {
  commentId: Scalars['ID']['input'];
  taskId: Scalars['ID']['input'];
};

export type CommentDeleteMutationPayload = {
  __typename?: 'CommentDeleteMutationPayload';
  id: Scalars['ID']['output'];
};

/** An edge in a connection. */
export type CommentEdge = {
  __typename?: 'CommentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Comment>;
};

export type CommentUpdateMutationInput = {
  body: Scalars['String']['input'];
  commentId: Scalars['ID']['input'];
  taskId: Scalars['ID']['input'];
};

export type CommentUpdateMutationPayload = {
  __typename?: 'CommentUpdateMutationPayload';
  id: Scalars['ID']['output'];
};

/** A completed quarter's payroll breakdown */
export type CompletedQuarterPayroll = {
  __typename?: 'CompletedQuarterPayroll';
  /** The average payroll for the quarter */
  averagePayroll: Scalars['Float']['output'];
  /** The fiscal year */
  fiscalYear: Scalars['Int']['output'];
  /** The fiscal quarter number (1-4) */
  quarter: Scalars['Int']['output'];
  /** The quarter's health status */
  status: MpdHealthStatusEnum;
};

export type Constant = {
  __typename?: 'Constant';
  activities: Array<ActivitiesConstant>;
  csvRequiredHeaders: Array<IdValue>;
  csvSupportedHeaders: Array<IdValue>;
  displayResults: Array<IdValue>;
  importMaxFileSizeInBytes: Scalars['Int']['output'];
  languages: Array<IdValue>;
  likelyToGive: Array<IdValue>;
  likelyToGiveOptions: Array<IdValue>;
  locales: Array<Locale>;
  locations: Array<IdValue>;
  mpdGoalBenefitsConstants: Array<MpdGoalBenefitsConstant>;
  mpdGoalGeographicConstants: Array<MpdGoalGeographicConstant>;
  mpdGoalMiscConstants: Array<MpdGoalMiscConstant>;
  mpdGoalReimbursementConstant?: Maybe<MpdGoalReimbursementConstant>;
  newsletter: Array<IdValue>;
  notificationTranslatedHashes: Array<IdKeyValue>;
  phases: Array<Phase>;
  pledgeCurrencies: Array<Currency>;
  pledgeCurrency: Array<Currency>;
  pledgeFrequencies: Array<IdKeyValue>;
  pledgeFrequency: Array<IdKeyValue>;
  pledgesReceived: Array<IdValue>;
  preferredContactMethods: Array<IdKeyValue>;
  sendAppeals: Array<IdValue>;
  sendNewsletterOptions: Array<IdValue>;
  status: Array<StatusesConstant>;
  statuses: Array<StatusesConstant>;
  times: Array<Time>;
};

export type ConstantMpdGoalBenefitsConstantsArgs = {
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type ConstantMpdGoalGeographicConstantsArgs = {
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type ConstantMpdGoalMiscConstantsArgs = {
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type ConstantMpdGoalReimbursementConstantArgs = {
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type Contact = {
  __typename?: 'Contact';
  addresses: AddressConnection;
  avatar: Scalars['String']['output'];
  churchName?: Maybe<Scalars['String']['output']>;
  contactDonorAccounts: ContactDonorAccountConnection;
  contactPhase?: Maybe<PhaseEnum>;
  /** Contact Referrals referencing the Contacts that were referred by the current Contact (AKA "Referrals") */
  contactReferralsByMe: ReferralConnection;
  /** Contact Referrals referencing the Contacts that referred the current Contact (AKA "Referred By") */
  contactReferralsToMe: ReferralConnection;
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Whether or not there are any people and they are all deceased */
  deceased: Scalars['Boolean']['output'];
  donations: DonationConnection;
  donorAccountIds?: Maybe<Array<Scalars['String']['output']>>;
  envelopeGreeting?: Maybe<Scalars['String']['output']>;
  greeting?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastDonation?: Maybe<Donation>;
  lateAt?: Maybe<Scalars['ISO8601Date']['output']>;
  likelyToGive?: Maybe<LikelyToGiveEnum>;
  locale?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  nextAsk?: Maybe<Scalars['ISO8601Date']['output']>;
  noAppeals?: Maybe<Scalars['Boolean']['output']>;
  /** Whether or not the Contact is eligible for Gift Aid (UK government subsidies) */
  noGiftAid?: Maybe<Scalars['Boolean']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  notesSavedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  people: PersonConnection;
  pledgeAmount?: Maybe<Scalars['Float']['output']>;
  pledgeCurrency?: Maybe<Scalars['String']['output']>;
  /** Attempted conversion of pledgeCurrency to symbol with fallback to pledgeCurrency value */
  pledgeCurrencySymbol?: Maybe<Scalars['String']['output']>;
  pledgeFrequency?: Maybe<PledgeFrequencyEnum>;
  pledgeReceived: Scalars['Boolean']['output'];
  pledgeStartDate?: Maybe<Scalars['ISO8601Date']['output']>;
  pledges: Array<Pledge>;
  preferredContactMethod?: Maybe<PreferredContactMethodEnum>;
  primaryAddress?: Maybe<Address>;
  /** Sets the address matching this id to primary_mailing_address true */
  primaryAddressId?: Maybe<Scalars['String']['output']>;
  primaryPerson?: Maybe<Person>;
  /** The remote system relationship code to match with */
  relationshipCode?: Maybe<Scalars['String']['output']>;
  sendNewsletter?: Maybe<SendNewsletterEnum>;
  source?: Maybe<ContactSourceEnum>;
  /** Indicates if a user has starred the contact */
  starred: Scalars['Boolean']['output'];
  /** Indicates when the contact was starred */
  starredAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  status?: Maybe<StatusEnum>;
  statusValid?: Maybe<Scalars['Boolean']['output']>;
  /** json string of suggested changes to contact */
  suggestedChanges?: Maybe<Scalars['String']['output']>;
  tagList: Array<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  totalDonations?: Maybe<Scalars['Float']['output']>;
  /** The cached number of uncompleted tasks for this Contact */
  uncompletedTasksCount: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  user?: Maybe<UserScopedToAccountList>;
  website?: Maybe<Scalars['String']['output']>;
};

export type ContactAddressesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ContactContactDonorAccountsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ContactContactReferralsByMeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ContactContactReferralsToMeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ContactDonationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ContactPeopleArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ContactAddresses = {
  __typename?: 'ContactAddresses';
  city?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  primaryMailingAddress?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of ContactAnonymizeMutation */
export type ContactAnonymizeMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contactId: Scalars['ID']['input'];
};

/** Autogenerated return type of ContactAnonymizeMutation. */
export type ContactAnonymizeMutationPayload = {
  __typename?: 'ContactAnonymizeMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  contact: Contact;
};

/** The connection type for Contact. */
export type ContactConnection = {
  __typename?: 'ContactConnection';
  /** A list of edges. */
  edges: Array<ContactEdge>;
  /** A list of nodes. */
  nodes: Array<Contact>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total # of objects returned from this Plural Query */
  totalCount: Scalars['Int']['output'];
  /** Total # of pages, based on total count and pagesize */
  totalPageCount: Scalars['Int']['output'];
};

export type ContactCreateInput = {
  churchName?: InputMaybe<Scalars['String']['input']>;
  contactReferralsByMe?: InputMaybe<Array<ContactReferralByMeInput>>;
  contactReferralsToMe?: InputMaybe<Array<ContactReferralToMeInput>>;
  envelopeGreeting?: InputMaybe<Scalars['String']['input']>;
  greeting?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  likelyToGive?: InputMaybe<LikelyToGiveEnum>;
  locale?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  nextAsk?: InputMaybe<Scalars['ISO8601Date']['input']>;
  noAppeals?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  pledgeAmount?: InputMaybe<Scalars['Float']['input']>;
  pledgeCurrency?: InputMaybe<Scalars['String']['input']>;
  pledgeFrequency?: InputMaybe<PledgeFrequencyEnum>;
  pledgeReceived?: InputMaybe<Scalars['Boolean']['input']>;
  pledgeStartDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  preferredContactMethod?: InputMaybe<PreferredContactMethodEnum>;
  sendNewsletter?: InputMaybe<SendNewsletterEnum>;
  starred?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<StatusEnum>;
  tagList?: InputMaybe<Array<Scalars['String']['input']>>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of ContactCreateMutation */
export type ContactCreateMutationInput = {
  /** AccountList ID that the contact is associated with */
  accountListId: Scalars['ID']['input'];
  /** attributes to create */
  attributes: ContactCreateInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of ContactCreateMutation. */
export type ContactCreateMutationPayload = {
  __typename?: 'ContactCreateMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  contact: Contact;
};

/** Autogenerated input type of ContactDeleteMutation */
export type ContactDeleteMutationInput = {
  /** AccountList ID that the contact is associated with */
  accountListId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of contact to delete */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of ContactDeleteMutation. */
export type ContactDeleteMutationPayload = {
  __typename?: 'ContactDeleteMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type ContactDestroyDonorAccountInput = {
  contactId: Scalars['ID']['input'];
  donorAccountId: Scalars['ID']['input'];
};

export type ContactDestroyDonorAccountPayload = {
  __typename?: 'ContactDestroyDonorAccountPayload';
  id: Scalars['ID']['output'];
};

export type ContactDonorAccount = {
  __typename?: 'ContactDonorAccount';
  createdAt: Scalars['ISO8601DateTime']['output'];
  donorAccount: DonorAccount;
  id: Scalars['ID']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** The connection type for ContactDonorAccount. */
export type ContactDonorAccountConnection = {
  __typename?: 'ContactDonorAccountConnection';
  /** A list of edges. */
  edges: Array<ContactDonorAccountEdge>;
  /** A list of nodes. */
  nodes: Array<ContactDonorAccount>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total # of objects returned from this Plural Query */
  totalCount: Scalars['Int']['output'];
  /** Total # of pages, based on total count and pagesize */
  totalPageCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ContactDonorAccountEdge = {
  __typename?: 'ContactDonorAccountEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ContactDonorAccount>;
};

export type ContactDonorAccountInput = {
  accountNumber: Scalars['String']['input'];
  name: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};

export type ContactDonorAccountType = {
  accountNumber: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  organization?: InputMaybe<ContactDonorOrganizationType>;
  type: Scalars['String']['input'];
};

export type ContactDonorOrganizationType = {
  id: Scalars['ID']['input'];
  type: Scalars['String']['input'];
};

export type ContactDuplicate = {
  __typename?: 'ContactDuplicate';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  ignore: Scalars['Boolean']['output'];
  reason: ReasonEnum;
  recordOne: Contact;
  recordTwo: Contact;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** The connection type for ContactDuplicate. */
export type ContactDuplicateConnection = {
  __typename?: 'ContactDuplicateConnection';
  /** A list of edges. */
  edges: Array<ContactDuplicateEdge>;
  /** A list of nodes. */
  nodes: Array<ContactDuplicate>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total # of objects returned from this Plural Query */
  totalCount: Scalars['Int']['output'];
  /** Total # of pages, based on total count and pagesize */
  totalPageCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ContactDuplicateEdge = {
  __typename?: 'ContactDuplicateEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ContactDuplicate>;
};

/** An edge in a connection. */
export type ContactEdge = {
  __typename?: 'ContactEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Contact>;
};

export enum ContactFilterActivityTypeEnum {
  Any = 'ANY',
  AppointmentInPerson = 'APPOINTMENT_IN_PERSON',
  AppointmentPhoneCall = 'APPOINTMENT_PHONE_CALL',
  AppointmentVideoCall = 'APPOINTMENT_VIDEO_CALL',
  FollowUpEmail = 'FOLLOW_UP_EMAIL',
  FollowUpInPerson = 'FOLLOW_UP_IN_PERSON',
  FollowUpLetterCard = 'FOLLOW_UP_LETTER_CARD',
  FollowUpPhoneCall = 'FOLLOW_UP_PHONE_CALL',
  FollowUpSocialMedia = 'FOLLOW_UP_SOCIAL_MEDIA',
  FollowUpTextMessage = 'FOLLOW_UP_TEXT_MESSAGE',
  FollowUpToDo = 'FOLLOW_UP_TO_DO',
  InitiationEmail = 'INITIATION_EMAIL',
  InitiationInPerson = 'INITIATION_IN_PERSON',
  InitiationLetter = 'INITIATION_LETTER',
  InitiationPhoneCall = 'INITIATION_PHONE_CALL',
  InitiationSocialMedia = 'INITIATION_SOCIAL_MEDIA',
  InitiationSpecialGiftAppeal = 'INITIATION_SPECIAL_GIFT_APPEAL',
  InitiationTextMessage = 'INITIATION_TEXT_MESSAGE',
  InitiationToDo = 'INITIATION_TO_DO',
  /** special type when filtered by will return any task with no activityType */
  None = 'NONE',
  PartnerCareDigitalNewsletter = 'PARTNER_CARE_DIGITAL_NEWSLETTER',
  PartnerCareEmail = 'PARTNER_CARE_EMAIL',
  PartnerCareInPerson = 'PARTNER_CARE_IN_PERSON',
  PartnerCareLetterCard = 'PARTNER_CARE_LETTER_CARD',
  PartnerCarePhoneCall = 'PARTNER_CARE_PHONE_CALL',
  PartnerCarePhysicalNewsletter = 'PARTNER_CARE_PHYSICAL_NEWSLETTER',
  PartnerCarePrayerRequest = 'PARTNER_CARE_PRAYER_REQUEST',
  PartnerCareSocialMedia = 'PARTNER_CARE_SOCIAL_MEDIA',
  PartnerCareTextMessage = 'PARTNER_CARE_TEXT_MESSAGE',
  PartnerCareThank = 'PARTNER_CARE_THANK',
  PartnerCareToDo = 'PARTNER_CARE_TO_DO',
  PartnerCareUpdateInformation = 'PARTNER_CARE_UPDATE_INFORMATION',
}

export enum ContactFilterNewsletterEnum {
  All = 'ALL',
  Both = 'BOTH',
  Email = 'EMAIL',
  EmailOnly = 'EMAIL_ONLY',
  None = 'NONE',
  NoValue = 'NO_VALUE',
  Physical = 'PHYSICAL',
  PhysicalOnly = 'PHYSICAL_ONLY',
}

export type ContactFilterNotesInput = {
  wildcardNoteSearch?: InputMaybe<Scalars['String']['input']>;
};

export enum ContactFilterPledgeReceivedEnum {
  Any = 'ANY',
  NotReceived = 'NOT_RECEIVED',
  Received = 'RECEIVED',
}

export type ContactFilterSetInput = {
  /** Filter by Address No Longer Valid; Accepts values 'true', or 'false' */
  addressHistoric?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter contacts with addresses located within the lat lng bounds. Hash should contain a ne and sw lat lng pair. */
  addressLatLng?: InputMaybe<Scalars['String']['input']>;
  /** Filter by Primary Address; Accepts values 'true', or 'false' */
  addressPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter where address value is false; accepts "false" */
  addressValid?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by alma mater; Accepts multiple parameters, with value 'none', or an alma mater name */
  almaMater?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter where contact people have anniversary on date between provided date range */
  anniversary?: InputMaybe<DateRangeInput>;
  /** When filtering by tags this specifies if the filter should match tasks with any of the filtered tags if "true" or only tasks with all of the filtered tags if "false" */
  anyTags?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by Appeal; Accepts multiple parameters, with value 'no_appeals', or an appeal ID */
  appeal?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by Pledge Status. One of excluded, asked, not_received, received_not_processed, or processed. Must be used with appeal filter. */
  appealStatus?: InputMaybe<Scalars['String']['input']>;
  /** Filter where contact people have birthday on date between provided date range */
  birthday?: InputMaybe<DateRangeInput>;
  /** Filter by Church; Accepts multiple parameters, with value 'none', or a church name */
  church?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by City; Accepts multiple parameters, with value 'none', or a city name */
  city?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by where contact has address; Accepts values 'Yes', or 'No' */
  contactInfoAddr?: InputMaybe<Scalars['String']['input']>;
  /** Filter where contact people has an email; Accepts values 'Yes', or 'No' */
  contactInfoEmail?: InputMaybe<Scalars['String']['input']>;
  /** Filter where contact people has a Facebook Profile; Accepts values 'Yes', or 'No' */
  contactInfoFacebook?: InputMaybe<Scalars['String']['input']>;
  /** Filter where contact people has a mobile phone; Accepts values 'Yes', or 'No' */
  contactInfoMobile?: InputMaybe<Scalars['String']['input']>;
  /** Filter where contact people has a phone; Accepts values 'Yes', or 'No' */
  contactInfoPhone?: InputMaybe<Scalars['String']['input']>;
  /** Filter where contact people has a work phone; Accepts values 'Yes', or 'No' */
  contactInfoWorkPhone?: InputMaybe<Scalars['String']['input']>;
  /** Filter by Type; Accepts multiple parameters, with values 'person', and 'company' */
  contactType?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by Country; Accepts multiple parameters, with values 'none', or a country */
  country?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by Created At date between a provided date range */
  createdAt?: InputMaybe<DateRangeInput>;
  /** Filter by Designation Account; accepts multiple parameters, separated by comma */
  designationAccountId?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter by Gift Options; Accepts multiple parameters, with values 'none', 'one', 'first', and 'last' */
  donation?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by Exact Gift Amount; Accepts multiple parameters, with values like '9.99' */
  donationAmount?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by Gift Amount Range; Accepts object with max and min keys with decimal values { "max": "9.99", "min": "0.99" } */
  donationAmountRange?: InputMaybe<NumericRangeInput>;
  /** Filter by Gift Date; Accepts date range with text value like 'MM/DD/YYYY - MM/DD/YYYY' */
  donationDate?: InputMaybe<DateRangeInput>;
  /** Filter contacts that have any of the tags included in this filter; comma separated value for multiple */
  excludeTags?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter where contact gave more than they pledged within the provided date range */
  gaveMoreThanPledgedRange?: InputMaybe<DateRangeInput>;
  /** Filter contacts with ids included in this filter; comma separated value for multiple */
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter contacts by the date at which the contact started being late on payments */
  lateAt?: InputMaybe<DateRangeInput>;
  /** Filter by Likely To Give; Accepts multiple parameters, with values 'none', 'Least Likely', 'Likely', and 'Most Likely' */
  likely?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by Language; Accepts multiple parameters, */
  locale?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by Metro Area; Accepts multiple parameters, with values 'none', or a metro area name */
  metroArea?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter where contact name starts with the provided value */
  nameLike?: InputMaybe<Scalars['String']['input']>;
  /** Filter by Newsletter Recipients; Accepts values 'none', 'all', 'address', 'email', and 'both' */
  newsletter?: InputMaybe<ContactFilterNewsletterEnum>;
  /** Filter by Next Ask date within the provided date range */
  nextAsk?: InputMaybe<DateRangeInput>;
  /** Filter where contact has asked specifically not to receive appeals; accepts "true" */
  noAppeals?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter contacts with note contents; accepts hash with wildcard_note_search parameter { "wildcard_note_search": "value to search by" } */
  notes?: InputMaybe<ContactFilterNotesInput>;
  /** Filter where at least one contact person has opted out from email; Accepts values 'Yes', or 'No' */
  optOut?: InputMaybe<Scalars['String']['input']>;
  /** filter where contact's account list has a designation account belonging to an organization; Accepts IDs separated by comma */
  organizationId?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter contacts by pledge status. completed, outstanding, pending */
  pledge?: InputMaybe<Scalars['String']['input']>;
  /** Filter by Pledge Amount; Accepts multiple parameters, with values like '100.0' */
  pledgeAmount?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter where Pledge Amount increased in the provided date range */
  pledgeAmountIncreasedRange?: InputMaybe<DateRangeInput>;
  /** Filter by Pledge Currency; Accepts multiple parameters, with values like 'USD' */
  pledgeCurrency?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by Pledge Frequency; Accepts multiple parameters, with numeric values like '0.23076923076923' (Weekly), '0.46153846153846' (Every 2 Weeks), '1.0' (Monthly), '2.0' (Every 2 Months), '3.0', '4.0', '6.0', '12.0' (Yearly), and '24.0' (Every 2 Years) */
  pledgeFrequency?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by Late By; Accepts values '', '0_30' (Less than 30 days late), '30_60' (More than 30 days late), '60_90' (More than 60 days late), or '90' (More than 90 days late) */
  pledgeLateBy?: InputMaybe<Scalars['String']['input']>;
  /** Filter by Pledge Received; Accepts values 'true', or 'false' */
  pledgeReceived?: InputMaybe<ContactFilterPledgeReceivedEnum>;
  /** Filter contacts with addresses in particular state; accepts values 'primary', 'active', 'inactive', or 'null' */
  primaryAddress?: InputMaybe<Scalars['String']['input']>;
  /** Filter by Referrer; Accepts multiple parameters, with values 'none', 'any', or a Contact ID */
  referrer?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by Referrer ID; Accepts Comma separated list of Contact IDs */
  referrerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter by Region; Accepts multiple parameters, with values 'none', or a region name */
  region?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by Action; Accepts multiple parameters, with values 'none', or an activity type like 'Call' */
  relatedTaskAction?: InputMaybe<Array<ContactFilterActivityTypeEnum>>;
  reverseAlmaMater?: InputMaybe<Scalars['Boolean']['input']>;
  reverseAppeal?: InputMaybe<Scalars['Boolean']['input']>;
  reverseChurch?: InputMaybe<Scalars['Boolean']['input']>;
  reverseCity?: InputMaybe<Scalars['Boolean']['input']>;
  reverseContactType?: InputMaybe<Scalars['Boolean']['input']>;
  reverseCountry?: InputMaybe<Scalars['Boolean']['input']>;
  reverseDesignationAccountId?: InputMaybe<Scalars['Boolean']['input']>;
  reverseDonation?: InputMaybe<Scalars['Boolean']['input']>;
  reverseDonationAmount?: InputMaybe<Scalars['Boolean']['input']>;
  reverseIds?: InputMaybe<Scalars['Boolean']['input']>;
  reverseLikely?: InputMaybe<Scalars['Boolean']['input']>;
  reverseLocale?: InputMaybe<Scalars['Boolean']['input']>;
  reverseMetroArea?: InputMaybe<Scalars['Boolean']['input']>;
  reversePledgeAmount?: InputMaybe<Scalars['Boolean']['input']>;
  reversePledgeCurrency?: InputMaybe<Scalars['Boolean']['input']>;
  reversePledgeFrequency?: InputMaybe<Scalars['Boolean']['input']>;
  reverseReferrer?: InputMaybe<Scalars['Boolean']['input']>;
  reverseRegion?: InputMaybe<Scalars['Boolean']['input']>;
  reverseRelatedTaskAction?: InputMaybe<Scalars['Boolean']['input']>;
  reverseSource?: InputMaybe<Scalars['Boolean']['input']>;
  reverseState?: InputMaybe<Scalars['Boolean']['input']>;
  reverseStatus?: InputMaybe<Scalars['Boolean']['input']>;
  reverseTags?: InputMaybe<Scalars['Boolean']['input']>;
  reverseTimezone?: InputMaybe<Scalars['Boolean']['input']>;
  reverseUserIds?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by Source; Accepts multiple parameters */
  source?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by starred, is either selected or unselected */
  starred?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter where contact started giving in the provided date range */
  startedGivingRange?: InputMaybe<DateRangeInput>;
  /** Filter by State; Accepts multiple parameters, with values 'none', or a state */
  state?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by Status; Accepts multiple parameters, with values 'active', 'hidden', 'null', 'Never Contacted', 'Ask in Future', 'Cultivate Relationship', 'Contact for Appointment', 'Appointment Scheduled', 'Call for Decision', 'Partner - Financial', 'Partner - Special', 'Partner - Pray', 'Not Interested', 'Unresponsive', 'Never Ask', 'Research Abandoned', and 'Expired Referral' */
  status?: InputMaybe<Array<ContactFilterStatusEnum>>;
  /** Filter by Status Valid; Accepts values 'true', or 'false' */
  statusValid?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter where contact stopped giving in the provided date range */
  stoppedGivingRange?: InputMaybe<DateRangeInput>;
  /** Filter by Tags; Accepts multiple parameters, with text values separated by comma */
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by Due Date; Accepts date range with text value like 'MM/DD/YYYY - MM/DD/YYYY' */
  taskDueDate?: InputMaybe<DateRangeInput>;
  /** Filter where contact's tasks have completed set to true; accepts "true" */
  tasksAllCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by Timezone; Accepts multiple parameters */
  timezone?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter contacts that were updated in this date range */
  updatedAt?: InputMaybe<DateTimeRangeInput>;
  /** Filter contacts with user_ids included in this filter; comma separated value for multiple */
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter contacts where subject contains this filter */
  wildcardSearch?: InputMaybe<Scalars['String']['input']>;
};

export enum ContactFilterStatusEnum {
  Active = 'ACTIVE',
  AppointmentScheduled = 'APPOINTMENT_SCHEDULED',
  AskInFuture = 'ASK_IN_FUTURE',
  CallForDecision = 'CALL_FOR_DECISION',
  ContactForAppointment = 'CONTACT_FOR_APPOINTMENT',
  CultivateRelationship = 'CULTIVATE_RELATIONSHIP',
  ExpiredReferral = 'EXPIRED_REFERRAL',
  Hidden = 'HIDDEN',
  NeverAsk = 'NEVER_ASK',
  NeverContacted = 'NEVER_CONTACTED',
  NotInterested = 'NOT_INTERESTED',
  Null = 'NULL',
  PartnerFinancial = 'PARTNER_FINANCIAL',
  PartnerPray = 'PARTNER_PRAY',
  PartnerSpecial = 'PARTNER_SPECIAL',
  ResearchAbandoned = 'RESEARCH_ABANDONED',
  ResearchContactInfo = 'RESEARCH_CONTACT_INFO',
  Unresponsive = 'UNRESPONSIVE',
}

export type ContactGroup = {
  __typename?: 'ContactGroup';
  createdAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  tag?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedInDbAt?: Maybe<Scalars['String']['output']>;
};

export type ContactPeople = {
  __typename?: 'ContactPeople';
  deceased?: Maybe<Scalars['Boolean']['output']>;
  emailAddresses?: Maybe<Array<Maybe<ContactPeopleEmailAddresses>>>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phoneNumbers?: Maybe<Array<Maybe<ContactPeoplePhoneNumbers>>>;
};

export type ContactPeopleAccountLists = {
  __typename?: 'ContactPeopleAccountLists';
  accountListUsers?: Maybe<Array<Maybe<ContactPeopleAccountListsUsers>>>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ContactPeopleAccountListsUsers = {
  __typename?: 'ContactPeopleAccountListsUsers';
  id?: Maybe<Scalars['ID']['output']>;
  phoneNumbers?: Maybe<Array<Maybe<ContactPeoplePhoneNumbers>>>;
  userEmailAddresses?: Maybe<Array<Maybe<ContactPeopleEmailAddresses>>>;
  userFirstName?: Maybe<Scalars['String']['output']>;
  userLastName?: Maybe<Scalars['String']['output']>;
};

export type ContactPeopleEmailAddresses = {
  __typename?: 'ContactPeopleEmailAddresses';
  email?: Maybe<Scalars['String']['output']>;
  historic?: Maybe<Scalars['Boolean']['output']>;
  primary?: Maybe<Scalars['Boolean']['output']>;
};

export type ContactPeoplePhoneNumbers = {
  __typename?: 'ContactPeoplePhoneNumbers';
  historic?: Maybe<Scalars['Boolean']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  primary?: Maybe<Scalars['Boolean']['output']>;
};

export type ContactPrimaryAddress = {
  __typename?: 'ContactPrimaryAddress';
  addresses: Array<AddressWithPrimary>;
};

export type ContactPrimaryAddressInput = {
  contactId: Scalars['ID']['input'];
  primaryAddressId?: InputMaybe<Scalars['ID']['input']>;
};

export type ContactReferralByMeInput = {
  destroy?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  referredToId?: InputMaybe<Scalars['ID']['input']>;
};

export type ContactReferralToMeInput = {
  destroy?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  referredById?: InputMaybe<Scalars['ID']['input']>;
};

export enum ContactSortEnum {
  /** sorts by contacts with active status and name */
  ActiveStatusAndName = 'ACTIVE_STATUS_AND_NAME',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
}

export enum ContactSourceEnum {
  GiveSite = 'GIVE_SITE',
  Mpdx = 'MPDX',
}

export type ContactUpdateInput = {
  churchName?: InputMaybe<Scalars['String']['input']>;
  contactReferralsByMe?: InputMaybe<Array<ContactReferralByMeInput>>;
  contactReferralsToMe?: InputMaybe<Array<ContactReferralToMeInput>>;
  donorAccount?: InputMaybe<ContactDonorAccountInput>;
  donorAccountIds?: InputMaybe<Array<Scalars['String']['input']>>;
  envelopeGreeting?: InputMaybe<Scalars['String']['input']>;
  greeting?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  likelyToGive?: InputMaybe<LikelyToGiveEnum>;
  locale?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nextAsk?: InputMaybe<Scalars['ISO8601Date']['input']>;
  noAppeals?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  pledgeAmount?: InputMaybe<Scalars['Float']['input']>;
  pledgeCurrency?: InputMaybe<Scalars['String']['input']>;
  pledgeFrequency?: InputMaybe<PledgeFrequencyEnum>;
  pledgeReceived?: InputMaybe<Scalars['Boolean']['input']>;
  pledgeStartDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  preferredContactMethod?: InputMaybe<PreferredContactMethodEnum>;
  primaryAddressId?: InputMaybe<Scalars['String']['input']>;
  primaryPersonId?: InputMaybe<Scalars['ID']['input']>;
  relationshipCode?: InputMaybe<Scalars['String']['input']>;
  sendNewsletter?: InputMaybe<SendNewsletterEnum>;
  starred?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<StatusEnum>;
  statusValid?: InputMaybe<Scalars['Boolean']['input']>;
  tagList?: InputMaybe<Array<Scalars['String']['input']>>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of ContactUpdateMutation */
export type ContactUpdateMutationInput = {
  /** AccountList ID that the contact is associated with */
  accountListId: Scalars['ID']['input'];
  /** attributes to update */
  attributes: ContactUpdateInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of ContactUpdateMutation. */
export type ContactUpdateMutationPayload = {
  __typename?: 'ContactUpdateMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  contact: Contact;
};

export type ContactsAccountListAnalytics = {
  __typename?: 'ContactsAccountListAnalytics';
  active: Scalars['Int']['output'];
  referrals: Scalars['Int']['output'];
  referralsOnHand: Scalars['Int']['output'];
};

export type ContactsByStatus = {
  __typename?: 'ContactsByStatus';
  appointmentScheduled: Scalars['Int']['output'];
  callForDecision: Scalars['Int']['output'];
  connectionsRemaining: Scalars['Int']['output'];
  contactForAppointment: Scalars['Int']['output'];
  cultivate: Scalars['Int']['output'];
  financial: Scalars['Int']['output'];
  future: Scalars['Int']['output'];
  initiations: Scalars['Int']['output'];
  neverContacted: Scalars['Int']['output'];
  prayer: Scalars['Int']['output'];
  special: Scalars['Int']['output'];
};

/** Autogenerated input type of ContactsUpdateMutation */
export type ContactsUpdateMutationInput = {
  /** AccountList ID that the contacts are associated with */
  accountListId: Scalars['ID']['input'];
  /** attributes to update */
  attributes: Array<ContactUpdateInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of ContactsUpdateMutation. */
export type ContactsUpdateMutationPayload = {
  __typename?: 'ContactsUpdateMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  contacts: Array<Contact>;
};

export type CorrespondenceAccountListAnalytics = {
  __typename?: 'CorrespondenceAccountListAnalytics';
  newsletters: Scalars['Int']['output'];
  precall: Scalars['Int']['output'];
  reminders: Scalars['Int']['output'];
  supportLetters: Scalars['Int']['output'];
  thankYous: Scalars['Int']['output'];
};

/** Autogenerated input type of CreateAccountListInvite */
export type CreateAccountListInviteInput = {
  attributes: AccountListInviteCreateInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateAccountListInvite. */
export type CreateAccountListInvitePayload = {
  __typename?: 'CreateAccountListInvitePayload';
  accountListInvite: AccountListInvite;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type CreateGoogleIntegrationInput = {
  accountListId: Scalars['String']['input'];
  googleAccountId: Scalars['ID']['input'];
  googleIntegration?: InputMaybe<GoogleAccountIntegrationInput>;
};

/** Autogenerated input type of CreateOrUpdateOptionMutation */
export type CreateOrUpdateOptionMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** key to update or create */
  key: Scalars['String']['input'];
  /** value to change */
  value: Scalars['String']['input'];
};

/** Autogenerated return type of CreateOrUpdateOptionMutation. */
export type CreateOrUpdateOptionMutationPayload = {
  __typename?: 'CreateOrUpdateOptionMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  option: Option;
};

export type CreateOrganizationInviteInput = {
  organizationId: Scalars['ID']['input'];
  recipientEmail: Scalars['ID']['input'];
};

export type Currency = {
  __typename?: 'Currency';
  code?: Maybe<Scalars['String']['output']>;
  codeSymbolString?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  symbol?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type CurrentSalary = {
  __typename?: 'CurrentSalary';
  grossSalaryAmount?: Maybe<Scalars['Float']['output']>;
  lastRegularPaymentDate?: Maybe<Scalars['ISO8601Date']['output']>;
  lastUpdated?: Maybe<Scalars['ISO8601Date']['output']>;
};

/** Range of dates */
export type DateRangeInput = {
  /** Maximum value of the range */
  max?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Minimum value of the range */
  min?: InputMaybe<Scalars['ISO8601Date']['input']>;
};

export type DateRangeOption = {
  __typename?: 'DateRangeOption';
  name: Scalars['String']['output'];
  rangeEnd: Scalars['ISO8601DateTime']['output'];
  rangeStart: Scalars['ISO8601DateTime']['output'];
};

/** Range of dates */
export type DateTimeRangeInput = {
  /** Maximum value of the range */
  max?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Minimum value of the range */
  min?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};

export type DaterangeFilter = Filter & {
  __typename?: 'DaterangeFilter';
  filterKey: Scalars['String']['output'];
  options?: Maybe<Array<DateRangeOption>>;
  title: Scalars['String']['output'];
};

export type DeleteGoogleAccountInput = {
  accountId: Scalars['ID']['input'];
};

export type DeleteMailchimpAccountInput = {
  accountListId: Scalars['ID']['input'];
};

export type DeleteOrganizationAdminInput = {
  adminId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export type DeleteOrganizationContactInput = {
  contactId: Scalars['ID']['input'];
};

export type DeleteOrganizationInviteInput = {
  inviteId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export type DeletePrayerlettersAccountInput = {
  accountListId: Scalars['ID']['input'];
};

export type DeleteTagsInput = {
  page: Scalars['String']['input'];
  tagName: Scalars['String']['input'];
};

export type DeleteTagsPayload = {
  __typename?: 'DeleteTagsPayload';
  id?: Maybe<Scalars['ID']['output']>;
};

export type DeletionResponse = {
  __typename?: 'DeletionResponse';
  success: Scalars['Boolean']['output'];
};

export type DesignationAccount = {
  __typename?: 'DesignationAccount';
  accountNumber: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  organization: Organization;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type DesignationAccountRest = {
  __typename?: 'DesignationAccountRest';
  active: Scalars['Boolean']['output'];
  balanceUpdatedAt: Scalars['ISO8601Date']['output'];
  convertedBalance: Scalars['Float']['output'];
  currency: Scalars['String']['output'];
  designationNumber?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type DesignationAccountsGroup = {
  __typename?: 'DesignationAccountsGroup';
  designationAccounts: Array<DesignationAccountRest>;
  organizationName: Scalars['String']['output'];
};

export type DesignationSupportCalculation = {
  __typename?: 'DesignationSupportCalculation';
  /** Monthly reimbursable expense */
  accountTransfers?: Maybe<Scalars['Float']['output']>;
  averageHoursPerWeek?: Maybe<Scalars['Float']['output']>;
  benefits?: Maybe<Scalars['Float']['output']>;
  /** Which year-versioned constants set the calculation is checked against */
  calculationsYear: Scalars['Int']['output'];
  /** Annual reimbursable expense */
  conferenceRetreatCosts?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  designationSupportHoursItems: Array<DesignationSupportHoursItem>;
  formType?: Maybe<DesignationSupportFormType>;
  geographicLocation?: Maybe<Scalars['String']['output']>;
  hoursWorkedPerWeek?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  /** Monthly reimbursable expense */
  ministryCellPhone?: Maybe<Scalars['Float']['output']>;
  /** Monthly reimbursable expense */
  ministryInternet?: Maybe<Scalars['Float']['output']>;
  /** Annual reimbursable expense */
  ministryTravelMeals?: Maybe<Scalars['Float']['output']>;
  /** Monthly reimbursable expense */
  mpdMiscellaneous?: Maybe<Scalars['Float']['output']>;
  /** Monthly reimbursable expense */
  mpdNewsletter?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** Annual reimbursable expense */
  otherAnnualReimbursements?: Maybe<Scalars['Float']['output']>;
  /** Monthly reimbursable expense */
  otherMonthlyReimbursements?: Maybe<Scalars['Float']['output']>;
  payRate?: Maybe<Scalars['Float']['output']>;
  reimbursableExpensesForOther?: Maybe<Scalars['Float']['output']>;
  reimbursableExpensesOverride?: Maybe<Scalars['Float']['output']>;
  salaryOrHourly?: Maybe<DesignationSupportSalaryType>;
  status?: Maybe<DesignationSupportStatus>;
  totalMonthlySupportGoal: Scalars['Float']['output'];
  totalReimbursableExpenses: Scalars['Float']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** The connection type for DesignationSupportCalculation. */
export type DesignationSupportCalculationConnection = {
  __typename?: 'DesignationSupportCalculationConnection';
  /** A list of edges. */
  edges: Array<DesignationSupportCalculationEdge>;
  /** A list of nodes. */
  nodes: Array<DesignationSupportCalculation>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total # of objects returned from this Plural Query */
  totalCount: Scalars['Int']['output'];
  /** Total # of pages, based on total count and pagesize */
  totalPageCount: Scalars['Int']['output'];
};

export type DesignationSupportCalculationCreateInput = {
  accountTransfers?: InputMaybe<Scalars['Float']['input']>;
  averageHoursPerWeek?: InputMaybe<Scalars['Float']['input']>;
  benefits?: InputMaybe<Scalars['Float']['input']>;
  conferenceRetreatCosts?: InputMaybe<Scalars['Float']['input']>;
  formType?: InputMaybe<DesignationSupportFormType>;
  geographicLocation?: InputMaybe<Scalars['String']['input']>;
  hoursWorkedPerWeek?: InputMaybe<Scalars['Float']['input']>;
  ministryCellPhone?: InputMaybe<Scalars['Float']['input']>;
  ministryInternet?: InputMaybe<Scalars['Float']['input']>;
  ministryTravelMeals?: InputMaybe<Scalars['Float']['input']>;
  mpdMiscellaneous?: InputMaybe<Scalars['Float']['input']>;
  mpdNewsletter?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  otherAnnualReimbursements?: InputMaybe<Scalars['Float']['input']>;
  otherMonthlyReimbursements?: InputMaybe<Scalars['Float']['input']>;
  payRate?: InputMaybe<Scalars['Float']['input']>;
  reimbursableExpensesForOther?: InputMaybe<Scalars['Float']['input']>;
  reimbursableExpensesOverride?: InputMaybe<Scalars['Float']['input']>;
  salaryOrHourly?: InputMaybe<DesignationSupportSalaryType>;
  status?: InputMaybe<DesignationSupportStatus>;
  totalMonthlySupportGoal?: InputMaybe<Scalars['Float']['input']>;
  totalReimbursableExpenses?: InputMaybe<Scalars['Float']['input']>;
};

/** Autogenerated input type of DesignationSupportCalculationCreateMutation */
export type DesignationSupportCalculationCreateMutationInput = {
  /** Attributes to create */
  attributes?: InputMaybe<DesignationSupportCalculationCreateInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of DesignationSupportCalculationCreateMutation. */
export type DesignationSupportCalculationCreateMutationPayload = {
  __typename?: 'DesignationSupportCalculationCreateMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  designationSupportCalculation: DesignationSupportCalculation;
};

/** Autogenerated input type of DesignationSupportCalculationDeleteMutation */
export type DesignationSupportCalculationDeleteMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the designation support calculation to delete */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DesignationSupportCalculationDeleteMutation. */
export type DesignationSupportCalculationDeleteMutationPayload = {
  __typename?: 'DesignationSupportCalculationDeleteMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

/** An edge in a connection. */
export type DesignationSupportCalculationEdge = {
  __typename?: 'DesignationSupportCalculationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<DesignationSupportCalculation>;
};

export type DesignationSupportCalculationUpdateInput = {
  accountTransfers?: InputMaybe<Scalars['Float']['input']>;
  averageHoursPerWeek?: InputMaybe<Scalars['Float']['input']>;
  benefits?: InputMaybe<Scalars['Float']['input']>;
  conferenceRetreatCosts?: InputMaybe<Scalars['Float']['input']>;
  formType?: InputMaybe<DesignationSupportFormType>;
  geographicLocation?: InputMaybe<Scalars['String']['input']>;
  hoursWorkedPerWeek?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['ID']['input'];
  ministryCellPhone?: InputMaybe<Scalars['Float']['input']>;
  ministryInternet?: InputMaybe<Scalars['Float']['input']>;
  ministryTravelMeals?: InputMaybe<Scalars['Float']['input']>;
  mpdMiscellaneous?: InputMaybe<Scalars['Float']['input']>;
  mpdNewsletter?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  otherAnnualReimbursements?: InputMaybe<Scalars['Float']['input']>;
  otherMonthlyReimbursements?: InputMaybe<Scalars['Float']['input']>;
  payRate?: InputMaybe<Scalars['Float']['input']>;
  reimbursableExpensesForOther?: InputMaybe<Scalars['Float']['input']>;
  reimbursableExpensesOverride?: InputMaybe<Scalars['Float']['input']>;
  salaryOrHourly?: InputMaybe<DesignationSupportSalaryType>;
  status?: InputMaybe<DesignationSupportStatus>;
  totalMonthlySupportGoal?: InputMaybe<Scalars['Float']['input']>;
  totalReimbursableExpenses?: InputMaybe<Scalars['Float']['input']>;
};

/** Autogenerated input type of DesignationSupportCalculationUpdateMutation */
export type DesignationSupportCalculationUpdateMutationInput = {
  /** Attributes to update */
  attributes: DesignationSupportCalculationUpdateInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of DesignationSupportCalculationUpdateMutation. */
export type DesignationSupportCalculationUpdateMutationPayload = {
  __typename?: 'DesignationSupportCalculationUpdateMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  designationSupportCalculation: DesignationSupportCalculation;
};

export enum DesignationSupportFormType {
  Detailed = 'DETAILED',
  Simple = 'SIMPLE',
}

export type DesignationSupportHoursItem = {
  __typename?: 'DesignationSupportHoursItem';
  createdAt: Scalars['ISO8601DateTime']['output'];
  hoursPerWeek?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  numberOfWeeks?: Maybe<Scalars['Int']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  predefined: Scalars['Boolean']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type DesignationSupportHoursItemCreateInput = {
  designationSupportCalculationId: Scalars['ID']['input'];
  hoursPerWeek?: InputMaybe<Scalars['Float']['input']>;
  label: Scalars['String']['input'];
  numberOfWeeks?: InputMaybe<Scalars['Int']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated input type of DesignationSupportHoursItemCreateMutation */
export type DesignationSupportHoursItemCreateMutationInput = {
  /** Attributes to create a Designation Support Hours Item */
  attributes: DesignationSupportHoursItemCreateInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of DesignationSupportHoursItemCreateMutation. */
export type DesignationSupportHoursItemCreateMutationPayload = {
  __typename?: 'DesignationSupportHoursItemCreateMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  designationSupportHoursItem: DesignationSupportHoursItem;
};

/** Autogenerated input type of DesignationSupportHoursItemDeleteMutation */
export type DesignationSupportHoursItemDeleteMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the designation support hours item to delete */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DesignationSupportHoursItemDeleteMutation. */
export type DesignationSupportHoursItemDeleteMutationPayload = {
  __typename?: 'DesignationSupportHoursItemDeleteMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type DesignationSupportHoursItemUpdateInput = {
  designationSupportCalculationId?: InputMaybe<Scalars['ID']['input']>;
  hoursPerWeek?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['ID']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
  numberOfWeeks?: InputMaybe<Scalars['Int']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated input type of DesignationSupportHoursItemUpdateMutation */
export type DesignationSupportHoursItemUpdateMutationInput = {
  /** Attributes to update a Designation Support Hours Item */
  attributes: DesignationSupportHoursItemUpdateInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of DesignationSupportHoursItemUpdateMutation. */
export type DesignationSupportHoursItemUpdateMutationPayload = {
  __typename?: 'DesignationSupportHoursItemUpdateMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  designationSupportHoursItem: DesignationSupportHoursItem;
};

export enum DesignationSupportSalaryType {
  Hourly = 'HOURLY',
  Salaried = 'SALARIED',
}

export enum DesignationSupportStatus {
  FullTime = 'FULL_TIME',
  PartTime = 'PART_TIME',
}

export type DesignationWithDisplayName = {
  __typename?: 'DesignationWithDisplayName';
  displayName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export enum DisplayMethodEnum {
  /** announcement should be displayed as a banner across the top of the screen */
  Banner = 'banner',
  /** announcement should be displayed as a popup modal */
  Modal = 'modal',
}

export enum DisplayResultEnum {
  AppointmentResultCancelled = 'APPOINTMENT_RESULT_CANCELLED',
  AppointmentResultFollowUp = 'APPOINTMENT_RESULT_FOLLOW_UP',
  AppointmentResultNotInterested = 'APPOINTMENT_RESULT_NOT_INTERESTED',
  AppointmentResultPartnerFinancial = 'APPOINTMENT_RESULT_PARTNER_FINANCIAL',
  AppointmentResultPartnerPray = 'APPOINTMENT_RESULT_PARTNER_PRAY',
  AppointmentResultPartnerSpecial = 'APPOINTMENT_RESULT_PARTNER_SPECIAL',
  FollowUpResultNotInterested = 'FOLLOW_UP_RESULT_NOT_INTERESTED',
  FollowUpResultNoResponse = 'FOLLOW_UP_RESULT_NO_RESPONSE',
  FollowUpResultPartnerFinancial = 'FOLLOW_UP_RESULT_PARTNER_FINANCIAL',
  FollowUpResultPartnerPray = 'FOLLOW_UP_RESULT_PARTNER_PRAY',
  FollowUpResultPartnerSpecial = 'FOLLOW_UP_RESULT_PARTNER_SPECIAL',
  InitiationResultAppointmentScheduled = 'INITIATION_RESULT_APPOINTMENT_SCHEDULED',
  InitiationResultCircleBack = 'INITIATION_RESULT_CIRCLE_BACK',
  InitiationResultNotInterested = 'INITIATION_RESULT_NOT_INTERESTED',
  InitiationResultNoResponse = 'INITIATION_RESULT_NO_RESPONSE',
  PartnerCareCompleted = 'PARTNER_CARE_COMPLETED',
}

export type Donation = {
  __typename?: 'Donation';
  amount: Money;
  appeal?: Maybe<Appeal>;
  appealAmount?: Maybe<Money>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  designationAccount: DesignationAccount;
  donationDate: Scalars['ISO8601Date']['output'];
  donorAccount: DonorAccount;
  id: Scalars['ID']['output'];
  memo?: Maybe<Scalars['String']['output']>;
  motivation?: Maybe<Scalars['String']['output']>;
  paymentMethod?: Maybe<Scalars['String']['output']>;
  remoteId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** The connection type for Donation. */
export type DonationConnection = {
  __typename?: 'DonationConnection';
  /** A list of edges. */
  edges: Array<DonationEdge>;
  /** A list of nodes. */
  nodes: Array<Donation>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total # of objects returned from this Plural Query */
  totalCount: Scalars['Int']['output'];
  /** Total # of pages, based on total count and pagesize */
  totalPageCount: Scalars['Int']['output'];
};

export type DonationCreateInput = {
  amount: Scalars['Float']['input'];
  appealAmount?: InputMaybe<Scalars['Float']['input']>;
  appealId?: InputMaybe<Scalars['ID']['input']>;
  currency: Scalars['String']['input'];
  designationAccountId: Scalars['ID']['input'];
  donationDate: Scalars['ISO8601Date']['input'];
  donorAccountId: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  memo?: InputMaybe<Scalars['String']['input']>;
  motivation?: InputMaybe<Scalars['String']['input']>;
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of DonationCreateMutation */
export type DonationCreateMutationInput = {
  /** AccountList ID that the contact is associated with */
  accountListId: Scalars['ID']['input'];
  /** attributes to create */
  attributes: DonationCreateInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of DonationCreateMutation. */
export type DonationCreateMutationPayload = {
  __typename?: 'DonationCreateMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  donation: Donation;
};

/** Autogenerated input type of DonationDeleteMutation */
export type DonationDeleteMutationInput = {
  /** AccountList ID that the donation is associated with */
  accountListId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of donation to delete */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DonationDeleteMutation. */
export type DonationDeleteMutationPayload = {
  __typename?: 'DonationDeleteMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

/** An edge in a connection. */
export type DonationEdge = {
  __typename?: 'DonationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Donation>;
};

export type DonationHistories = {
  __typename?: 'DonationHistories';
  /** total divided by number of periods */
  average: Scalars['Float']['output'];
  /** total divided by number of periods except current period */
  averageIgnoreCurrent: Scalars['Float']['output'];
  /** total divided by number of periods except current period or periods where total was zero */
  averageIgnoreCurrentAndZero: Scalars['Float']['output'];
  /** total divided by number of periods except periods where total was zero */
  averageIgnoreZero: Scalars['Float']['output'];
  periods: Array<DonationHistoriesPeriod>;
};

export type DonationHistoriesPeriod = {
  __typename?: 'DonationHistoriesPeriod';
  convertedTotal: Scalars['Float']['output'];
  endDate: Scalars['ISO8601Date']['output'];
  startDate: Scalars['ISO8601Date']['output'];
  totals: Array<Total>;
};

export type DonationUpdateInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  appealAmount?: InputMaybe<Scalars['Float']['input']>;
  appealId?: InputMaybe<Scalars['ID']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  designationAccountId?: InputMaybe<Scalars['ID']['input']>;
  donationDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  donorAccountId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  memo?: InputMaybe<Scalars['String']['input']>;
  motivation?: InputMaybe<Scalars['String']['input']>;
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of DonationUpdateMutation */
export type DonationUpdateMutationInput = {
  /** AccountList ID that the donation is associated with */
  accountListId: Scalars['ID']['input'];
  /** attributes to update */
  attributes: DonationUpdateInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of DonationUpdateMutation. */
export type DonationUpdateMutationPayload = {
  __typename?: 'DonationUpdateMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  donation: Donation;
};

/** Autogenerated input type of DonationsUpdateMutation */
export type DonationsUpdateMutationInput = {
  /** AccountList ID that the donations are associated with */
  accountListId: Scalars['ID']['input'];
  /** attributes to update */
  attributes: Array<DonationUpdateInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of DonationsUpdateMutation. */
export type DonationsUpdateMutationPayload = {
  __typename?: 'DonationsUpdateMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  donations: Array<Donation>;
};

export type DonorAccount = {
  __typename?: 'DonorAccount';
  accountNumber: Scalars['String']['output'];
  /** Contacts associated with the donor account, scoped to the account list of the current context */
  contacts: ContactConnection;
  createdAt: Scalars['ISO8601DateTime']['output'];
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  organization: Organization;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type DonorAccountContactsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type DonorCurrencyDonations = {
  __typename?: 'DonorCurrencyDonations';
  /** Associated account list */
  accountList: AccountList;
  /** Donations grouped by currency */
  currencyGroups: Scalars['JSON']['output'];
  /** Default currency for the account list */
  defaultCurrency: Scalars['String']['output'];
  /** Information about donors */
  donorInfos: Array<DonorInfo>;
  /** Months in the report */
  months: Array<Scalars['String']['output']>;
};

export type DonorInfo = {
  __typename?: 'DonorInfo';
  /** Account numbers associated with the donor */
  accountNumbers: Array<Scalars['String']['output']>;
  /** Unique identifier for the contact */
  contactId: Scalars['ID']['output'];
  /** Name of the contact */
  contactName: Scalars['String']['output'];
  /** Flag if donor is late by 30 days */
  lateBy30Days: Scalars['Boolean']['output'];
  /** Flag if donor is late by 60 days */
  lateBy60Days: Scalars['Boolean']['output'];
  /** Amount pledged by donor */
  pledgeAmount?: Maybe<Scalars['String']['output']>;
  /** Currency of pledge */
  pledgeCurrency?: Maybe<Scalars['String']['output']>;
  /** Frequency of pledge (e.g. "1.0" for monthly) */
  pledgeFrequency?: Maybe<Scalars['String']['output']>;
  /** Status of the donor relationship */
  status?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of DuplicateMinistryHousingAllowanceRequestMutation */
export type DuplicateMinistryHousingAllowanceRequestMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Request ID */
  requestId: Scalars['ID']['input'];
};

/** Autogenerated return type of DuplicateMinistryHousingAllowanceRequestMutation. */
export type DuplicateMinistryHousingAllowanceRequestMutationPayload = {
  __typename?: 'DuplicateMinistryHousingAllowanceRequestMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  ministryHousingAllowanceRequest: MinistryHousingAllowanceRequest;
};

export type DuplicateRecordPair = {
  __typename?: 'DuplicateRecordPair';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  ignore: Scalars['Boolean']['output'];
  reason: ReasonEnum;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type DuplicateRecordPairUpdateInput = {
  /** Whether or not this duplicate pair should be ignored */
  ignore: Scalars['Boolean']['input'];
  /** The reason this duplicate pair was found */
  reason?: InputMaybe<ReasonEnum>;
};

/** Autogenerated input type of DuplicatesUpdateMutation */
export type DuplicatesUpdateMutationInput = {
  /** attributes to set on the duplicate record */
  attributes: DuplicateRecordPairUpdateInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the duplicate to operate on */
  id: Scalars['ID']['input'];
  /** The type of duplicate record pair */
  type: TypeEnum;
};

/** Autogenerated return type of DuplicatesUpdateMutation. */
export type DuplicatesUpdateMutationPayload = {
  __typename?: 'DuplicatesUpdateMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  duplicate: DuplicateRecordPair;
};

export enum ElectionType403bEnum {
  /** No percentage contributed to 403(b) */
  None = 'NONE',
  /** 100% of request goes to Traditional 403(b) */
  Pretax = 'PRETAX',
  /** 100% of request goes to Roth 403(b) */
  Roth = 'ROTH',
  /** Current contribution percentages applied to Traditional and Roth 403(b) */
  Standard = 'STANDARD',
}

export type ElectronicAccountListAnalytics = {
  __typename?: 'ElectronicAccountListAnalytics';
  appointments: Scalars['Int']['output'];
  received: Scalars['Int']['output'];
  sent: Scalars['Int']['output'];
};

export type EmailAddress = {
  __typename?: 'EmailAddress';
  createdAt: Scalars['ISO8601DateTime']['output'];
  email: Scalars['String']['output'];
  historic: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  location?: Maybe<Scalars['String']['output']>;
  primary: Scalars['Boolean']['output'];
  /** The source of the email address, for example "MPDX" if it was entered by a user, or "Siebel" if it was imported from the US Donation System */
  source: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  validValues: Scalars['Boolean']['output'];
};

/** The connection type for EmailAddress. */
export type EmailAddressConnection = {
  __typename?: 'EmailAddressConnection';
  /** A list of edges. */
  edges: Array<EmailAddressEdge>;
  /** A list of nodes. */
  nodes: Array<EmailAddress>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total # of objects returned from this Plural Query */
  totalCount: Scalars['Int']['output'];
  /** Total # of pages, based on total count and pagesize */
  totalPageCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type EmailAddressEdge = {
  __typename?: 'EmailAddressEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<EmailAddress>;
};

export type EmailsAccountListAnalytics = {
  __typename?: 'EmailsAccountListAnalytics';
  received: Scalars['Int']['output'];
  sent: Scalars['Int']['output'];
};

export type EntryHistoriesGroup = {
  __typename?: 'EntryHistoriesGroup';
  entryHistories?: Maybe<Array<EntryHistoryRest>>;
  financialAccountId: Scalars['ID']['output'];
};

export type EntryHistoryRest = {
  __typename?: 'EntryHistoryRest';
  closingBalance: Scalars['Float']['output'];
  endDate: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type ExceptionSalaryCap = {
  __typename?: 'ExceptionSalaryCap';
  amount?: Maybe<Scalars['Float']['output']>;
  boardCapException: Scalars['Boolean']['output'];
  effectiveDate?: Maybe<Scalars['ISO8601Date']['output']>;
  exceptionApprover?: Maybe<Scalars['String']['output']>;
};

export type ExcludedAppealContact = {
  __typename?: 'ExcludedAppealContact';
  contact?: Maybe<Contact>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  reasons?: Maybe<Array<ExcludedAppealContactReasonEnum>>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export enum ExcludedAppealContactReasonEnum {
  GaveMoreThanPledgedRange = 'gave_more_than_pledged_range',
  IncreasedRecently = 'increased_recently',
  JoinedRecently = 'joined_recently',
  MarkedDoNotAsk = 'marked_do_not_ask',
  NoAppeals = 'no_appeals',
  PledgeAmountIncreasedRange = 'pledge_amount_increased_range',
  PledgeLateBy = 'pledge_late_by',
  SpecialGift = 'special_gift',
  StartedGivingRange = 'started_giving_range',
  StoppedGiving = 'stopped_giving',
  StoppedGivingRange = 'stopped_giving_range',
}

export type ExpectedMonthlyTotalDonation = {
  __typename?: 'ExpectedMonthlyTotalDonation';
  contactId?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  contactStatus?: Maybe<Scalars['String']['output']>;
  convertedAmount?: Maybe<Scalars['Float']['output']>;
  convertedCurrency?: Maybe<Scalars['String']['output']>;
  convertedCurrencySymbol?: Maybe<Scalars['String']['output']>;
  donationAmount?: Maybe<Scalars['Float']['output']>;
  donationCurrency?: Maybe<Scalars['String']['output']>;
  donationCurrencySymbol?: Maybe<Scalars['String']['output']>;
  pledgeAmount?: Maybe<Scalars['Float']['output']>;
  pledgeCurrency?: Maybe<Scalars['String']['output']>;
  pledgeCurrencySymbol?: Maybe<Scalars['String']['output']>;
  pledgeFrequency?: Maybe<Scalars['String']['output']>;
};

export type ExpectedMonthlyTotalGroup = {
  __typename?: 'ExpectedMonthlyTotalGroup';
  donations: Array<ExpectedMonthlyTotalDonation>;
  total: Scalars['Float']['output'];
};

export type ExpectedMonthlyTotalReport = {
  __typename?: 'ExpectedMonthlyTotalReport';
  currency?: Maybe<Scalars['String']['output']>;
  currencySymbol?: Maybe<Scalars['String']['output']>;
  likely: ExpectedMonthlyTotalGroup;
  received: ExpectedMonthlyTotalGroup;
  unlikely: ExpectedMonthlyTotalGroup;
};

export type ExportContactsInput = {
  accountListId: Scalars['ID']['input'];
  /** Enum value to determine the file format of the exported contacts (Either csv, xlsx, or pdf) */
  format: ExportFormatEnum;
  labelType?: InputMaybe<ExportLabelTypeEnum>;
  /** Boolean value to determine if export is going to be used for mailing purposes. */
  mailing: Scalars['Boolean']['input'];
  sort?: InputMaybe<ExportSortEnum>;
};

export type ExportDataInput = {
  accountListId: Scalars['ID']['input'];
};

export enum ExportFormatEnum {
  Csv = 'csv',
  Pdf = 'pdf',
  Xlsx = 'xlsx',
}

export enum ExportLabelTypeEnum {
  Avery5160 = 'Avery5160',
  Avery7160 = 'Avery7160',
}

export enum ExportSortEnum {
  Name = 'name',
  Zip = 'zip',
}

export type FacebookAccount = {
  __typename?: 'FacebookAccount';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  username?: Maybe<Scalars['String']['output']>;
};

/** The connection type for FacebookAccount. */
export type FacebookAccountConnection = {
  __typename?: 'FacebookAccountConnection';
  /** A list of edges. */
  edges: Array<FacebookAccountEdge>;
  /** A list of nodes. */
  nodes: Array<FacebookAccount>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total # of objects returned from this Plural Query */
  totalCount: Scalars['Int']['output'];
  /** Total # of pages, based on total count and pagesize */
  totalPageCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type FacebookAccountEdge = {
  __typename?: 'FacebookAccountEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<FacebookAccount>;
};

export type FacebookAccountListAnalytics = {
  __typename?: 'FacebookAccountListAnalytics';
  received: Scalars['Int']['output'];
  sent: Scalars['Int']['output'];
};

export type FamilyRelationship = {
  __typename?: 'FamilyRelationship';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  relatedPerson: Person;
  relationship: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** The connection type for FamilyRelationship. */
export type FamilyRelationshipConnection = {
  __typename?: 'FamilyRelationshipConnection';
  /** A list of edges. */
  edges: Array<FamilyRelationshipEdge>;
  /** A list of nodes. */
  nodes: Array<FamilyRelationship>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total # of objects returned from this Plural Query */
  totalCount: Scalars['Int']['output'];
  /** Total # of pages, based on total count and pagesize */
  totalPageCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type FamilyRelationshipEdge = {
  __typename?: 'FamilyRelationshipEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<FamilyRelationship>;
};

export type Filter = {
  filterKey: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type FilterGroup = {
  __typename?: 'FilterGroup';
  featured?: Maybe<Scalars['Boolean']['output']>;
  filters: Array<Filter>;
  name: Scalars['String']['output'];
};

export type FilterOption = {
  __typename?: 'FilterOption';
  name: Scalars['String']['output'];
  placeholder?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

export type FinancialAccount = {
  __typename?: 'FinancialAccount';
  active?: Maybe<Scalars['Boolean']['output']>;
  balance: Money;
  categories: CategoryConnection;
  code: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Organization>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type FinancialAccountCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type FinancialAccountCategory = {
  __typename?: 'FinancialAccountCategory';
  code?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

/** The connection type for FinancialAccount. */
export type FinancialAccountConnection = {
  __typename?: 'FinancialAccountConnection';
  /** A list of edges. */
  edges: Array<FinancialAccountEdge>;
  /** A list of nodes. */
  nodes: Array<FinancialAccount>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total # of objects returned from this Plural Query */
  totalCount: Scalars['Int']['output'];
  /** Total # of pages, based on total count and pagesize */
  totalPageCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type FinancialAccountEdge = {
  __typename?: 'FinancialAccountEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<FinancialAccount>;
};

export type FinancialAccountEntriesInput = {
  accountListId: Scalars['ID']['input'];
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  dateRange: Scalars['String']['input'];
  financialAccountId: Scalars['ID']['input'];
  wildcardSearch?: InputMaybe<Scalars['String']['input']>;
};

export type FinancialAccountEntriesResponse = {
  __typename?: 'FinancialAccountEntriesResponse';
  entries: Array<FinancialAccountEntry>;
  metaData: FinancialAccountMetaData;
};

export type FinancialAccountEntry = {
  __typename?: 'FinancialAccountEntry';
  amount?: Maybe<Scalars['String']['output']>;
  category: FinancialAccountCategory;
  code?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  entryDate?: Maybe<Scalars['ISO8601Date']['output']>;
  id: Scalars['ID']['output'];
  type?: Maybe<Scalars['String']['output']>;
};

export type FinancialAccountMetaData = {
  __typename?: 'FinancialAccountMetaData';
  closingBalance?: Maybe<Scalars['String']['output']>;
  credits?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  debits?: Maybe<Scalars['String']['output']>;
  difference?: Maybe<Scalars['String']['output']>;
  filter?: Maybe<Scalars['String']['output']>;
  openingBalance?: Maybe<Scalars['String']['output']>;
  sort?: Maybe<Scalars['String']['output']>;
};

export type FinancialAccountSummaryCategory = {
  __typename?: 'FinancialAccountSummaryCategory';
  amount?: Maybe<Scalars['String']['output']>;
  category?: Maybe<FinancialAccountCategory>;
  id: Scalars['ID']['output'];
};

export type FinancialAccountSummaryInput = {
  accountListId: Scalars['ID']['input'];
  financialAccountId: Scalars['ID']['input'];
};

export type FinancialAccountSummaryResponse = {
  __typename?: 'FinancialAccountSummaryResponse';
  closingBalance?: Maybe<Scalars['String']['output']>;
  creditByCategories: Array<Maybe<FinancialAccountSummaryCategory>>;
  credits?: Maybe<Scalars['String']['output']>;
  debitByCategories: Array<Maybe<FinancialAccountSummaryCategory>>;
  debits?: Maybe<Scalars['String']['output']>;
  difference?: Maybe<Scalars['String']['output']>;
  endDate: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  openingBalance?: Maybe<Scalars['String']['output']>;
  startDate: Scalars['String']['output'];
};

export type FourOThreeB = {
  __typename?: 'FourOThreeB';
  currentRothContributionPercentage?: Maybe<Scalars['Float']['output']>;
  currentTaxDeferredContributionPercentage?: Maybe<Scalars['Float']['output']>;
  fourOThreeBMakeUpLimitAmount?: Maybe<Scalars['Float']['output']>;
  maximumContributionLimit?: Maybe<Scalars['Float']['output']>;
};

export type Fund = {
  __typename?: 'Fund';
  /** The most that can be transferred out right now: the current balance plus the deficit limit, minus pending scheduled transfers out of the fund and both spouses' unpaid ASRs. Null when the report covers a historical window. */
  availableBalance?: Maybe<Scalars['Float']['output']>;
  categories?: Maybe<Array<TransactionCategory>>;
  deficitLimit: Scalars['Float']['output'];
  /** The balance at the end of the specified period */
  endBalance: Scalars['Float']['output'];
  fundType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** The balance at the start of the specified period */
  startBalance: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
};

export type GoalCalculation = {
  __typename?: 'GoalCalculation';
  age?: Maybe<GoalCalculationAge>;
  benefitsPlan?: Maybe<MpdGoalBenefitsConstantPlanEnum>;
  /** Which year-versioned constants set the goal is calculated against */
  calculationsYear: Scalars['Int']['output'];
  childrenNamesAges?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  familySize?: Maybe<MpdGoalBenefitsConstantSizeEnum>;
  firstName?: Maybe<Scalars['String']['output']>;
  geographicLocation?: Maybe<Scalars['String']['output']>;
  householdFamily: BudgetFamily;
  id: Scalars['ID']['output'];
  isCurrent: Scalars['Boolean']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  mhaAmount?: Maybe<Scalars['Float']['output']>;
  ministryFamily: BudgetFamily;
  ministryLocation?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  netPaycheckAmount?: Maybe<Scalars['Float']['output']>;
  /** The New Staff reference goal calculations */
  newStaffCalculations: NewStaffGoalCalculationCalculations;
  primary: Scalars['Boolean']['output'];
  /** Read-only goals (e.g. a converted New Staff Goal) reject every mutation, including deletion */
  readOnly: Scalars['Boolean']['output'];
  role?: Maybe<GoalCalculationRole>;
  rothContributionPercentage?: Maybe<Scalars['Float']['output']>;
  secaExempt?: Maybe<Scalars['Boolean']['output']>;
  specialFamily: BudgetFamily;
  spouseAge?: Maybe<GoalCalculationAge>;
  spouseFirstName?: Maybe<Scalars['String']['output']>;
  spouseMhaAmount?: Maybe<Scalars['Float']['output']>;
  spouseNetPaycheckAmount?: Maybe<Scalars['Float']['output']>;
  spouseRothContributionPercentage?: Maybe<Scalars['Float']['output']>;
  spouseSecaExempt?: Maybe<Scalars['Boolean']['output']>;
  spouseTaxesPercentage?: Maybe<Scalars['Float']['output']>;
  spouseTraditionalContributionPercentage?: Maybe<Scalars['Float']['output']>;
  spouseYearsOnStaff?: Maybe<Scalars['Int']['output']>;
  taxesPercentage?: Maybe<Scalars['Float']['output']>;
  traditionalContributionPercentage?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  yearsOnStaff?: Maybe<Scalars['Int']['output']>;
};

export enum GoalCalculationAge {
  /** Over 40 */
  OverForty = 'OVER_FORTY',
  /** 35 to 39 */
  ThirtyFiveToThirtyNine = 'THIRTY_FIVE_TO_THIRTY_NINE',
  /** 30 to 34 */
  ThirtyToThirtyFour = 'THIRTY_TO_THIRTY_FOUR',
  /** Under 30 */
  UnderThirty = 'UNDER_THIRTY',
}

/** The connection type for GoalCalculation. */
export type GoalCalculationConnection = {
  __typename?: 'GoalCalculationConnection';
  /** A list of edges. */
  edges: Array<GoalCalculationEdge>;
  /** A list of nodes. */
  nodes: Array<GoalCalculation>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total # of objects returned from this Plural Query */
  totalCount: Scalars['Int']['output'];
  /** Total # of pages, based on total count and pagesize */
  totalPageCount: Scalars['Int']['output'];
};

export type GoalCalculationCreateInput = {
  age?: InputMaybe<GoalCalculationAge>;
  benefitsPlan?: InputMaybe<MpdGoalBenefitsConstantPlanEnum>;
  /** Which year-versioned constants set the goal is calculated against */
  calculationsYear?: InputMaybe<Scalars['Int']['input']>;
  childrenNamesAges?: InputMaybe<Scalars['String']['input']>;
  familySize?: InputMaybe<MpdGoalBenefitsConstantSizeEnum>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  geographicLocation?: InputMaybe<Scalars['String']['input']>;
  isCurrent?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mhaAmount?: InputMaybe<Scalars['Float']['input']>;
  ministryLocation?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  netPaycheckAmount?: InputMaybe<Scalars['Float']['input']>;
  primary?: InputMaybe<Scalars['Boolean']['input']>;
  role?: InputMaybe<GoalCalculationRole>;
  rothContributionPercentage?: InputMaybe<Scalars['Float']['input']>;
  secaExempt?: InputMaybe<Scalars['Boolean']['input']>;
  spouseAge?: InputMaybe<GoalCalculationAge>;
  spouseFirstName?: InputMaybe<Scalars['String']['input']>;
  spouseMhaAmount?: InputMaybe<Scalars['Float']['input']>;
  spouseNetPaycheckAmount?: InputMaybe<Scalars['Float']['input']>;
  spouseRothContributionPercentage?: InputMaybe<Scalars['Float']['input']>;
  spouseSecaExempt?: InputMaybe<Scalars['Boolean']['input']>;
  spouseTaxesPercentage?: InputMaybe<Scalars['Float']['input']>;
  spouseTraditionalContributionPercentage?: InputMaybe<
    Scalars['Float']['input']
  >;
  spouseYearsOnStaff?: InputMaybe<Scalars['Int']['input']>;
  taxesPercentage?: InputMaybe<Scalars['Float']['input']>;
  traditionalContributionPercentage?: InputMaybe<Scalars['Float']['input']>;
  yearsOnStaff?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated input type of GoalCalculationCreateMutation */
export type GoalCalculationCreateMutationInput = {
  /** AccountList ID that the goal calculation will be associated with */
  accountListId: Scalars['ID']['input'];
  /** Attributes to create */
  attributes?: InputMaybe<GoalCalculationCreateInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of GoalCalculationCreateMutation. */
export type GoalCalculationCreateMutationPayload = {
  __typename?: 'GoalCalculationCreateMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  goalCalculation: GoalCalculation;
};

/** Autogenerated input type of GoalCalculationDeleteMutation */
export type GoalCalculationDeleteMutationInput = {
  /** AccountList ID that the goal calculation is associated with */
  accountListId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the goal calculation to delete */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of GoalCalculationDeleteMutation. */
export type GoalCalculationDeleteMutationPayload = {
  __typename?: 'GoalCalculationDeleteMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

/** An edge in a connection. */
export type GoalCalculationEdge = {
  __typename?: 'GoalCalculationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<GoalCalculation>;
};

export enum GoalCalculationRole {
  Field = 'FIELD',
  Office = 'OFFICE',
}

export type GoalCalculationUpdateInput = {
  age?: InputMaybe<GoalCalculationAge>;
  benefitsPlan?: InputMaybe<MpdGoalBenefitsConstantPlanEnum>;
  /** Which year-versioned constants set the goal is calculated against */
  calculationsYear?: InputMaybe<Scalars['Int']['input']>;
  childrenNamesAges?: InputMaybe<Scalars['String']['input']>;
  familySize?: InputMaybe<MpdGoalBenefitsConstantSizeEnum>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  geographicLocation?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isCurrent?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mhaAmount?: InputMaybe<Scalars['Float']['input']>;
  ministryLocation?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  netPaycheckAmount?: InputMaybe<Scalars['Float']['input']>;
  primary?: InputMaybe<Scalars['Boolean']['input']>;
  role?: InputMaybe<GoalCalculationRole>;
  rothContributionPercentage?: InputMaybe<Scalars['Float']['input']>;
  secaExempt?: InputMaybe<Scalars['Boolean']['input']>;
  spouseAge?: InputMaybe<GoalCalculationAge>;
  spouseFirstName?: InputMaybe<Scalars['String']['input']>;
  spouseMhaAmount?: InputMaybe<Scalars['Float']['input']>;
  spouseNetPaycheckAmount?: InputMaybe<Scalars['Float']['input']>;
  spouseRothContributionPercentage?: InputMaybe<Scalars['Float']['input']>;
  spouseSecaExempt?: InputMaybe<Scalars['Boolean']['input']>;
  spouseTaxesPercentage?: InputMaybe<Scalars['Float']['input']>;
  spouseTraditionalContributionPercentage?: InputMaybe<
    Scalars['Float']['input']
  >;
  spouseYearsOnStaff?: InputMaybe<Scalars['Int']['input']>;
  taxesPercentage?: InputMaybe<Scalars['Float']['input']>;
  traditionalContributionPercentage?: InputMaybe<Scalars['Float']['input']>;
  yearsOnStaff?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated input type of GoalCalculationUpdateMutation */
export type GoalCalculationUpdateMutationInput = {
  /** AccountList ID that the goal calculation is associated with */
  accountListId: Scalars['ID']['input'];
  /** Attributes to update */
  attributes: GoalCalculationUpdateInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of GoalCalculationUpdateMutation. */
export type GoalCalculationUpdateMutationPayload = {
  __typename?: 'GoalCalculationUpdateMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  goalCalculation: GoalCalculation;
};

export type GoogleAccountAttributes = {
  __typename?: 'GoogleAccountAttributes';
  contactGroups: Array<Maybe<ContactGroup>>;
  createdAt: Scalars['String']['output'];
  email: Scalars['String']['output'];
  expiresAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastDownload?: Maybe<Scalars['String']['output']>;
  lastEmailSync?: Maybe<Scalars['String']['output']>;
  primary: Scalars['Boolean']['output'];
  remoteId: Scalars['String']['output'];
  tokenExpired: Scalars['Boolean']['output'];
  updatedAt: Scalars['String']['output'];
  updatedInDbAt: Scalars['String']['output'];
};

export type GoogleAccountIntegration = {
  __typename?: 'GoogleAccountIntegration';
  calendarId?: Maybe<Scalars['String']['output']>;
  calendarIntegration?: Maybe<Scalars['Boolean']['output']>;
  calendarIntegrations: Array<ActivityTypeEnum>;
  calendarName?: Maybe<Scalars['String']['output']>;
  calendars: Array<Maybe<GoogleAccountIntegrationCalendars>>;
  createdAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  updatedInDbAt: Scalars['String']['output'];
};

export type GoogleAccountIntegrationCalendars = {
  __typename?: 'GoogleAccountIntegrationCalendars';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type GoogleAccountIntegrationCalendarsInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type GoogleAccountIntegrationInput = {
  calendarId?: InputMaybe<Scalars['String']['input']>;
  calendarIntegration?: InputMaybe<Scalars['Boolean']['input']>;
  calendarIntegrations?: InputMaybe<
    Array<InputMaybe<Scalars['String']['input']>>
  >;
  calendarName?: InputMaybe<Scalars['String']['input']>;
  calendars?: InputMaybe<
    Array<InputMaybe<GoogleAccountIntegrationCalendarsInput>>
  >;
  createdAt?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  overwrite?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['String']['input']>;
  updatedInDbAt?: InputMaybe<Scalars['String']['input']>;
};

export type GoogleAccountIntegrationsInput = {
  accountListId: Scalars['ID']['input'];
  googleAccountId: Scalars['ID']['input'];
};

export type Hcm = {
  __typename?: 'Hcm';
  asrEit: AsrEit;
  currentSalary: CurrentSalary;
  designationSupportCalculatorEligible: Scalars['Boolean']['output'];
  exceptionSalaryCap: ExceptionSalaryCap;
  fourOThreeB: FourOThreeB;
  /** Whether the staff member has a current MHA: a board approval date of any age is on file. The IBS certification is not checked; mhaNewRequest decides who may request a new MHA */
  mhaBoardApproval: MhaEit;
  mhaEit: MhaEit;
  /** Whether the staff member may start, duplicate or submit an MHA request: mhaEit passes, or they have a board-approved MHA amount and approval date */
  mhaNewRequest: MhaEit;
  mhaRequest: MhaRequest;
  mhiEit: MhiEit;
  /** HCM no longer returns this person, so this is the last data it did return */
  outOfSync: Scalars['Boolean']['output'];
  salaryRequestEligible: Scalars['Boolean']['output'];
  staffInfo: StaffInfo;
  /** When this data was last read from HCM; null when it was fetched live for a past or future date */
  syncedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  usStaffGroup?: Maybe<UsStaffGroupEnum>;
  yearToDate: YearToDate;
};

export type IdKeyValue = {
  __typename?: 'IdKeyValue';
  id?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type IdValue = {
  __typename?: 'IdValue';
  id?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type IndividualMultiplier = {
  __typename?: 'IndividualMultiplier';
  createdAt: Scalars['ISO8601DateTime']['output'];
  fiveChildren029: Scalars['Float']['output'];
  fiveChildren3034: Scalars['Float']['output'];
  fiveChildren3539: Scalars['Float']['output'];
  fiveChildren40200: Scalars['Float']['output'];
  fourChildren029: Scalars['Float']['output'];
  fourChildren3034: Scalars['Float']['output'];
  fourChildren3539: Scalars['Float']['output'];
  fourChildren40200: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  married029: Scalars['Float']['output'];
  married3034: Scalars['Float']['output'];
  married3539: Scalars['Float']['output'];
  married40200: Scalars['Float']['output'];
  oneChildren029: Scalars['Float']['output'];
  oneChildren3034: Scalars['Float']['output'];
  oneChildren3539: Scalars['Float']['output'];
  oneChildren40200: Scalars['Float']['output'];
  single029: Scalars['Float']['output'];
  single3034: Scalars['Float']['output'];
  single3539: Scalars['Float']['output'];
  single40200: Scalars['Float']['output'];
  sixChildren029: Scalars['Float']['output'];
  sixChildren3034: Scalars['Float']['output'];
  sixChildren3539: Scalars['Float']['output'];
  sixChildren40200: Scalars['Float']['output'];
  threeChildren029: Scalars['Float']['output'];
  threeChildren3034: Scalars['Float']['output'];
  threeChildren3539: Scalars['Float']['output'];
  threeChildren40200: Scalars['Float']['output'];
  twoChildren029: Scalars['Float']['output'];
  twoChildren3034: Scalars['Float']['output'];
  twoChildren3539: Scalars['Float']['output'];
  twoChildren40200: Scalars['Float']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  widowWidower029: Scalars['Float']['output'];
  widowWidower3034: Scalars['Float']['output'];
  widowWidower3539: Scalars['Float']['output'];
  widowWidower40200: Scalars['Float']['output'];
  year: Scalars['Int']['output'];
};

export type Invite = {
  __typename?: 'Invite';
  acceptedAt?: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  inviteUserAs?: Maybe<Scalars['String']['output']>;
  recipientEmail?: Maybe<Scalars['String']['output']>;
};

export enum InviteTypeEnum {
  Coach = 'COACH',
  User = 'USER',
}

export type KeyAccount = {
  __typename?: 'KeyAccount';
  createdAt: Scalars['ISO8601DateTime']['output'];
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export enum LikelyToGiveEnum {
  LeastLikely = 'LEAST_LIKELY',
  Likely = 'LIKELY',
  MostLikely = 'MOST_LIKELY',
}

export type LinkedinAccount = {
  __typename?: 'LinkedinAccount';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  publicUrl?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** The connection type for LinkedinAccount. */
export type LinkedinAccountConnection = {
  __typename?: 'LinkedinAccountConnection';
  /** A list of edges. */
  edges: Array<LinkedinAccountEdge>;
  /** A list of nodes. */
  nodes: Array<LinkedinAccount>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total # of objects returned from this Plural Query */
  totalCount: Scalars['Int']['output'];
  /** Total # of pages, based on total count and pagesize */
  totalPageCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type LinkedinAccountEdge = {
  __typename?: 'LinkedinAccountEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<LinkedinAccount>;
};

export type ListsAvailableForNewsletters = {
  __typename?: 'ListsAvailableForNewsletters';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type Locale = {
  __typename?: 'Locale';
  englishName?: Maybe<Scalars['String']['output']>;
  nativeName?: Maybe<Scalars['String']['output']>;
  shortName?: Maybe<Scalars['String']['output']>;
};

export type MailchimpAccount = {
  __typename?: 'MailchimpAccount';
  active: Scalars['Boolean']['output'];
  autoLogCampaigns: Scalars['Boolean']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  listsAvailableForNewsletters?: Maybe<
    Array<Maybe<ListsAvailableForNewsletters>>
  >;
  listsLink: Scalars['String']['output'];
  listsPresent: Scalars['Boolean']['output'];
  primaryListId?: Maybe<Scalars['ID']['output']>;
  primaryListName?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
  updatedInDbAt: Scalars['String']['output'];
  valid: Scalars['Boolean']['output'];
  validateKey: Scalars['Boolean']['output'];
  validationError?: Maybe<Scalars['String']['output']>;
};

export type MailchimpAccountInput = {
  accountListId: Scalars['ID']['input'];
};

/** Autogenerated input type of ManagedStaffGeographicLocationUpdateMutation */
export type ManagedStaffGeographicLocationUpdateMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Geographic location to store on the staff member's account list */
  geographicLocation: Scalars['String']['input'];
  /** Managed staff member whose geographic location to update */
  personNumber: Scalars['String']['input'];
};

/** Autogenerated return type of ManagedStaffGeographicLocationUpdateMutation. */
export type ManagedStaffGeographicLocationUpdateMutationPayload = {
  __typename?: 'ManagedStaffGeographicLocationUpdateMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The updated geographic location for the staff member */
  geographicLocation: Scalars['String']['output'];
  /** Recalculated new staff monthly salary for the staff member */
  newStaffMonthlySalary: Scalars['Float']['output'];
};

export enum MaritalStatusEnum {
  /** Married staff member */
  Married = 'MARRIED',
  /** Single staff member */
  Single = 'SINGLE',
  /** Widowed staff member */
  Widowed = 'WIDOWED',
}

export type MergeContactsInput = {
  winnersAndLosers: Array<WinnersAndLosers>;
};

export type MergePeopleBulkInput = {
  winnersAndLosers: Array<WinnersAndLosers>;
};

/** Autogenerated input type of MergePeopleMutation */
export type MergePeopleMutationInput = {
  /** AccountList ID that the people are associated with */
  accountListId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** IDs of the people that will lose the merge */
  loserIds: Array<Scalars['ID']['input']>;
  /** ID of the person that will win the merge */
  winnerId: Scalars['ID']['input'];
};

/** Autogenerated return type of MergePeopleMutation. */
export type MergePeopleMutationPayload = {
  __typename?: 'MergePeopleMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  contact: Contact;
  winner: Person;
};

export type MhaEit = {
  __typename?: 'MhaEit';
  /** Code identifying why the user is ineligible to create MHA requests */
  ineligibilityReasonCode?: Maybe<MinistersHousingIneligibilityReasonEnum>;
  /** Indicates whether the user is eligible to create MHA requests */
  mhaEligibility: Scalars['Boolean']['output'];
};

export enum MhaRentOrOwnEnum {
  /** Individual owns their home */
  Own = 'OWN',
  /** Individual is renting their home */
  Rent = 'RENT',
}

export type MhaRequest = {
  __typename?: 'MhaRequest';
  boardApprovedOnDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** The current approved MHA (or MHI) amount: the HCM approved amount when mhaBoardApproval or mhiEit passes, otherwise 0 */
  boardApprovedOverallAmount?: Maybe<Scalars['Float']['output']>;
  currentApprovedOverallAmount?: Maybe<Scalars['Float']['output']>;
  currentTakenAmount?: Maybe<Scalars['Float']['output']>;
  lastUpdatedDate?: Maybe<Scalars['ISO8601Date']['output']>;
};

export type MhaRequestAttributes = {
  __typename?: 'MhaRequestAttributes';
  /** Date when the approved amount becomes available */
  availableDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** Average monthly utilities (electric, gas, water, trash) */
  avgUtilityOne?: Maybe<Scalars['PositiveFloat']['output']>;
  /** Additional utilities (cable, internet, phone) */
  avgUtilityTwo?: Maybe<Scalars['PositiveFloat']['output']>;
  /** Timestamp when the request was approved by the board */
  boardApprovedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Timestamp when the request was cancelled */
  cancelledAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Timestamp when changes were requested */
  changesRequestedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Contact email address for this request */
  emailAddress?: Maybe<Scalars['String']['output']>;
  /** Furniture and furnishings costs (initial estimate) */
  furnitureCostsOne?: Maybe<Scalars['PositiveFloat']['output']>;
  /** Additional furniture and furnishings costs */
  furnitureCostsTwo?: Maybe<Scalars['PositiveFloat']['output']>;
  /** Timestamp when the request was approved by HR */
  hrApprovedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Confirmation that the applicant understands the MHA policy */
  iUnderstandMhaPolicy?: Maybe<Scalars['Boolean']['output']>;
  /** Monthly mortgage or rent payment amount */
  mortgageOrRentPayment?: Maybe<Scalars['PositiveFloat']['output']>;
  /** Total requested housing allowance amount */
  overallAmount?: Maybe<Scalars['PositiveFloat']['output']>;
  /** Contact phone number for this request */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** Whether the applicant rents or owns their home */
  rentOrOwn?: Maybe<MhaRentOrOwnEnum>;
  /** Fair market rental value of owned home (for tax purposes) */
  rentalValue?: Maybe<Scalars['PositiveFloat']['output']>;
  /** Home repair and maintenance costs */
  repairCosts?: Maybe<Scalars['PositiveFloat']['output']>;
  /** Flag indicating the spouse of the MHA creator is not eligible (requires human review) */
  spouseIneligible?: Maybe<Scalars['Boolean']['output']>;
  /** Timestamp when the request was submitted */
  submittedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Buffer for unexpected housing expenses */
  unexpectedExpenses?: Maybe<Scalars['PositiveFloat']['output']>;
};

export enum MhaStatusEnum {
  /** Request needs changes from the user */
  ActionRequired = 'ACTION_REQUIRED',
  /** Request has been approved by the board */
  BoardApproved = 'BOARD_APPROVED',
  /** Request has been cancelled */
  Cancelled = 'CANCELLED',
  /** Request has been approved by HR */
  HrApproved = 'HR_APPROVED',
  /** Request is being drafted by the user */
  InProgress = 'IN_PROGRESS',
  /** Request has been submitted and is awaiting HR review */
  Pending = 'PENDING',
}

export type MhiEit = {
  __typename?: 'MhiEit';
  /** Code identifying why the user is ineligible to create MHI requests */
  ineligibilityReasonCode?: Maybe<MinistersHousingIneligibilityReasonEnum>;
  /** Indicates whether the user is eligible to create MHI requests */
  mhiEligibility: Scalars['Boolean']['output'];
};

export enum MinistersHousingIneligibilityReasonEnum {
  /** Assignment Status is not "Active - Payroll Eligible" or "Active - Paid Leave" */
  AssignmentStatus = 'ASSIGNMENT_STATUS',
  /** IBS Initial Certification is more than 10 years old */
  IbsCertificationExpired = 'IBS_CERTIFICATION_EXPIRED',
  /** IBS certification type is not valid for this housing allowance */
  InvalidIbsCertification = 'INVALID_IBS_CERTIFICATION',
  /** Italy staff receive MHI instead of MHA */
  ItalyMhi = 'ITALY_MHI',
  /** mhaBoardApproval only: no MHA board approval date on file */
  MissingBoardApprovedOnDate = 'MISSING_BOARD_APPROVED_ON_DATE',
  /** IBS Initial Certification has no certification date on file */
  MissingIbsCertificationDate = 'MISSING_IBS_CERTIFICATION_DATE',
  /** Non-Italy staff receive MHA instead of MHI */
  NonItalyMha = 'NON_ITALY_MHA',
  /** No IBS certification found */
  NoIbsCertification = 'NO_IBS_CERTIFICATION',
  /** User Person Type is not eligible for housing allowance requests */
  PersonType = 'PERSON_TYPE',
  /** People Group Support Type is not "Supported RMO" */
  SupportType = 'SUPPORT_TYPE',
}

export type Ministry = {
  __typename?: 'Ministry';
  /** Applicant-selectable sub-ministries, ordered by name */
  children: Array<Ministry>;
  id: Scalars['ID']['output'];
  /** Ministry name */
  name?: Maybe<Scalars['String']['output']>;
};

export type MinistryHousingAllowanceRequest = {
  __typename?: 'MinistryHousingAllowanceRequest';
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Feedback from reviewers */
  feedback?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** HR person number associated with this request */
  personNumber: Scalars['String']['output'];
  /** JSON object containing the form data for the housing allowance request */
  requestAttributes: MhaRequestAttributes;
  /** Current status of the request in the approval workflow */
  status: MhaStatusEnum;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** User who created this request */
  user?: Maybe<User>;
};

export type MinistryHousingAllowanceRequestAttributesInput = {
  /** Average monthly utilities (electric, gas, water, trash) */
  avgUtilityOne?: InputMaybe<Scalars['PositiveFloat']['input']>;
  /** Additional utilities (cable, internet, phone) */
  avgUtilityTwo?: InputMaybe<Scalars['PositiveFloat']['input']>;
  /** Contact email address for this request */
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  /** Furniture and furnishings costs (initial estimate) */
  furnitureCostsOne?: InputMaybe<Scalars['PositiveFloat']['input']>;
  /** Additional furniture and furnishings costs */
  furnitureCostsTwo?: InputMaybe<Scalars['PositiveFloat']['input']>;
  /** Confirmation that the applicant understands the MHA policy */
  iUnderstandMhaPolicy?: InputMaybe<Scalars['Boolean']['input']>;
  /** Monthly mortgage or rent payment amount */
  mortgageOrRentPayment?: InputMaybe<Scalars['PositiveFloat']['input']>;
  /** Total requested housing allowance amount */
  overallAmount?: InputMaybe<Scalars['PositiveFloat']['input']>;
  /** Contact phone number for this request */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Whether the applicant rents or owns their home */
  rentOrOwn?: InputMaybe<MhaRentOrOwnEnum>;
  /** Fair market rental value of owned home (for tax purposes) */
  rentalValue?: InputMaybe<Scalars['PositiveFloat']['input']>;
  /** Home repair and maintenance costs */
  repairCosts?: InputMaybe<Scalars['PositiveFloat']['input']>;
  /** Buffer for unexpected housing expenses */
  unexpectedExpenses?: InputMaybe<Scalars['PositiveFloat']['input']>;
};

/** The connection type for MinistryHousingAllowanceRequest. */
export type MinistryHousingAllowanceRequestConnection = {
  __typename?: 'MinistryHousingAllowanceRequestConnection';
  /** A list of edges. */
  edges: Array<MinistryHousingAllowanceRequestEdge>;
  /** A list of nodes. */
  nodes: Array<MinistryHousingAllowanceRequest>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total # of objects returned from this Plural Query */
  totalCount: Scalars['Int']['output'];
  /** Total # of pages, based on total count and pagesize */
  totalPageCount: Scalars['Int']['output'];
};

/** Autogenerated input type of MinistryHousingAllowanceRequestCreateMutation */
export type MinistryHousingAllowanceRequestCreateMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** JSON object containing the form data for the housing allowance request */
  requestAttributes?: InputMaybe<MinistryHousingAllowanceRequestAttributesInput>;
};

/** Autogenerated return type of MinistryHousingAllowanceRequestCreateMutation. */
export type MinistryHousingAllowanceRequestCreateMutationPayload = {
  __typename?: 'MinistryHousingAllowanceRequestCreateMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  ministryHousingAllowanceRequest: MinistryHousingAllowanceRequest;
};

/** Autogenerated input type of MinistryHousingAllowanceRequestDeleteMutation */
export type MinistryHousingAllowanceRequestDeleteMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Request ID to delete */
  requestId: Scalars['ID']['input'];
};

/** Autogenerated return type of MinistryHousingAllowanceRequestDeleteMutation. */
export type MinistryHousingAllowanceRequestDeleteMutationPayload = {
  __typename?: 'MinistryHousingAllowanceRequestDeleteMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

/** An edge in a connection. */
export type MinistryHousingAllowanceRequestEdge = {
  __typename?: 'MinistryHousingAllowanceRequestEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<MinistryHousingAllowanceRequest>;
};

/** Autogenerated input type of MinistryHousingAllowanceRequestSubmitMutation */
export type MinistryHousingAllowanceRequestSubmitMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Request ID */
  requestId: Scalars['ID']['input'];
};

/** Autogenerated return type of MinistryHousingAllowanceRequestSubmitMutation. */
export type MinistryHousingAllowanceRequestSubmitMutationPayload = {
  __typename?: 'MinistryHousingAllowanceRequestSubmitMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  ministryHousingAllowanceRequest: MinistryHousingAllowanceRequest;
};

/** Autogenerated input type of MinistryHousingAllowanceRequestUpdateMutation */
export type MinistryHousingAllowanceRequestUpdateMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Structured form data for the Housing Allowance Request */
  requestAttributes: MinistryHousingAllowanceRequestAttributesInput;
  /** Request ID to update */
  requestId: Scalars['ID']['input'];
};

/** Autogenerated return type of MinistryHousingAllowanceRequestUpdateMutation. */
export type MinistryHousingAllowanceRequestUpdateMutationPayload = {
  __typename?: 'MinistryHousingAllowanceRequestUpdateMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  ministryHousingAllowanceRequest: MinistryHousingAllowanceRequest;
};

/** A ministry partner reminder from Siebel */
export type MinistryPartnerReminder = {
  __typename?: 'MinistryPartnerReminder';
  addressStatus: Scalars['String']['output'];
  changeable: Scalars['Boolean']['output'];
  designationId: Scalars['String']['output'];
  donorAccountNumber: Scalars['String']['output'];
  donorId: Scalars['String']['output'];
  donorName: Scalars['String']['output'];
  frequency: MinistryPartnerReminderFrequencyEnum;
  id: Scalars['ID']['output'];
  lastGiftDate?: Maybe<Scalars['ISO8601Date']['output']>;
  lastReminderDate?: Maybe<Scalars['ISO8601Date']['output']>;
  reminded: Scalars['Boolean']['output'];
  undeliverable: Scalars['Boolean']['output'];
};

export enum MinistryPartnerReminderFrequencyEnum {
  Annually = 'ANNUALLY',
  Bimonthly = 'BIMONTHLY',
  DoNotRemind = 'DO_NOT_REMIND',
  Monthly = 'MONTHLY',
  NotReminded = 'NOT_REMINDED',
  Quarterly = 'QUARTERLY',
  SemiAnnually = 'SEMI_ANNUALLY',
}

/** Input type for updating a single ministry partner reminder */
export type MinistryPartnerReminderUpdateInput = {
  /** The Siebel row ID of the reminder to update */
  rowId: Scalars['String']['input'];
  /** The new frequency status code */
  statusCd: MinistryPartnerReminderFrequencyEnum;
};

export type Money = {
  __typename?: 'Money';
  amount: Scalars['Float']['output'];
  conversionDate: Scalars['ISO8601Date']['output'];
  conversionRate: Scalars['Float']['output'];
  convertedAmount: Scalars['Float']['output'];
  convertedCurrency: Scalars['String']['output'];
  currency: Scalars['String']['output'];
};

/** A staff member's payroll history by month */
export type MonthlyPayrollHistory = {
  __typename?: 'MonthlyPayrollHistory';
  /** Additional salary and reimbursements this month */
  asrAndReimbursements?: Maybe<Scalars['Float']['output']>;
  /** The month this payroll data is pulled from, as YYYY-MM */
  month?: Maybe<Scalars['String']['output']>;
  /** Payroll this month */
  payroll?: Maybe<Scalars['Float']['output']>;
  /** Percentage of how much they have been paid this month relative to their max amount */
  percentMaxPay?: Maybe<Scalars['Float']['output']>;
};

/** A staff member's payroll summary by month */
export type MonthlyPayrollSummary = {
  __typename?: 'MonthlyPayrollSummary';
  /** Total income this month */
  contributions?: Maybe<Scalars['Float']['output']>;
  /** The balance at the end of this month */
  endBalance?: Maybe<Scalars['Float']['output']>;
  /** Total expenses this month */
  expenses?: Maybe<Scalars['Float']['output']>;
  /** The month this payroll data is pulled from, as YYYY-MM */
  month?: Maybe<Scalars['String']['output']>;
  /** Difference between contributions and expenses this month */
  net?: Maybe<Scalars['Float']['output']>;
};

export enum MpdAssignmentCategoryGroupEnum {
  /** Full-time assignment categories */
  FullTime = 'FULL_TIME',
  /** Part-time and on call assignment categories */
  PartTime = 'PART_TIME',
}

export type MpdGoalBenefitsConstant = {
  __typename?: 'MpdGoalBenefitsConstant';
  cost: Scalars['Float']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  plan: MpdGoalBenefitsConstantPlanEnum;
  planDisplayName: Scalars['String']['output'];
  size: MpdGoalBenefitsConstantSizeEnum;
  sizeDisplayName: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  year: Scalars['Int']['output'];
};

export enum MpdGoalBenefitsConstantPlanEnum {
  Base = 'BASE',
  Exempt = 'EXEMPT',
  Minimum = 'MINIMUM',
  Plus = 'PLUS',
  Select = 'SELECT',
}

export enum MpdGoalBenefitsConstantSizeEnum {
  MarriedNoChildren = 'MARRIED_NO_CHILDREN',
  MarriedOneToTwoChildren = 'MARRIED_ONE_TO_TWO_CHILDREN',
  MarriedThreeOrMoreChildren = 'MARRIED_THREE_OR_MORE_CHILDREN',
  Single = 'SINGLE',
  SosaFourOrMoreDependents = 'SOSA_FOUR_OR_MORE_DEPENDENTS',
  SosaOneDependent = 'SOSA_ONE_DEPENDENT',
  SosaTwoToThreeDependents = 'SOSA_TWO_TO_THREE_DEPENDENTS',
}

export type MpdGoalGeographicConstant = {
  __typename?: 'MpdGoalGeographicConstant';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  location: Scalars['String']['output'];
  percentageMultiplier: Scalars['Float']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  year: Scalars['Int']['output'];
};

export type MpdGoalMiscConstant = {
  __typename?: 'MpdGoalMiscConstant';
  category: MpdGoalMiscConstantCategoryEnum;
  categoryDisplayName: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  fee: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  label: MpdGoalMiscConstantLabelEnum;
  labelDisplayName: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  year: Scalars['Int']['output'];
};

export enum MpdGoalMiscConstantCategoryEnum {
  AdditionalRates = 'ADDITIONAL_RATES',
  BoardApprovedSalaryCalc = 'BOARD_APPROVED_SALARY_CALC',
  DebtPercentage = 'DEBT_PERCENTAGE',
  MileageRates = 'MILEAGE_RATES',
  MinimumAccountBalance = 'MINIMUM_ACCOUNT_BALANCE',
  Rates = 'RATES',
  RecommendedEmergencySavings = 'RECOMMENDED_EMERGENCY_SAVINGS',
  ReimbursementsWithMaximum = 'REIMBURSEMENTS_WITH_MAXIMUM',
}

export enum MpdGoalMiscConstantLabelEnum {
  AdminRate = 'ADMIN_RATE',
  AttritionRate = 'ATTRITION_RATE',
  Couples = 'COUPLES',
  CreditCardFeeRate = 'CREDIT_CARD_FEE_RATE',
  DebtCapFraction = 'DEBT_CAP_FRACTION',
  EmployerFicaRate = 'EMPLOYER_FICA_RATE',
  FourOhThreeB = 'FOUR_OH_THREE_B',
  General = 'GENERAL',
  Individuals = 'INDIVIDUALS',
  Internet = 'INTERNET',
  Level_1SalaryFraction = 'LEVEL_1_SALARY_FRACTION',
  Level_2SalaryFraction = 'LEVEL_2_SALARY_FRACTION',
  Married = 'MARRIED',
  MarriedNy = 'MARRIED_NY',
  MarriedOther = 'MARRIED_OTHER',
  Medical = 'MEDICAL',
  MinimumReimbursable = 'MINIMUM_REIMBURSABLE',
  MinAccountBalanceMarriedNoKids = 'MIN_ACCOUNT_BALANCE_MARRIED_NO_KIDS',
  MinAccountBalanceMarriedWithKids = 'MIN_ACCOUNT_BALANCE_MARRIED_WITH_KIDS',
  MinAccountBalanceSingle = 'MIN_ACCOUNT_BALANCE_SINGLE',
  PartTimeWorkCompensation = 'PART_TIME_WORK_COMPENSATION',
  Phone = 'PHONE',
  Seca = 'SECA',
  Single = 'SINGLE',
  SingleNy = 'SINGLE_NY',
  SingleOther = 'SINGLE_OTHER',
  WithKids = 'WITH_KIDS',
}

export type MpdGoalReimbursementConstant = {
  __typename?: 'MpdGoalReimbursementConstant';
  baseConferences: Scalars['Float']['output'];
  baseMeals: Scalars['Float']['output'];
  baseMileage: Scalars['Float']['output'];
  baseMpd: Scalars['Float']['output'];
  baseSupplies: Scalars['Float']['output'];
  baseTravel: Scalars['Float']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  healthcareBase: Scalars['Float']['output'];
  healthcareExempt: Scalars['Float']['output'];
  healthcareMinimum: Scalars['Float']['output'];
  healthcarePerChild: Scalars['Float']['output'];
  healthcarePlus: Scalars['Float']['output'];
  healthcareSelect: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  officeMultiplierConferences: Scalars['Float']['output'];
  officeMultiplierMeals: Scalars['Float']['output'];
  officeMultiplierMileage: Scalars['Float']['output'];
  officeMultiplierMpd: Scalars['Float']['output'];
  officeMultiplierSupplies: Scalars['Float']['output'];
  officeMultiplierTravel: Scalars['Float']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  year: Scalars['Int']['output'];
};

export enum MpdHealthStatusEnum {
  /** Indicates payroll status is not graded against salary thresholds (for part-time and volunteers) */
  Blue = 'BLUE',
  /** Indicates no payroll data available */
  Gray = 'GRAY',
  /** Indicates healthy payroll status */
  Green = 'GREEN',
  /** Indicates problematic payroll status */
  Red = 'RED',
  /** Indicates cautionary payroll status */
  Yellow = 'YELLOW',
}

export enum MpdHistoryRangeEnum {
  /** 12-month history range of payroll */
  TwelveMonths = 'TWELVE_MONTHS',
  /** 24-month history range of payroll */
  TwentyFourMonths = 'TWENTY_FOUR_MONTHS',
}

/** A supervisor's list of staff they manage, including their payroll and health data */
export type MpdManagedStaff = {
  __typename?: 'MpdManagedStaff';
  /** The employee's age as of the last HCM staff import */
  age?: Maybe<Scalars['Int']['output']>;
  /** Whether the assignment is full time, or part time (which includes on call), as of the last HCM staff import */
  assignmentCategoryGroup?: Maybe<MpdAssignmentCategoryGroupEnum>;
  /** The employee's own department as of the last HCM staff import, the value the departments filter matches. Can differ from the departments of their teams */
  department?: Maybe<Scalars['String']['output']>;
  /** The employee's first name */
  firstName: Scalars['String']['output'];
  /** The geographic location used for the employee's new staff monthly salary */
  geographicLocation?: Maybe<Scalars['String']['output']>;
  /** Dependents on the household's healthcare plan as of the last HCM staff import, the larger of the counts HCM holds for the employee and their spouse */
  healthcareDependentsCount?: Maybe<Scalars['Int']['output']>;
  /** The employee's last name */
  lastName: Scalars['String']['output'];
  /** The employee's monthly salary if they were new staff. Null for interns, part-time field staff and volunteers, who are not measured against it */
  newStaffMonthlySalary?: Maybe<Scalars['Float']['output']>;
  /** How the employee is supported — RMO, non-RMO, designation or not at all — as of the last HCM staff import */
  peopleGroupSupportType?: Maybe<PeopleGroupSupportTypeEnum>;
  /** The employee's person number */
  personNumber: Scalars['String']['output'];
  /** The employee's quarterly health data */
  quarterlyHealth: QuarterlyPayrollHistory;
  /** Whether the employee pays SECA, pays FICA instead, or holds the ministerial exemption from SECA, as of the last HCM staff import */
  secaStatus?: Maybe<SecaStatusEnum>;
  /** The employee's spouse's first name */
  spouseFirstName?: Maybe<Scalars['String']['output']>;
  /** The employee's spouse's last name */
  spouseLastName?: Maybe<Scalars['String']['output']>;
  /** The employee's spouse's person number */
  spousePersonNumber?: Maybe<Scalars['String']['output']>;
  /** The employee's spouse's staff account ID */
  spouseStaffAccountId?: Maybe<Scalars['String']['output']>;
  /** The employee's staff account ID */
  staffAccountId: Scalars['String']['output'];
  /** The teams the employee and their spouse are on */
  teams: MpdStaffTeams;
  /** HCM's years of service as of the last HCM staff import. Counts service before joining staff, so it is not the years-on-staff a salary or goal calculation uses */
  tenure?: Maybe<Scalars['Int']['output']>;
  /** The employee's HCM user person type as of the last HCM staff import, the value the userPersonTypes filter matches */
  userPersonType?: Maybe<MpdUserPersonTypeEnum>;
};

/** The connection type for MpdManagedStaff. */
export type MpdManagedStaffConnection = {
  __typename?: 'MpdManagedStaffConnection';
  /** A list of edges. */
  edges: Array<MpdManagedStaffEdge>;
  /** A list of nodes. */
  nodes: Array<MpdManagedStaff>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total # of objects returned from this Plural Query */
  totalCount: Scalars['Int']['output'];
  /** Total # of pages, based on total count and pagesize */
  totalPageCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type MpdManagedStaffEdge = {
  __typename?: 'MpdManagedStaffEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<MpdManagedStaff>;
};

/** The teams a person is on */
export type MpdPersonTeam = {
  __typename?: 'MpdPersonTeam';
  /** The department of the team the person is on */
  department?: Maybe<Scalars['String']['output']>;
  /** The ID of the team the person is on */
  id?: Maybe<Scalars['String']['output']>;
  /** The name of the team the person is on */
  name: Scalars['String']['output'];
};

/** A team name a supervisor can filter their managed staff report by */
export type MpdStaffTeamOption = {
  __typename?: 'MpdStaffTeamOption';
  /** The departments of the staff on teams of this name, for narrowing the filter further. Staff with no department contribute none */
  departments: Array<Scalars['String']['output']>;
  /** The team name. Several teams sharing a name appear here once, and filtering by it reports the staff on all of them */
  name: Scalars['String']['output'];
};

/** The teams an employee and their spouse are on */
export type MpdStaffTeams = {
  __typename?: 'MpdStaffTeams';
  /** The teams the employee is on */
  employee: Array<MpdPersonTeam>;
  /** The teams the employee's spouse is on */
  spouse: Array<MpdPersonTeam>;
};

/** A completed month in the quarter a staff member started payroll */
export type MpdStartingQuarterMonthlyBreakdown = {
  __typename?: 'MpdStartingQuarterMonthlyBreakdown';
  /** The completed month in the quarter */
  month: Scalars['String']['output'];
  /** The payroll for the month */
  payroll: Scalars['Float']['output'];
  /** The month's health status */
  status: MpdHealthStatusEnum;
};

export enum MpdUserPersonTypeEnum {
  /** Employee - International Intern */
  EmployeeInternationalIntern = 'EMPLOYEE_INTERNATIONAL_INTERN',
  /** Employee - National Staff (Expat) */
  EmployeeNationalStaffExpat = 'EMPLOYEE_NATIONAL_STAFF_EXPAT',
  /** Employee - PTFS */
  EmployeePtfs = 'EMPLOYEE_PTFS',
  /** Employee - Staff */
  EmployeeStaff = 'EMPLOYEE_STAFF',
  /** Employee - Staff - non-RMO Spouse */
  EmployeeStaffNonRmoSpouse = 'EMPLOYEE_STAFF_NON_RMO_SPOUSE',
  /** Employee - US Intern */
  EmployeeUsIntern = 'EMPLOYEE_US_INTERN',
  /** Non-worker - National Staff */
  NonworkerNationalStaff = 'NONWORKER_NATIONAL_STAFF',
  /** Non-worker - NMBHR */
  NonworkerNmbhr = 'NONWORKER_NMBHR',
  /** Non-worker - Staff */
  NonworkerStaff = 'NONWORKER_STAFF',
  /** Non-worker - Staff Emeritus */
  NonworkerStaffEmeritus = 'NONWORKER_STAFF_EMERITUS',
  /** Non-worker - Volunteer */
  NonworkerVolunteer = 'NONWORKER_VOLUNTEER',
  /** Pending - International Intern */
  PendingInternationalIntern = 'PENDING_INTERNATIONAL_INTERN',
  /** Pending - PTFS */
  PendingPtfs = 'PENDING_PTFS',
  /** Pending - Staff */
  PendingStaff = 'PENDING_STAFF',
  /** Pending - Staff - non-RMO Spouse */
  PendingStaffNonRmoSpouse = 'PENDING_STAFF_NON_RMO_SPOUSE',
  /** Pending - US Intern */
  PendingUsIntern = 'PENDING_US_INTERN',
}

export type MultiselectFilter = Filter & {
  __typename?: 'MultiselectFilter';
  defaultSelection?: Maybe<Scalars['String']['output']>;
  filterKey: Scalars['String']['output'];
  options?: Maybe<Array<FilterOption>>;
  title: Scalars['String']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  acknowledgeAllUserNotifications?: Maybe<AcknowledgeAllUserNotificationsMutationPayload>;
  acknowledgeAnnouncement?: Maybe<AcknowledgeAnnouncementMutationPayload>;
  acknowledgeUserNotification?: Maybe<AcknowledgeUserNotificationMutationPayload>;
  adminDeleteOrganizationCoach: DeletionResponse;
  adminDeleteOrganizationInvite: DeletionResponse;
  adminDeleteOrganizationUser: DeletionResponse;
  anonymizeContact?: Maybe<ContactAnonymizeMutationPayload>;
  apiOauthSignIn?: Maybe<ApiOauthSignInMutationPayload>;
  assignCoachToNewStaffCohortAttendee?: Maybe<NewStaffCohortAttendeeAssignCoachMutationPayload>;
  assignContactsToAppeal?: Maybe<AssignContactsToAppealMutationPayload>;
  cancelAccountListInvite?: Maybe<CancelAccountListInvitePayload>;
  completeNewStaffQuestionnaire?: Maybe<NewStaffQuestionnaireCompleteMutationPayload>;
  createAccountListInvite?: Maybe<CreateAccountListInvitePayload>;
  createAccountListPledge?: Maybe<AccountListPledgeCreateMutationPayload>;
  createAdditionalSalaryRequest?: Maybe<AdditionalSalaryRequestCreateMutationPayload>;
  createAddress?: Maybe<AddressCreateMutationPayload>;
  createAppeal?: Maybe<AppealCreateMutationPayload>;
  createContact?: Maybe<ContactCreateMutationPayload>;
  createDesignationSupportCalculation?: Maybe<DesignationSupportCalculationCreateMutationPayload>;
  createDesignationSupportHoursItem?: Maybe<DesignationSupportHoursItemCreateMutationPayload>;
  createDonation?: Maybe<DonationCreateMutationPayload>;
  createGoalCalculation?: Maybe<GoalCalculationCreateMutationPayload>;
  createGoogleIntegration: GoogleAccountIntegration;
  createMinistryHousingAllowanceRequest?: Maybe<MinistryHousingAllowanceRequestCreateMutationPayload>;
  createNewStaffScenarioGoal?: Maybe<NewStaffScenarioGoalCreateMutationPayload>;
  createOrUpdateUserOption?: Maybe<CreateOrUpdateOptionMutationPayload>;
  createOrganizationAccount?: Maybe<OrganizationAccountCreateMutationPayload>;
  createOrganizationInvite: Invite;
  createPerson?: Maybe<PersonCreateMutationPayload>;
  createRecurringTransfer?: Maybe<RecurringTransferCreateMutationPayload>;
  createSalaryRequest?: Maybe<SalaryRequestCreateMutationPayload>;
  createSubBudgetCategory?: Maybe<SubBudgetCategoryCreateMutationPayload>;
  createTask?: Maybe<TaskCreateMutationPayload>;
  createTaskComment?: Maybe<TaskCommentCreateMutationPayload>;
  createTasks?: Maybe<TasksCreateMutationPayload>;
  createTransfer?: Maybe<TransferCreateMutationPayload>;
  deleteAccountListCoach?: Maybe<AccountListCoachDeleteMutationPayload>;
  deleteAccountListPledge?: Maybe<AccountListPledgeDeleteMutationPayload>;
  deleteAccountListUser?: Maybe<AccountListUserDeleteMutationPayload>;
  deleteAdditionalSalaryRequest?: Maybe<AdditionalSalaryRequestDeleteMutationPayload>;
  deleteAddress?: Maybe<AddressDeleteMutationPayload>;
  deleteAppeal?: Maybe<AppealDeleteMutationPayload>;
  deleteAppealContact?: Maybe<AppealContactDeleteMutationPayload>;
  deleteComment: CommentDeleteMutationPayload;
  deleteContact?: Maybe<ContactDeleteMutationPayload>;
  deleteDesignationSupportCalculation?: Maybe<DesignationSupportCalculationDeleteMutationPayload>;
  deleteDesignationSupportHoursItem?: Maybe<DesignationSupportHoursItemDeleteMutationPayload>;
  deleteDonation?: Maybe<DonationDeleteMutationPayload>;
  deleteGoalCalculation?: Maybe<GoalCalculationDeleteMutationPayload>;
  deleteGoogleAccount: DeletionResponse;
  deleteMailchimpAccount: DeletionResponse;
  deleteMinistryHousingAllowanceRequest?: Maybe<MinistryHousingAllowanceRequestDeleteMutationPayload>;
  deleteNewStaffScenarioGoal?: Maybe<NewStaffScenarioGoalDeleteMutationPayload>;
  deleteOrganizationAccount?: Maybe<OrganizationAccountDeleteMutationPayload>;
  deleteOrganizationContact: DeletionResponse;
  deletePerson?: Maybe<PersonDeleteMutationPayload>;
  deletePrayerlettersAccount: DeletionResponse;
  deleteRecurringTransfer?: Maybe<RecurringTransferDeleteMutationPayload>;
  deleteSalaryRequest?: Maybe<SalaryRequestDeleteMutationPayload>;
  deleteSubBudgetCategory?: Maybe<SubBudgetCategoryDeleteMutationPayload>;
  deleteTags?: Maybe<DeleteTagsPayload>;
  deleteTask?: Maybe<TaskDeleteMutationPayload>;
  deleteTasks?: Maybe<TasksDeleteMutationPayload>;
  deleteUser?: Maybe<UserDeleteMutationPayload>;
  deleteUserOption?: Maybe<UserOptionDeleteMutationPayload>;
  destroyDonorAccount?: Maybe<ContactDestroyDonorAccountPayload>;
  destroyOrganizationAdmin: DeletionResponse;
  destroyOrganizationInvite: DeletionResponse;
  duplicateMinistryHousingAllowanceRequest?: Maybe<DuplicateMinistryHousingAllowanceRequestMutationPayload>;
  exportContacts: Scalars['String']['output'];
  exportData: Scalars['String']['output'];
  mergeAccountList?: Maybe<AccountListMergeMutationPayload>;
  /** Returns the ids of the winner */
  mergeContacts: Array<Scalars['ID']['output']>;
  mergePeople?: Maybe<MergePeopleMutationPayload>;
  mergePeopleBulk: Array<Scalars['ID']['output']>;
  oktaSignIn?: Maybe<OktaSignInMutationPayload>;
  previewNewStaffGoalCalculation?: Maybe<NewStaffGoalCalculationPreviewMutationPayload>;
  printNewStaffCohortGoals?: Maybe<NewStaffCohortPrintGoalsMutationPayload>;
  resetAccountList?: Maybe<AccountListResetMutationPayload>;
  runAndSendNewStaffCohort?: Maybe<NewStaffCohortRunAndSendMutationPayload>;
  saveCoachingAnswer: CoachingAnswer;
  sendNewStaffScenarioGoal?: Maybe<NewStaffScenarioGoalSendMutationPayload>;
  sendToChalkline: Scalars['String']['output'];
  setActiveDesignationAccount: DesignationAccountRest;
  setActiveFinancialAccount: SetActiveFinancialAccountRest;
  setContactPrimaryAddress: ContactPrimaryAddress;
  submitAdditionalSalaryRequest?: Maybe<AdditionalSalaryRequestSubmitMutationPayload>;
  submitMinistryHousingAllowanceRequest?: Maybe<MinistryHousingAllowanceRequestSubmitMutationPayload>;
  submitSalaryRequest?: Maybe<SalaryRequestSubmitMutationPayload>;
  syncGoogleAccount?: Maybe<Scalars['String']['output']>;
  syncMailchimpAccount?: Maybe<Scalars['String']['output']>;
  syncOrganizationAccount?: Maybe<OrganizationAccountSyncMutationPayload>;
  syncPrayerlettersAccount?: Maybe<Scalars['String']['output']>;
  unassignCoachFromNewStaffCohortAttendee?: Maybe<NewStaffCohortAttendeeUnassignCoachMutationPayload>;
  updateAccountList?: Maybe<AccountListUpdateMutationPayload>;
  updateAccountListPledge?: Maybe<AccountListPledgeUpdateMutationPayload>;
  updateAdditionalSalaryRequest?: Maybe<AdditionalSalaryRequestUpdateMutationPayload>;
  updateAddress?: Maybe<AddressUpdateMutationPayload>;
  updateAppeal?: Maybe<AppealUpdateMutationPayload>;
  updateBudgetFamily?: Maybe<BudgetFamilyUpdateMutationPayload>;
  updateComment: CommentUpdateMutationPayload;
  updateContact?: Maybe<ContactUpdateMutationPayload>;
  updateContacts?: Maybe<ContactsUpdateMutationPayload>;
  updateDesignationSupportCalculation?: Maybe<DesignationSupportCalculationUpdateMutationPayload>;
  updateDesignationSupportHoursItem?: Maybe<DesignationSupportHoursItemUpdateMutationPayload>;
  updateDonation?: Maybe<DonationUpdateMutationPayload>;
  updateDonations?: Maybe<DonationsUpdateMutationPayload>;
  updateDuplicate?: Maybe<DuplicatesUpdateMutationPayload>;
  updateGoalCalculation?: Maybe<GoalCalculationUpdateMutationPayload>;
  updateGoogleIntegration: GoogleAccountIntegration;
  updateMailchimpAccount: MailchimpAccount;
  updateManagedStaffGeographicLocation?: Maybe<ManagedStaffGeographicLocationUpdateMutationPayload>;
  updateMinistryHousingAllowanceRequest?: Maybe<MinistryHousingAllowanceRequestUpdateMutationPayload>;
  /** Batch update ministry partner reminder statuses */
  updateMinistryPartnerReminders?: Maybe<UpdateMinistryPartnerRemindersPayload>;
  updateNewStaffCohort?: Maybe<NewStaffCohortUpdateMutationPayload>;
  updateNewStaffGoalCalculation?: Maybe<NewStaffGoalCalculationUpdateMutationPayload>;
  updateNewStaffQuestionnaire?: Maybe<NewStaffQuestionnaireUpdateMutationPayload>;
  updateNotificationPreferences?: Maybe<NotificationPreferencesUpdateMutationPayload>;
  updateOrganizationAccount?: Maybe<OrganizationAccountUpdateMutationPayload>;
  updatePeople?: Maybe<PeopleUpdateMutationPayload>;
  updatePerson?: Maybe<PersonUpdateMutationPayload>;
  updatePreference?: Maybe<UserPreferenceUpdateMutationPayload>;
  updatePrimaryBudgetCategory?: Maybe<PrimaryBudgetCategoryUpdateMutationPayload>;
  updateRecurringTransfer?: Maybe<RecurringTransferUpdateMutationPayload>;
  updateSalaryRequest?: Maybe<SalaryRequestUpdateMutationPayload>;
  updateSubBudgetCategory?: Maybe<SubBudgetCategoryUpdateMutationPayload>;
  updateTask?: Maybe<TaskUpdateMutationPayload>;
  updateTasks?: Maybe<TasksUpdateMutationPayload>;
  updateUser?: Maybe<UserUpdateMutationPayload>;
  updateUserGeographicLocation?: Maybe<UserGeographicLocationUpdateMutationPayload>;
  userKeySignIn?: Maybe<UserKeySignInMutationPayload>;
};

export type MutationAcknowledgeAllUserNotificationsArgs = {
  input: AcknowledgeAllUserNotificationsMutationInput;
};

export type MutationAcknowledgeAnnouncementArgs = {
  input: AcknowledgeAnnouncementMutationInput;
};

export type MutationAcknowledgeUserNotificationArgs = {
  input: AcknowledgeUserNotificationMutationInput;
};

export type MutationAdminDeleteOrganizationCoachArgs = {
  input: AdminDeleteOrganizationCoachInput;
};

export type MutationAdminDeleteOrganizationInviteArgs = {
  input: AdminDeleteOrganizationInviteInput;
};

export type MutationAdminDeleteOrganizationUserArgs = {
  input: AdminDeleteOrganizationUserInput;
};

export type MutationAnonymizeContactArgs = {
  input: ContactAnonymizeMutationInput;
};

export type MutationApiOauthSignInArgs = {
  input: ApiOauthSignInMutationInput;
};

export type MutationAssignCoachToNewStaffCohortAttendeeArgs = {
  input: NewStaffCohortAttendeeAssignCoachMutationInput;
};

export type MutationAssignContactsToAppealArgs = {
  input: AssignContactsToAppealMutationInput;
};

export type MutationCancelAccountListInviteArgs = {
  input: CancelAccountListInviteInput;
};

export type MutationCompleteNewStaffQuestionnaireArgs = {
  input: NewStaffQuestionnaireCompleteMutationInput;
};

export type MutationCreateAccountListInviteArgs = {
  input: CreateAccountListInviteInput;
};

export type MutationCreateAccountListPledgeArgs = {
  input: AccountListPledgeCreateMutationInput;
};

export type MutationCreateAdditionalSalaryRequestArgs = {
  input: AdditionalSalaryRequestCreateMutationInput;
};

export type MutationCreateAddressArgs = {
  input: AddressCreateMutationInput;
};

export type MutationCreateAppealArgs = {
  input: AppealCreateMutationInput;
};

export type MutationCreateContactArgs = {
  input: ContactCreateMutationInput;
};

export type MutationCreateDesignationSupportCalculationArgs = {
  input: DesignationSupportCalculationCreateMutationInput;
};

export type MutationCreateDesignationSupportHoursItemArgs = {
  input: DesignationSupportHoursItemCreateMutationInput;
};

export type MutationCreateDonationArgs = {
  input: DonationCreateMutationInput;
};

export type MutationCreateGoalCalculationArgs = {
  input: GoalCalculationCreateMutationInput;
};

export type MutationCreateGoogleIntegrationArgs = {
  input: CreateGoogleIntegrationInput;
};

export type MutationCreateMinistryHousingAllowanceRequestArgs = {
  input: MinistryHousingAllowanceRequestCreateMutationInput;
};

export type MutationCreateNewStaffScenarioGoalArgs = {
  input: NewStaffScenarioGoalCreateMutationInput;
};

export type MutationCreateOrUpdateUserOptionArgs = {
  input: CreateOrUpdateOptionMutationInput;
};

export type MutationCreateOrganizationAccountArgs = {
  input: OrganizationAccountCreateMutationInput;
};

export type MutationCreateOrganizationInviteArgs = {
  input: CreateOrganizationInviteInput;
};

export type MutationCreatePersonArgs = {
  input: PersonCreateMutationInput;
};

export type MutationCreateRecurringTransferArgs = {
  input: RecurringTransferCreateMutationInput;
};

export type MutationCreateSalaryRequestArgs = {
  input: SalaryRequestCreateMutationInput;
};

export type MutationCreateSubBudgetCategoryArgs = {
  input: SubBudgetCategoryCreateMutationInput;
};

export type MutationCreateTaskArgs = {
  input: TaskCreateMutationInput;
};

export type MutationCreateTaskCommentArgs = {
  input: TaskCommentCreateMutationInput;
};

export type MutationCreateTasksArgs = {
  input: TasksCreateMutationInput;
};

export type MutationCreateTransferArgs = {
  input: TransferCreateMutationInput;
};

export type MutationDeleteAccountListCoachArgs = {
  input: AccountListCoachDeleteMutationInput;
};

export type MutationDeleteAccountListPledgeArgs = {
  input: AccountListPledgeDeleteMutationInput;
};

export type MutationDeleteAccountListUserArgs = {
  input: AccountListUserDeleteMutationInput;
};

export type MutationDeleteAdditionalSalaryRequestArgs = {
  input: AdditionalSalaryRequestDeleteMutationInput;
};

export type MutationDeleteAddressArgs = {
  input: AddressDeleteMutationInput;
};

export type MutationDeleteAppealArgs = {
  input: AppealDeleteMutationInput;
};

export type MutationDeleteAppealContactArgs = {
  input: AppealContactDeleteMutationInput;
};

export type MutationDeleteCommentArgs = {
  input: CommentDeleteMutationInput;
};

export type MutationDeleteContactArgs = {
  input: ContactDeleteMutationInput;
};

export type MutationDeleteDesignationSupportCalculationArgs = {
  input: DesignationSupportCalculationDeleteMutationInput;
};

export type MutationDeleteDesignationSupportHoursItemArgs = {
  input: DesignationSupportHoursItemDeleteMutationInput;
};

export type MutationDeleteDonationArgs = {
  input: DonationDeleteMutationInput;
};

export type MutationDeleteGoalCalculationArgs = {
  input: GoalCalculationDeleteMutationInput;
};

export type MutationDeleteGoogleAccountArgs = {
  input: DeleteGoogleAccountInput;
};

export type MutationDeleteMailchimpAccountArgs = {
  input: DeleteMailchimpAccountInput;
};

export type MutationDeleteMinistryHousingAllowanceRequestArgs = {
  input: MinistryHousingAllowanceRequestDeleteMutationInput;
};

export type MutationDeleteNewStaffScenarioGoalArgs = {
  input: NewStaffScenarioGoalDeleteMutationInput;
};

export type MutationDeleteOrganizationAccountArgs = {
  input: OrganizationAccountDeleteMutationInput;
};

export type MutationDeleteOrganizationContactArgs = {
  input: DeleteOrganizationContactInput;
};

export type MutationDeletePersonArgs = {
  input: PersonDeleteMutationInput;
};

export type MutationDeletePrayerlettersAccountArgs = {
  input: DeletePrayerlettersAccountInput;
};

export type MutationDeleteRecurringTransferArgs = {
  input: RecurringTransferDeleteMutationInput;
};

export type MutationDeleteSalaryRequestArgs = {
  input: SalaryRequestDeleteMutationInput;
};

export type MutationDeleteSubBudgetCategoryArgs = {
  input: SubBudgetCategoryDeleteMutationInput;
};

export type MutationDeleteTagsArgs = {
  input: DeleteTagsInput;
};

export type MutationDeleteTaskArgs = {
  input: TaskDeleteMutationInput;
};

export type MutationDeleteTasksArgs = {
  input: TasksDeleteMutationInput;
};

export type MutationDeleteUserArgs = {
  input: UserDeleteMutationInput;
};

export type MutationDeleteUserOptionArgs = {
  input: UserOptionDeleteMutationInput;
};

export type MutationDestroyDonorAccountArgs = {
  input: ContactDestroyDonorAccountInput;
};

export type MutationDestroyOrganizationAdminArgs = {
  input: DeleteOrganizationAdminInput;
};

export type MutationDestroyOrganizationInviteArgs = {
  input: DeleteOrganizationInviteInput;
};

export type MutationDuplicateMinistryHousingAllowanceRequestArgs = {
  input: DuplicateMinistryHousingAllowanceRequestMutationInput;
};

export type MutationExportContactsArgs = {
  input: ExportContactsInput;
};

export type MutationExportDataArgs = {
  input: ExportDataInput;
};

export type MutationMergeAccountListArgs = {
  input: AccountListMergeMutationInput;
};

export type MutationMergeContactsArgs = {
  input: MergeContactsInput;
};

export type MutationMergePeopleArgs = {
  input: MergePeopleMutationInput;
};

export type MutationMergePeopleBulkArgs = {
  input: MergePeopleBulkInput;
};

export type MutationOktaSignInArgs = {
  input: OktaSignInMutationInput;
};

export type MutationPreviewNewStaffGoalCalculationArgs = {
  input: NewStaffGoalCalculationPreviewMutationInput;
};

export type MutationPrintNewStaffCohortGoalsArgs = {
  input: NewStaffCohortPrintGoalsMutationInput;
};

export type MutationResetAccountListArgs = {
  input: AccountListResetMutationInput;
};

export type MutationRunAndSendNewStaffCohortArgs = {
  input: NewStaffCohortRunAndSendMutationInput;
};

export type MutationSaveCoachingAnswerArgs = {
  input: SaveCoachingAnswerInput;
};

export type MutationSendNewStaffScenarioGoalArgs = {
  input: NewStaffScenarioGoalSendMutationInput;
};

export type MutationSendToChalklineArgs = {
  input: SendToChalklineInput;
};

export type MutationSetActiveDesignationAccountArgs = {
  input: SetActiveDesignationAccountInput;
};

export type MutationSetActiveFinancialAccountArgs = {
  input: SetActiveFinancialAccountInput;
};

export type MutationSetContactPrimaryAddressArgs = {
  input: ContactPrimaryAddressInput;
};

export type MutationSubmitAdditionalSalaryRequestArgs = {
  input: AdditionalSalaryRequestSubmitMutationInput;
};

export type MutationSubmitMinistryHousingAllowanceRequestArgs = {
  input: MinistryHousingAllowanceRequestSubmitMutationInput;
};

export type MutationSubmitSalaryRequestArgs = {
  input: SalaryRequestSubmitMutationInput;
};

export type MutationSyncGoogleAccountArgs = {
  input: SyncGoogleAccountInput;
};

export type MutationSyncMailchimpAccountArgs = {
  input: SyncMailchimpAccountInput;
};

export type MutationSyncOrganizationAccountArgs = {
  input: OrganizationAccountSyncMutationInput;
};

export type MutationSyncPrayerlettersAccountArgs = {
  input: SyncPrayerlettersAccountInput;
};

export type MutationUnassignCoachFromNewStaffCohortAttendeeArgs = {
  input: NewStaffCohortAttendeeUnassignCoachMutationInput;
};

export type MutationUpdateAccountListArgs = {
  input: AccountListUpdateMutationInput;
};

export type MutationUpdateAccountListPledgeArgs = {
  input: AccountListPledgeUpdateMutationInput;
};

export type MutationUpdateAdditionalSalaryRequestArgs = {
  input: AdditionalSalaryRequestUpdateMutationInput;
};

export type MutationUpdateAddressArgs = {
  input: AddressUpdateMutationInput;
};

export type MutationUpdateAppealArgs = {
  input: AppealUpdateMutationInput;
};

export type MutationUpdateBudgetFamilyArgs = {
  input: BudgetFamilyUpdateMutationInput;
};

export type MutationUpdateCommentArgs = {
  input: CommentUpdateMutationInput;
};

export type MutationUpdateContactArgs = {
  input: ContactUpdateMutationInput;
};

export type MutationUpdateContactsArgs = {
  input: ContactsUpdateMutationInput;
};

export type MutationUpdateDesignationSupportCalculationArgs = {
  input: DesignationSupportCalculationUpdateMutationInput;
};

export type MutationUpdateDesignationSupportHoursItemArgs = {
  input: DesignationSupportHoursItemUpdateMutationInput;
};

export type MutationUpdateDonationArgs = {
  input: DonationUpdateMutationInput;
};

export type MutationUpdateDonationsArgs = {
  input: DonationsUpdateMutationInput;
};

export type MutationUpdateDuplicateArgs = {
  input: DuplicatesUpdateMutationInput;
};

export type MutationUpdateGoalCalculationArgs = {
  input: GoalCalculationUpdateMutationInput;
};

export type MutationUpdateGoogleIntegrationArgs = {
  input: UpdateGoogleIntegrationInput;
};

export type MutationUpdateMailchimpAccountArgs = {
  input: UpdateMailchimpAccountInput;
};

export type MutationUpdateManagedStaffGeographicLocationArgs = {
  input: ManagedStaffGeographicLocationUpdateMutationInput;
};

export type MutationUpdateMinistryHousingAllowanceRequestArgs = {
  input: MinistryHousingAllowanceRequestUpdateMutationInput;
};

export type MutationUpdateMinistryPartnerRemindersArgs = {
  input: UpdateMinistryPartnerRemindersInput;
};

export type MutationUpdateNewStaffCohortArgs = {
  input: NewStaffCohortUpdateMutationInput;
};

export type MutationUpdateNewStaffGoalCalculationArgs = {
  input: NewStaffGoalCalculationUpdateMutationInput;
};

export type MutationUpdateNewStaffQuestionnaireArgs = {
  input: NewStaffQuestionnaireUpdateMutationInput;
};

export type MutationUpdateNotificationPreferencesArgs = {
  input: NotificationPreferencesUpdateMutationInput;
};

export type MutationUpdateOrganizationAccountArgs = {
  input: OrganizationAccountUpdateMutationInput;
};

export type MutationUpdatePeopleArgs = {
  input: PeopleUpdateMutationInput;
};

export type MutationUpdatePersonArgs = {
  input: PersonUpdateMutationInput;
};

export type MutationUpdatePreferenceArgs = {
  input: UserPreferenceUpdateMutationInput;
};

export type MutationUpdatePrimaryBudgetCategoryArgs = {
  input: PrimaryBudgetCategoryUpdateMutationInput;
};

export type MutationUpdateRecurringTransferArgs = {
  input: RecurringTransferUpdateMutationInput;
};

export type MutationUpdateSalaryRequestArgs = {
  input: SalaryRequestUpdateMutationInput;
};

export type MutationUpdateSubBudgetCategoryArgs = {
  input: SubBudgetCategoryUpdateMutationInput;
};

export type MutationUpdateTaskArgs = {
  input: TaskUpdateMutationInput;
};

export type MutationUpdateTasksArgs = {
  input: TasksUpdateMutationInput;
};

export type MutationUpdateUserArgs = {
  input: UserUpdateMutationInput;
};

export type MutationUpdateUserGeographicLocationArgs = {
  input: UserGeographicLocationUpdateMutationInput;
};

export type MutationUserKeySignInArgs = {
  input: UserKeySignInMutationInput;
};

/** A new-staff training group (e.g. "Fall NSO 2026") and its per-cohort training costs */
export type NewStaffCohort = {
  __typename?: 'NewStaffCohort';
  /** Active (non-withdrawn) attendee households this viewer may see */
  attendees: NewStaffCohortAttendeeConnection;
  /** True when no blockers prevent Run & Send for this cohort */
  canRunAndSend: Scalars['Boolean']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Per-household training cost in USD; null until an admin provides it */
  cruConferenceCoupleCost?: Maybe<Scalars['Float']['output']>;
  /** Per-household training cost in USD; null until an admin provides it */
  cruConferenceFamilyCost?: Maybe<Scalars['Float']['output']>;
  /** Per-household training cost in USD; null until an admin provides it */
  cruConferenceSingleCost?: Maybe<Scalars['Float']['output']>;
  /** Training start date, when known */
  date?: Maybe<Scalars['ISO8601Date']['output']>;
  /** Per-household training cost in USD; null until an admin provides it */
  faithAndFinanceCoupleCost?: Maybe<Scalars['Float']['output']>;
  /** Per-household training cost in USD; null until an admin provides it */
  faithAndFinanceSingleCost?: Maybe<Scalars['Float']['output']>;
  /** When this cohort's most recent Run & Send batch completed; null until the first send */
  goalsSentAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** True once every training cost below has been provided */
  hasTrainingCosts: Scalars['Boolean']['output'];
  /** Per-household training cost in USD; null until an admin provides it */
  ibsCoupleCost?: Maybe<Scalars['Float']['output']>;
  /** Per-household training cost in USD; null until an admin provides it */
  ibsSingleCost?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  /** Active households whose goal is still Incomplete this viewer may see; drives the Run & Send confirm modal */
  incompleteAttendees: Array<NewStaffCohortAttendee>;
  /** Display name for dropdowns, e.g. "Fall NSO 2026" */
  name: Scalars['String']['output'];
  /** Per-household training cost in USD; null until an admin provides it */
  nsoCoupleCost?: Maybe<Scalars['Float']['output']>;
  /** Per-household training cost in USD; null until an admin provides it */
  nsoFamilyCost?: Maybe<Scalars['Float']['output']>;
  /** Per-household training cost in USD; null until an admin provides it */
  nsoIndividual1InRoomCost?: Maybe<Scalars['Float']['output']>;
  /** Per-household training cost in USD; null until an admin provides it */
  nsoIndividual2InRoomCost?: Maybe<Scalars['Float']['output']>;
  /** Per-household training cost in USD; null until an admin provides it */
  refreshRetreatCoupleCost?: Maybe<Scalars['Float']['output']>;
  /** Per-household training cost in USD; null until an admin provides it */
  refreshRetreatSingleCost?: Maybe<Scalars['Float']['output']>;
  /** Machine-readable reasons Run & Send is blocked; empty when ready */
  runAndSendBlockers: Array<NewStaffCohortRunAndSendBlockerEnum>;
  /** Training name without the year, e.g. "Fall NSO" */
  trainingName: Scalars['String']['output'];
  /** Count of active (non-withdrawn) attendee households this viewer may see */
  trainingSize: Scalars['Int']['output'];
  /** Training year, e.g. 2026 */
  trainingYear: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** A new-staff training group (e.g. "Fall NSO 2026") and its per-cohort training costs */
export type NewStaffCohortAttendeesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<NewStaffCohortAttendeeSortEnum>;
};

/** One household attending a new-staff training cohort, as listed in the MPD Goal admin table */
export type NewStaffCohortAttendee = {
  __typename?: 'NewStaffCohortAttendee';
  /** The household's account list */
  accountListId: Scalars['ID']['output'];
  /** True when the current user may change this household's coach; false for coaches */
  canEditCoach: Scalars['Boolean']['output'];
  /** The official goals-team-assigned MPD coach; null until assigned */
  coach?: Maybe<NewStaffCohortAttendeeCoach>;
  /** Training the household attends, e.g. "Fall NSO 2026" */
  cohortName: Scalars['String']['output'];
  /** MPD coordinator names, resolved dynamically from OneApp roles; not yet populated */
  coordinators: Array<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Couple-aware household name, e.g. "Jo & Amy Smith" */
  displayName: Scalars['String']['output'];
  /** Single / married / SOSA from the goal calculation or questionnaire; null before the survey */
  familyStatus?: Maybe<NewStaffQuestionnaireMaritalStatusEnum>;
  /** City/state of assignment, from the goal calculation */
  geographicLocation?: Maybe<Scalars['String']['output']>;
  /** Machine-readable reasons the goal is still Incomplete; empty otherwise */
  goalMissingFields: Array<NewStaffCohortAttendeeGoalMissingFieldEnum>;
  /** When this household's goal was run & sent; null until then */
  goalSentAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Admin-table chip: INCOMPLETE until every requirement is met, then COMPLETE, then SENT */
  goalStatus: NewStaffCohortAttendeeGoalStatusEnum;
  id: Scalars['ID']['output'];
  /** The OneApp ministry the household is joining */
  ministry?: Maybe<Ministry>;
  /** Cohort the household attends, which the coach mutations scope by */
  newStaffCohortId: Scalars['ID']['output'];
  /** The household's goal calculation (id + monthlyGoal only; see NewStaffGoalCalculationQuery for the full calculation); null until the survey completes */
  newStaffGoalCalculation?: Maybe<NewStaffCohortAttendeeGoalCalculation>;
  /** Survey progress, driving the admin table's "Pending Survey" cells */
  questionnaireState: NewStaffCohortAttendeeQuestionnaireStateEnum;
  /** Whether the household is still attending or has withdrawn (the attendees connection currently returns active rows only) */
  status: NewStaffCohortAttendeeStatusEnum;
  /** Free-text sub-ministry from OneApp; doubles as the campus-ministry cohort/region (division) */
  subministry?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Autogenerated input type of NewStaffCohortAttendeeAssignCoachMutation */
export type NewStaffCohortAttendeeAssignCoachMutationInput = {
  /** Households to assign the coach to, at most 200; an id that is no longer an active household of the cohort is skipped, so read assignedCount */
  attendeeIds: Array<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The coach to assign, from newStaffCohortAssignableCoaches; an id that query does not offer is rejected */
  coachId: Scalars['ID']['input'];
  /** Cohort the households belong to */
  cohortId: Scalars['ID']['input'];
};

/** Autogenerated return type of NewStaffCohortAttendeeAssignCoachMutation. */
export type NewStaffCohortAttendeeAssignCoachMutationPayload = {
  __typename?: 'NewStaffCohortAttendeeAssignCoachMutationPayload';
  /** How many of the households named this batch assigned, counting a repeated id once */
  assignedCount: Scalars['Int']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The updated households, so the admin table can refresh in place */
  newStaffCohortAttendees: Array<NewStaffCohortAttendee>;
};

/** The goals-team-assigned MPD coach shown in the admin table (name and contact email only) */
export type NewStaffCohortAttendeeCoach = {
  __typename?: 'NewStaffCohortAttendeeCoach';
  /** The coach's email address (primary, falling back to the first on file) */
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
};

/** The connection type for NewStaffCohortAttendee. */
export type NewStaffCohortAttendeeConnection = {
  __typename?: 'NewStaffCohortAttendeeConnection';
  /** A list of edges. */
  edges: Array<NewStaffCohortAttendeeEdge>;
  /** A list of nodes. */
  nodes: Array<NewStaffCohortAttendee>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total # of objects returned from this Plural Query */
  totalCount: Scalars['Int']['output'];
  /** Total # of pages, based on total count and pagesize */
  totalPageCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type NewStaffCohortAttendeeEdge = {
  __typename?: 'NewStaffCohortAttendeeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<NewStaffCohortAttendee>;
};

/** The goal calculation shown in the admin table (id + computed monthly goal only) */
export type NewStaffCohortAttendeeGoalCalculation = {
  __typename?: 'NewStaffCohortAttendeeGoalCalculation';
  id: Scalars['ID']['output'];
  /** Line 16. Total monthly goal, from the computed calculation worksheet */
  monthlyGoal: Scalars['Float']['output'];
};

export enum NewStaffCohortAttendeeGoalMissingFieldEnum {
  /** The goal calculation is missing an age */
  Age = 'AGE',
  /** The goal calculation is missing a benefits plan */
  BenefitsPlan = 'BENEFITS_PLAN',
  /** The goal calculation is missing its goal year */
  CalculationsYear = 'CALCULATIONS_YEAR',
  /** The household's account list has no staff designation number yet */
  DesignationNumber = 'DESIGNATION_NUMBER',
  /** The goal calculation is missing a marital status */
  MaritalStatus = 'MARITAL_STATUS',
  /** The goal calculation is missing a first or last name */
  Name = 'NAME',
  /** No goal calculation exists for this household yet (normally created when the questionnaire is completed) */
  Questionnaire = 'QUESTIONNAIRE',
  /** The goal calculation is missing a role (field or office) */
  Role = 'ROLE',
  /** The goal calculation is missing the spouse's age */
  SpouseAge = 'SPOUSE_AGE',
  /** The goal calculation is missing the spouse's full-time years on staff */
  SpouseTenure = 'SPOUSE_TENURE',
  /** The goal calculation is missing full-time years on staff */
  Tenure = 'TENURE',
  /** The cohort is missing one or more training costs */
  TrainingCostsMissing = 'TRAINING_COSTS_MISSING',
  /** The goal calculation is missing a work location (city of assignment) */
  WorkLocation = 'WORK_LOCATION',
}

export enum NewStaffCohortAttendeeGoalStatusEnum {
  /** Every requirement is met; the goal is ready to run & send */
  Complete = 'COMPLETE',
  /** The goal cannot be run & sent yet; see goalMissingFields for why */
  Incomplete = 'INCOMPLETE',
  /** The household's goal has been run & sent (goalSentAt records when) */
  Sent = 'SENT',
}

export enum NewStaffCohortAttendeeQuestionnaireStateEnum {
  /** The questionnaire was submitted, creating the goal calculation */
  Completed = 'COMPLETED',
  /** The questionnaire exists but has not been submitted */
  InProgress = 'IN_PROGRESS',
  /** No questionnaire exists yet (admin table renders "Pending Survey") */
  None = 'NONE',
}

export enum NewStaffCohortAttendeeSortEnum {
  /** Household name A to Z (the default) */
  NameAsc = 'NAME_ASC',
  /** Household name Z to A */
  NameDesc = 'NAME_DESC',
}

export enum NewStaffCohortAttendeeStatusEnum {
  /** Attending the cohort (the admin table default) */
  Active = 'ACTIVE',
  /** Withdrawn from the cohort; kept so re-approval can reactivate the same row */
  Withdrawn = 'WITHDRAWN',
}

/** Autogenerated input type of NewStaffCohortAttendeeUnassignCoachMutation */
export type NewStaffCohortAttendeeUnassignCoachMutationInput = {
  /** Households to remove the coach from, at most 200; all-or-nothing, so an unknown or withdrawn id unassigns nobody */
  attendeeIds: Array<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Cohort the households belong to */
  cohortId: Scalars['ID']['input'];
};

/** Autogenerated return type of NewStaffCohortAttendeeUnassignCoachMutation. */
export type NewStaffCohortAttendeeUnassignCoachMutationPayload = {
  __typename?: 'NewStaffCohortAttendeeUnassignCoachMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The updated households, so the admin table can refresh in place */
  newStaffCohortAttendees: Array<NewStaffCohortAttendee>;
};

/** Editable cohort fields from the "Training Costs for {training}" modal */
export type NewStaffCohortAttributesInput = {
  /** Per-household training cost in USD */
  cruConferenceCoupleCost?: InputMaybe<Scalars['PositiveFloat']['input']>;
  /** Per-household training cost in USD */
  cruConferenceFamilyCost?: InputMaybe<Scalars['PositiveFloat']['input']>;
  /** Per-household training cost in USD */
  cruConferenceSingleCost?: InputMaybe<Scalars['PositiveFloat']['input']>;
  /** Training start date */
  date?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Per-household training cost in USD */
  faithAndFinanceCoupleCost?: InputMaybe<Scalars['PositiveFloat']['input']>;
  /** Per-household training cost in USD */
  faithAndFinanceSingleCost?: InputMaybe<Scalars['PositiveFloat']['input']>;
  /** Per-household training cost in USD */
  ibsCoupleCost?: InputMaybe<Scalars['PositiveFloat']['input']>;
  /** Per-household training cost in USD */
  ibsSingleCost?: InputMaybe<Scalars['PositiveFloat']['input']>;
  /** Per-household training cost in USD */
  nsoCoupleCost?: InputMaybe<Scalars['PositiveFloat']['input']>;
  /** Per-household training cost in USD */
  nsoFamilyCost?: InputMaybe<Scalars['PositiveFloat']['input']>;
  /** Per-household training cost in USD */
  nsoIndividual1InRoomCost?: InputMaybe<Scalars['PositiveFloat']['input']>;
  /** Per-household training cost in USD */
  nsoIndividual2InRoomCost?: InputMaybe<Scalars['PositiveFloat']['input']>;
  /** Per-household training cost in USD */
  refreshRetreatCoupleCost?: InputMaybe<Scalars['PositiveFloat']['input']>;
  /** Per-household training cost in USD */
  refreshRetreatSingleCost?: InputMaybe<Scalars['PositiveFloat']['input']>;
};

/** The connection type for NewStaffCohort. */
export type NewStaffCohortConnection = {
  __typename?: 'NewStaffCohortConnection';
  /** A list of edges. */
  edges: Array<NewStaffCohortEdge>;
  /** A list of nodes. */
  nodes: Array<NewStaffCohort>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total # of objects returned from this Plural Query */
  totalCount: Scalars['Int']['output'];
  /** Total # of pages, based on total count and pagesize */
  totalPageCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type NewStaffCohortEdge = {
  __typename?: 'NewStaffCohortEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<NewStaffCohort>;
};

/** Autogenerated input type of NewStaffCohortPrintGoalsMutation */
export type NewStaffCohortPrintGoalsMutationInput = {
  /** Households to print. Omit the key entirely to print every active household in the cohort; passing null is treated the same as omitting it. */
  attendeeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Cohort whose goals should be printed */
  cohortId: Scalars['ID']['input'];
};

/** Autogenerated return type of NewStaffCohortPrintGoalsMutation. */
export type NewStaffCohortPrintGoalsMutationPayload = {
  __typename?: 'NewStaffCohortPrintGoalsMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Single-use URL for the printed document; null when nothing was printable. This endpoint has no cookie session -- the caller must fetch it with the current user's Authorization header attached and save the returned blob. The URL also accepts the token via an access_token query param, but do not use that path: it would put a full-account JWT in browser history, bookmarks, the Referer header, and proxy logs. */
  downloadUrl?: Maybe<Scalars['String']['output']>;
  newStaffCohort: NewStaffCohort;
  /** Goals included in the document. Scoped to attendeeIds when one is given, rather than the full training; a withdrawn household counts toward neither this nor skippedCount. */
  printedCount: Scalars['Int']['output'];
  /** Households with no goal calculation to print. Scoped to attendeeIds when one is given, rather than the full training; a withdrawn household counts toward neither this nor printedCount. */
  skippedCount: Scalars['Int']['output'];
};

export enum NewStaffCohortRunAndSendBlockerEnum {
  /** The cohort is missing one or more training costs */
  TrainingCostsMissing = 'TRAINING_COSTS_MISSING',
}

/** Autogenerated input type of NewStaffCohortRunAndSendMutation */
export type NewStaffCohortRunAndSendMutationInput = {
  /** Households to send. Omit the key entirely to send every complete goal in the cohort; passing null is treated the same as omitting it. */
  attendeeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Cohort whose complete goals should be run & sent */
  cohortId: Scalars['ID']['input'];
};

/** Autogenerated return type of NewStaffCohortRunAndSendMutation. */
export type NewStaffCohortRunAndSendMutationPayload = {
  __typename?: 'NewStaffCohortRunAndSendMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  newStaffCohort: NewStaffCohort;
  /** This batch's timestamp; null when nothing was eligible */
  sentAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** How many households were sent by this batch */
  sentCount: Scalars['Int']['output'];
};

/** Autogenerated input type of NewStaffCohortUpdateMutation */
export type NewStaffCohortUpdateMutationInput = {
  /** Training costs and date to save */
  attributes: NewStaffCohortAttributesInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Cohort to update */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of NewStaffCohortUpdateMutation. */
export type NewStaffCohortUpdateMutationPayload = {
  __typename?: 'NewStaffCohortUpdateMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  newStaffCohort: NewStaffCohort;
};

export type NewStaffGoalCalculation = {
  __typename?: 'NewStaffGoalCalculation';
  /** Account transfers */
  accountTransfers?: Maybe<Scalars['Float']['output']>;
  /** Home address (prepopulated from HCM) */
  address?: Maybe<Scalars['String']['output']>;
  /** Advocacy transfers */
  advocacyTransfers?: Maybe<Scalars['Float']['output']>;
  /** Age range (prepopulated from HCM) */
  age?: Maybe<GoalCalculationAge>;
  /** Whether debt is allowed over the cap */
  allowDebtOverCap?: Maybe<Scalars['Boolean']['output']>;
  /** Over-cap salary approval tier */
  allowSalaryOverCap?: Maybe<NewStaffGoalCalculationSalaryOverCapEnum>;
  /** Requested annual salary */
  annualRequestedSalary?: Maybe<Scalars['Float']['output']>;
  /** Whether the assignment is field- or office-based */
  assignmentType?: Maybe<GoalCalculationRole>;
  /** Benefits plan selection */
  benefitsPlan?: Maybe<MpdGoalBenefitsConstantPlanEnum>;
  /** Computed goal calculation worksheet for this calculation */
  calculations: NewStaffGoalCalculationCalculations;
  /** Which year-versioned constants set the goal is calculated against */
  calculationsYear?: Maybe<Scalars['Int']['output']>;
  /** Monthly car loan payment */
  carLoanMonthlyPayment?: Maybe<Scalars['Float']['output']>;
  /** Number of children needing childcare */
  childcareChildrenCount?: Maybe<Scalars['Int']['output']>;
  /** 403(b) contribution percentage */
  contribution403bPercentage?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Monthly credit card debt payment */
  creditCardDebtMonthlyPayment?: Maybe<Scalars['Float']['output']>;
  /** Email address */
  emailAddress?: Maybe<Scalars['String']['output']>;
  /** First name */
  firstName?: Maybe<Scalars['String']['output']>;
  /** City of assignment */
  geographicLocation?: Maybe<Scalars['String']['output']>;
  /** Number of healthcare dependents */
  healthcareDependentsCount?: Maybe<Scalars['Int']['output']>;
  /** Whether healthcare is exempt */
  healthcareExempt?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  /** Year the staff member joined staff */
  joinedStaffYear?: Maybe<Scalars['Int']['output']>;
  /** Last name */
  lastName?: Maybe<Scalars['String']['output']>;
  /** Marital status, verified by the staff member (prepopulated from HCM) */
  maritalStatus: NewStaffQuestionnaireMaritalStatusEnum;
  /** Ministry location */
  ministryLocation?: Maybe<Scalars['String']['output']>;
  /** Ministry name */
  ministryName?: Maybe<Scalars['String']['output']>;
  /** The cohort household this calculation belongs to; null for scenario goals and for users viewing their own goal */
  newStaffCohortAttendee?: Maybe<NewStaffCohortAttendee>;
  /** New Staff Orientation housing arrangement */
  nsoHousing?: Maybe<NewStaffQuestionnaireNsoHousingEnum>;
  /** Which New Staff Orientation sessions the staff member will attend */
  nsoSessions?: Maybe<NewStaffQuestionnaireNsoSessionsEnum>;
  /** Special-needs support received toward New Staff Orientation */
  nsoSpecialNeedsSupportReceived?: Maybe<Scalars['Float']['output']>;
  /** Other monthly expenses (worksheet line 13) */
  otherExpenses?: Maybe<Scalars['Float']['output']>;
  /** Staff member's HCM person number */
  personNumber?: Maybe<Scalars['String']['output']>;
  /** Cell phone number */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** Whether the staff member is exempt from SECA */
  secaExempt?: Maybe<Scalars['Boolean']['output']>;
  /** Spouse's age range (prepopulated from HCM) */
  spouseAge?: Maybe<GoalCalculationAge>;
  /** Spouse's 403(b) contribution percentage */
  spouseContribution403bPercentage?: Maybe<Scalars['Float']['output']>;
  /** Spouse's email address */
  spouseEmailAddress?: Maybe<Scalars['String']['output']>;
  /** Spouse's first name */
  spouseFirstName?: Maybe<Scalars['String']['output']>;
  /** Whether the spouse's healthcare is exempt */
  spouseHealthcareExempt?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the spouse is joining staff (prepopulated from HCM) */
  spouseJoining?: Maybe<Scalars['Boolean']['output']>;
  /** Ministry housing allowance the spouse has taken */
  spouseMhaAmount?: Maybe<Scalars['Float']['output']>;
  /** Spouse's HCM person number */
  spousePersonNumber?: Maybe<Scalars['String']['output']>;
  /** Spouse's cell phone number */
  spousePhoneNumber?: Maybe<Scalars['String']['output']>;
  /** Spouse's requested annual salary */
  spouseRequestedAnnualSalary?: Maybe<Scalars['Float']['output']>;
  /** Whether the spouse is exempt from SECA */
  spouseSecaExempt?: Maybe<Scalars['Boolean']['output']>;
  /** Spouse's years on staff (copied from the questionnaire, which seeds a joining spouse at 0) */
  spouseTenure?: Maybe<Scalars['Int']['output']>;
  /** Staff conference transfer */
  staffConferenceTransfer?: Maybe<Scalars['Float']['output']>;
  /** Monthly student loan payment */
  studentLoanMonthlyPayment?: Maybe<Scalars['Float']['output']>;
  /** Years on staff (copied from the questionnaire, which seeds new staff at 0) */
  tenure?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type NewStaffGoalCalculationAttributesInput = {
  /** Account transfers */
  accountTransfers?: InputMaybe<Scalars['PositiveFloat']['input']>;
  /** Home address */
  address?: InputMaybe<Scalars['String']['input']>;
  /** Advocacy transfers */
  advocacyTransfers?: InputMaybe<Scalars['PositiveFloat']['input']>;
  /** Age range */
  age?: InputMaybe<GoalCalculationAge>;
  /** Whether debt is allowed over the cap */
  allowDebtOverCap?: InputMaybe<Scalars['Boolean']['input']>;
  /** Over-cap salary approval tier */
  allowSalaryOverCap?: InputMaybe<NewStaffGoalCalculationSalaryOverCapEnum>;
  /** Requested annual salary */
  annualRequestedSalary?: InputMaybe<Scalars['PositiveFloat']['input']>;
  /** Whether the assignment is field- or office-based */
  assignmentType?: InputMaybe<GoalCalculationRole>;
  /** Benefits plan selection */
  benefitsPlan?: InputMaybe<MpdGoalBenefitsConstantPlanEnum>;
  /** Which year-versioned constants set the goal is calculated against */
  calculationsYear?: InputMaybe<Scalars['Int']['input']>;
  /** Monthly car loan payment */
  carLoanMonthlyPayment?: InputMaybe<Scalars['PositiveFloat']['input']>;
  /** Number of children needing childcare */
  childcareChildrenCount?: InputMaybe<Scalars['Int']['input']>;
  /** 403(b) contribution percentage */
  contribution403bPercentage?: InputMaybe<Scalars['PositiveFloat']['input']>;
  /** Monthly credit card debt payment */
  creditCardDebtMonthlyPayment?: InputMaybe<Scalars['PositiveFloat']['input']>;
  /** Email address */
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  /** First name */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** City of assignment */
  geographicLocation?: InputMaybe<Scalars['String']['input']>;
  /** Number of healthcare dependents */
  healthcareDependentsCount?: InputMaybe<Scalars['Int']['input']>;
  /** Whether healthcare is exempt */
  healthcareExempt?: InputMaybe<Scalars['Boolean']['input']>;
  /** Last name */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Marital status */
  maritalStatus?: InputMaybe<NewStaffQuestionnaireMaritalStatusEnum>;
  /** Ministry location */
  ministryLocation?: InputMaybe<Scalars['String']['input']>;
  /** Ministry name */
  ministryName?: InputMaybe<Scalars['String']['input']>;
  /** New Staff Orientation housing arrangement */
  nsoHousing?: InputMaybe<NewStaffQuestionnaireNsoHousingEnum>;
  /** Which New Staff Orientation sessions the staff member will attend */
  nsoSessions?: InputMaybe<NewStaffQuestionnaireNsoSessionsEnum>;
  /** Special-needs support received toward New Staff Orientation */
  nsoSpecialNeedsSupportReceived?: InputMaybe<
    Scalars['PositiveFloat']['input']
  >;
  /** Other monthly expenses */
  otherExpenses?: InputMaybe<Scalars['PositiveFloat']['input']>;
  /** Cell phone number */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Whether the staff member is exempt from SECA */
  secaExempt?: InputMaybe<Scalars['Boolean']['input']>;
  /** Spouse's age range */
  spouseAge?: InputMaybe<GoalCalculationAge>;
  /** Spouse's 403(b) contribution percentage */
  spouseContribution403bPercentage?: InputMaybe<
    Scalars['PositiveFloat']['input']
  >;
  /** Spouse's email address */
  spouseEmailAddress?: InputMaybe<Scalars['String']['input']>;
  /** Spouse's first name */
  spouseFirstName?: InputMaybe<Scalars['String']['input']>;
  /** Whether the spouse's healthcare is exempt */
  spouseHealthcareExempt?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the spouse is joining staff */
  spouseJoining?: InputMaybe<Scalars['Boolean']['input']>;
  /** Ministry housing allowance the spouse has taken */
  spouseMhaAmount?: InputMaybe<Scalars['PositiveFloat']['input']>;
  /** Spouse's cell phone number */
  spousePhoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Spouse's requested annual salary */
  spouseRequestedAnnualSalary?: InputMaybe<Scalars['PositiveFloat']['input']>;
  /** Whether the spouse is exempt from SECA */
  spouseSecaExempt?: InputMaybe<Scalars['Boolean']['input']>;
  /** Spouse's years on staff */
  spouseTenure?: InputMaybe<Scalars['Int']['input']>;
  /** Staff conference transfer */
  staffConferenceTransfer?: InputMaybe<Scalars['PositiveFloat']['input']>;
  /** Monthly student loan payment */
  studentLoanMonthlyPayment?: InputMaybe<Scalars['PositiveFloat']['input']>;
  /** Years on staff */
  tenure?: InputMaybe<Scalars['Int']['input']>;
};

export type NewStaffGoalCalculationCalculations = {
  __typename?: 'NewStaffGoalCalculationCalculations';
  /** Current staff account balance from the linked account list; null for scenario goals, which have no account list */
  accountBalance?: Maybe<Scalars['Float']['output']>;
  /** Line 11. Transfers to other staff, EMF, etc. */
  accountTransfers: Scalars['Float']['output'];
  /** The administrative charge itself (line 15 - line 14) */
  adminCharge: Scalars['Float']['output'];
  /** Administrative charge rate */
  adminRate: Scalars['Float']['output'];
  /** Line 12. Advocacy transfers */
  advocacyTransfers: Scalars['Float']['output'];
  /** Annual base salary for the calculation year */
  annualBase: Scalars['Float']['output'];
  /** The attrition amount layered on top of the admin-grossed subtotal (line 16 - line 15) */
  attrition: Scalars['Float']['output'];
  /** Attrition rate */
  attritionRate: Scalars['Float']['output'];
  /** Line 9. Benefits charge */
  benefitsCharge: Scalars['Float']['output'];
  /** Line 4. Meetings, retreats, and conferences */
  conferences: Scalars['Float']['output'];
  /** Line 1D. Primary applicant's monthly 403(b) voluntary retirement plan contribution */
  contributing403bAmount: Scalars['Float']['output'];
  /** Primary applicant's 403(b) contribution rate (0-1 fraction), either their chosen percentage or the default 403(b) rate */
  contribution403bPercentage: Scalars['Float']['output'];
  /** Line 4. Cru National Conference */
  cruConferenceCost: Scalars['Float']['output'];
  /** Whether either applicant's annual debt exceeds the base (no-approval) debt cap */
  debtOverCap: Scalars['Boolean']['output'];
  /** Default 403(b) contribution fraction (0-1) */
  default403bFraction: Scalars['Float']['output'];
  /** Line 2. Faith & Finances course */
  faithAndFinanceCost: Scalars['Float']['output'];
  /** Line 14. Monthly needs subtotal (sum of lines 1-13) */
  goalSubtotal: Scalars['Float']['output'];
  /** Line 1. IBS / NSO (tuition, books, housing, food, travel) */
  ibsNsoCost: Scalars['Float']['output'];
  /** Line 5. Meals and per diem */
  meals: Scalars['Float']['output'];
  /** Line 10. Reimbursable (deductible and non-covered) medical expenses */
  medicalExpenses: Scalars['Float']['output'];
  /** Mileage rate (dollars per mile) */
  mileageRate: Scalars['Float']['output'];
  /** Minimum staff account balance required before reporting to assignment */
  minimumAccountBalance: Scalars['Float']['output'];
  /** Line 2. Ministry mileage (current mileage rate x number of ministry miles) */
  ministryMiles: Scalars['Float']['output'];
  /** Line 16. Total monthly goal (line 15 x the 1.06 attrition factor) */
  monthlyGoal: Scalars['Float']['output'];
  /** Line 6. MPD */
  mpd: Scalars['Float']['output'];
  /** Line 13. Other */
  otherExpenses: Scalars['Float']['output'];
  /** Line 3. Refresh Retreat (includes travel) */
  refreshRetreatCost: Scalars['Float']['output'];
  /** Line 1A. Monthly salary before SECA and 403(b) */
  salary: Scalars['Float']['output'];
  /** Whether the uncapped salary exceeds the base (no-exception) salary cap */
  salaryOverCap: Scalars['Boolean']['output'];
  /** Line 1C. Subtotal salary (lines 1A + 1B) */
  salarySubtotal: Scalars['Float']['output'];
  /** Line 1B. SECA and other taxes (line 1A x the 0.22 SECA percentage) */
  seca: Scalars['Float']['output'];
  /** SECA rate applied to salary */
  secaRate: Scalars['Float']['output'];
  /** Line 7. Special-needs funding already developed (raised) */
  specialNeedsDevelopedToDate: Scalars['Float']['output'];
  /** Line 8. Special needs still to be developed (line 6 less line 7) */
  specialNeedsLeft: Scalars['Float']['output'];
  /** Line 5. Subtotal of lines 1-4 */
  specialNeedsSubtotal: Scalars['Float']['output'];
  /** Line 6. Subtotal grossed up for the 12% administrative assessment (line 5 / 0.88) */
  specialNeedsTotal: Scalars['Float']['output'];
  /** Spouse's monthly 403(b) voluntary retirement plan contribution */
  spouseContributing403bAmount: Scalars['Float']['output'];
  /** Spouse's 403(b) contribution rate (0-1 fraction), either their chosen percentage or the default 403(b) rate */
  spouseContribution403bPercentage: Scalars['Float']['output'];
  /** Line 8. Summer assignments and U.S. Staff Conference */
  staffConferenceTransfer: Scalars['Float']['output'];
  /** Line 15. The subtotal grossed up for the 12% administrative charge (line 14 / 0.88) */
  subtotalWithAdminCharge: Scalars['Float']['output'];
  /** Line 7. Supplies and materials */
  supplies: Scalars['Float']['output'];
  /** Monthly support already raised (in-hand received pledges) from the linked account list; null for scenario goals, which have no account list */
  supportRaised?: Maybe<Scalars['Float']['output']>;
  /** Line 1D. Combined monthly 403(b) contribution (primary + spouse) */
  totalContributing403bAmount: Scalars['Float']['output'];
  /** Total monthly ministry expenses (sum of lines 2-7) */
  totalMinistryExpenses: Scalars['Float']['output'];
  /** Line 1. Total monthly salary, including SECA and the 403(b) plan (lines 1C + 1D) */
  totalSalary: Scalars['Float']['output'];
  /** Line 3. Travel */
  travel: Scalars['Float']['output'];
};

/** The connection type for NewStaffGoalCalculation. */
export type NewStaffGoalCalculationConnection = {
  __typename?: 'NewStaffGoalCalculationConnection';
  /** A list of edges. */
  edges: Array<NewStaffGoalCalculationEdge>;
  /** A list of nodes. */
  nodes: Array<NewStaffGoalCalculation>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total # of objects returned from this Plural Query */
  totalCount: Scalars['Int']['output'];
  /** Total # of pages, based on total count and pagesize */
  totalPageCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type NewStaffGoalCalculationEdge = {
  __typename?: 'NewStaffGoalCalculationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<NewStaffGoalCalculation>;
};

export type NewStaffGoalCalculationPreview = {
  __typename?: 'NewStaffGoalCalculationPreview';
  /** Account transfers */
  accountTransfers?: Maybe<Scalars['Float']['output']>;
  /** Home address (prepopulated from HCM) */
  address?: Maybe<Scalars['String']['output']>;
  /** Advocacy transfers */
  advocacyTransfers?: Maybe<Scalars['Float']['output']>;
  /** Age range (prepopulated from HCM) */
  age?: Maybe<GoalCalculationAge>;
  /** Whether debt is allowed over the cap */
  allowDebtOverCap?: Maybe<Scalars['Boolean']['output']>;
  /** Over-cap salary approval tier */
  allowSalaryOverCap?: Maybe<NewStaffGoalCalculationSalaryOverCapEnum>;
  /** Requested annual salary */
  annualRequestedSalary?: Maybe<Scalars['Float']['output']>;
  /** Whether the assignment is field- or office-based */
  assignmentType?: Maybe<GoalCalculationRole>;
  /** Benefits plan selection */
  benefitsPlan?: Maybe<MpdGoalBenefitsConstantPlanEnum>;
  /** Computed goal calculation worksheet for this calculation */
  calculations: NewStaffGoalCalculationCalculations;
  /** Which year-versioned constants set the goal is calculated against */
  calculationsYear?: Maybe<Scalars['Int']['output']>;
  /** Monthly car loan payment */
  carLoanMonthlyPayment?: Maybe<Scalars['Float']['output']>;
  /** Number of children needing childcare */
  childcareChildrenCount?: Maybe<Scalars['Int']['output']>;
  /** 403(b) contribution percentage */
  contribution403bPercentage?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Monthly credit card debt payment */
  creditCardDebtMonthlyPayment?: Maybe<Scalars['Float']['output']>;
  /** Email address */
  emailAddress?: Maybe<Scalars['String']['output']>;
  /** First name */
  firstName?: Maybe<Scalars['String']['output']>;
  /** City of assignment */
  geographicLocation?: Maybe<Scalars['String']['output']>;
  /** Number of healthcare dependents */
  healthcareDependentsCount?: Maybe<Scalars['Int']['output']>;
  /** Whether healthcare is exempt */
  healthcareExempt?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  /** Year the staff member joined staff */
  joinedStaffYear?: Maybe<Scalars['Int']['output']>;
  /** Last name */
  lastName?: Maybe<Scalars['String']['output']>;
  /** Marital status, verified by the staff member (prepopulated from HCM) */
  maritalStatus: NewStaffQuestionnaireMaritalStatusEnum;
  /** Ministry location */
  ministryLocation?: Maybe<Scalars['String']['output']>;
  /** Ministry name */
  ministryName?: Maybe<Scalars['String']['output']>;
  /** The cohort household this calculation belongs to; null for scenario goals and for users viewing their own goal */
  newStaffCohortAttendee?: Maybe<NewStaffCohortAttendee>;
  /** New Staff Orientation housing arrangement */
  nsoHousing?: Maybe<NewStaffQuestionnaireNsoHousingEnum>;
  /** Which New Staff Orientation sessions the staff member will attend */
  nsoSessions?: Maybe<NewStaffQuestionnaireNsoSessionsEnum>;
  /** Special-needs support received toward New Staff Orientation */
  nsoSpecialNeedsSupportReceived?: Maybe<Scalars['Float']['output']>;
  /** Other monthly expenses (worksheet line 13) */
  otherExpenses?: Maybe<Scalars['Float']['output']>;
  /** Staff member's HCM person number */
  personNumber?: Maybe<Scalars['String']['output']>;
  /** Cell phone number */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** Whether the staff member is exempt from SECA */
  secaExempt?: Maybe<Scalars['Boolean']['output']>;
  /** Spouse's age range (prepopulated from HCM) */
  spouseAge?: Maybe<GoalCalculationAge>;
  /** Spouse's 403(b) contribution percentage */
  spouseContribution403bPercentage?: Maybe<Scalars['Float']['output']>;
  /** Spouse's email address */
  spouseEmailAddress?: Maybe<Scalars['String']['output']>;
  /** Spouse's first name */
  spouseFirstName?: Maybe<Scalars['String']['output']>;
  /** Whether the spouse's healthcare is exempt */
  spouseHealthcareExempt?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the spouse is joining staff (prepopulated from HCM) */
  spouseJoining?: Maybe<Scalars['Boolean']['output']>;
  /** Ministry housing allowance the spouse has taken */
  spouseMhaAmount?: Maybe<Scalars['Float']['output']>;
  /** Spouse's HCM person number */
  spousePersonNumber?: Maybe<Scalars['String']['output']>;
  /** Spouse's cell phone number */
  spousePhoneNumber?: Maybe<Scalars['String']['output']>;
  /** Spouse's requested annual salary */
  spouseRequestedAnnualSalary?: Maybe<Scalars['Float']['output']>;
  /** Whether the spouse is exempt from SECA */
  spouseSecaExempt?: Maybe<Scalars['Boolean']['output']>;
  /** Spouse's years on staff (copied from the questionnaire, which seeds a joining spouse at 0) */
  spouseTenure?: Maybe<Scalars['Int']['output']>;
  /** Staff conference transfer */
  staffConferenceTransfer?: Maybe<Scalars['Float']['output']>;
  /** Monthly student loan payment */
  studentLoanMonthlyPayment?: Maybe<Scalars['Float']['output']>;
  /** Years on staff (copied from the questionnaire, which seeds new staff at 0) */
  tenure?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Autogenerated input type of NewStaffGoalCalculationPreviewMutation */
export type NewStaffGoalCalculationPreviewMutationInput = {
  /** AccountList the goal belongs to. Omit to preview one of your own scenario goals. */
  accountListId?: InputMaybe<Scalars['ID']['input']>;
  /** Goal-calculation changes to preview */
  attributes: NewStaffGoalCalculationAttributesInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Goal calculation to preview changes against */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of NewStaffGoalCalculationPreviewMutation. */
export type NewStaffGoalCalculationPreviewMutationPayload = {
  __typename?: 'NewStaffGoalCalculationPreviewMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  newStaffGoalCalculation: NewStaffGoalCalculationPreview;
};

export enum NewStaffGoalCalculationSalaryOverCapEnum {
  /** Salary may not exceed the cap */
  No = 'NO',
  /** Salary may exceed the cap up to the Board Compensation Committee tier */
  UpToBcc = 'UP_TO_BCC',
  /** Salary may exceed the cap up to the Management Compensation Committee tier */
  UpToMcc = 'UP_TO_MCC',
  /** Salary may exceed the cap by any amount */
  YesAny = 'YES_ANY',
}

export enum NewStaffGoalCalculationSortEnum {
  /** Surname then first name, A to Z; unnamed scenarios last */
  LastNameAsc = 'LAST_NAME_ASC',
  /** Surname then first name, Z to A; unnamed scenarios last */
  LastNameDesc = 'LAST_NAME_DESC',
  /** Newest first (the default) */
  MostRecentFirst = 'MOST_RECENT_FIRST',
}

/** Autogenerated input type of NewStaffGoalCalculationUpdateMutation */
export type NewStaffGoalCalculationUpdateMutationInput = {
  /** AccountList the goal belongs to. Omit to update one of your own scenario goals. */
  accountListId?: InputMaybe<Scalars['ID']['input']>;
  /** Goal-calculation data to save (partial saves are allowed) */
  attributes: NewStaffGoalCalculationAttributesInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Goal calculation to update */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of NewStaffGoalCalculationUpdateMutation. */
export type NewStaffGoalCalculationUpdateMutationPayload = {
  __typename?: 'NewStaffGoalCalculationUpdateMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The household's MPD support goal after this save; null for a scenario goal */
  monthlyGoal?: Maybe<Scalars['Int']['output']>;
  newStaffGoalCalculation: NewStaffGoalCalculation;
};

export type NewStaffQuestionnaire = {
  __typename?: 'NewStaffQuestionnaire';
  /** Account transfers */
  accountTransfers?: Maybe<Scalars['Float']['output']>;
  /** Home address (prepopulated from HCM) */
  address?: Maybe<Scalars['String']['output']>;
  /** Age range (prepopulated from HCM) */
  age?: Maybe<GoalCalculationAge>;
  /** Whether the assignment is field- or office-based */
  assignmentType?: Maybe<GoalCalculationRole>;
  /** Monthly car loan payment */
  carLoanMonthlyPayment?: Maybe<Scalars['Float']['output']>;
  /** Number of children needing childcare */
  childcareChildrenCount?: Maybe<Scalars['Int']['output']>;
  /** Whether the questionnaire has been completed */
  completed: Scalars['Boolean']['output'];
  /** When the questionnaire was completed and locked */
  completedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Monthly credit card debt payment */
  creditCardDebtMonthlyPayment?: Maybe<Scalars['Float']['output']>;
  /** Email address (prepopulated from HCM) */
  emailAddress?: Maybe<Scalars['String']['output']>;
  /** First name (prepopulated from HCM) */
  firstName?: Maybe<Scalars['String']['output']>;
  /** City of assignment */
  geographicLocation?: Maybe<Scalars['String']['output']>;
  /** Number of healthcare dependents */
  healthcareDependentsCount?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  /** Last name (prepopulated from HCM) */
  lastName?: Maybe<Scalars['String']['output']>;
  /** Marital status, verified by the staff member (prepopulated from HCM) */
  maritalStatus: NewStaffQuestionnaireMaritalStatusEnum;
  /** Ministry location */
  ministryLocation?: Maybe<Scalars['String']['output']>;
  /** Ministry name */
  ministryName?: Maybe<Scalars['String']['output']>;
  /** New Staff Orientation housing arrangement */
  nsoHousing?: Maybe<NewStaffQuestionnaireNsoHousingEnum>;
  /** Which New Staff Orientation sessions the staff member will attend */
  nsoSessions?: Maybe<NewStaffQuestionnaireNsoSessionsEnum>;
  /** Special-needs support received toward New Staff Orientation */
  nsoSpecialNeedsSupportReceived?: Maybe<Scalars['Float']['output']>;
  /** Staff member's HCM person number */
  personNumber: Scalars['String']['output'];
  /** Cell phone number */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** Spouse's age range (prepopulated from HCM) */
  spouseAge?: Maybe<GoalCalculationAge>;
  /** Spouse's 403(b) contribution percentage */
  spouseContribution403bPercentage?: Maybe<Scalars['Float']['output']>;
  /** Spouse's email address (prepopulated from HCM) */
  spouseEmailAddress?: Maybe<Scalars['String']['output']>;
  /** Spouse's first name (prepopulated from HCM) */
  spouseFirstName?: Maybe<Scalars['String']['output']>;
  /** Whether the spouse is joining staff (prepopulated from HCM) */
  spouseJoining?: Maybe<Scalars['Boolean']['output']>;
  /** Ministry housing allowance the spouse has taken */
  spouseMhaAmount?: Maybe<Scalars['Float']['output']>;
  /** Spouse's HCM person number */
  spousePersonNumber?: Maybe<Scalars['String']['output']>;
  /** Spouse's cell phone number */
  spousePhoneNumber?: Maybe<Scalars['String']['output']>;
  /** Spouse's requested annual salary */
  spouseRequestedAnnualSalary?: Maybe<Scalars['Float']['output']>;
  /** Spouse's years on staff (0 when the spouse is joining staff, otherwise prepopulated from HCM) */
  spouseTenure?: Maybe<Scalars['Int']['output']>;
  /** Staff conference transfer */
  staffConferenceTransfer?: Maybe<Scalars['Float']['output']>;
  /** Monthly student loan payment */
  studentLoanMonthlyPayment?: Maybe<Scalars['Float']['output']>;
  /** Years on staff (seeded at 0 for new staff rather than taken from HCM) */
  tenure?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** Which questionnaire flow applies (derived from the staff and marital statuses) */
  variant: NewStaffQuestionnaireVariantEnum;
};

export type NewStaffQuestionnaireAttributesInput = {
  /** Account transfers */
  accountTransfers?: InputMaybe<Scalars['PositiveFloat']['input']>;
  /** Whether the assignment is field- or office-based */
  assignmentType?: InputMaybe<GoalCalculationRole>;
  /** Monthly car loan payment */
  carLoanMonthlyPayment?: InputMaybe<Scalars['PositiveFloat']['input']>;
  /** Number of children needing childcare */
  childcareChildrenCount?: InputMaybe<Scalars['Int']['input']>;
  /** Monthly credit card debt payment */
  creditCardDebtMonthlyPayment?: InputMaybe<Scalars['PositiveFloat']['input']>;
  /** City of assignment */
  geographicLocation?: InputMaybe<Scalars['String']['input']>;
  /** Number of healthcare dependents */
  healthcareDependentsCount?: InputMaybe<Scalars['Int']['input']>;
  /** Ministry location */
  ministryLocation?: InputMaybe<Scalars['String']['input']>;
  /** Ministry name */
  ministryName?: InputMaybe<Scalars['String']['input']>;
  /** New Staff Orientation housing arrangement */
  nsoHousing?: InputMaybe<NewStaffQuestionnaireNsoHousingEnum>;
  /** Which New Staff Orientation sessions the staff member will attend */
  nsoSessions?: InputMaybe<NewStaffQuestionnaireNsoSessionsEnum>;
  /** Special-needs support received toward New Staff Orientation */
  nsoSpecialNeedsSupportReceived?: InputMaybe<
    Scalars['PositiveFloat']['input']
  >;
  /** Cell phone number */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Spouse's 403(b) contribution percentage */
  spouseContribution403bPercentage?: InputMaybe<
    Scalars['PositiveFloat']['input']
  >;
  /** Ministry housing allowance the spouse has taken */
  spouseMhaAmount?: InputMaybe<Scalars['PositiveFloat']['input']>;
  /** Spouse's cell phone number */
  spousePhoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Spouse's requested annual salary */
  spouseRequestedAnnualSalary?: InputMaybe<Scalars['PositiveFloat']['input']>;
  /** Staff conference transfer */
  staffConferenceTransfer?: InputMaybe<Scalars['PositiveFloat']['input']>;
  /** Monthly student loan payment */
  studentLoanMonthlyPayment?: InputMaybe<Scalars['PositiveFloat']['input']>;
};

/** Autogenerated input type of NewStaffQuestionnaireCompleteMutation */
export type NewStaffQuestionnaireCompleteMutationInput = {
  /** AccountList whose in-progress questionnaire should be completed */
  accountListId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of NewStaffQuestionnaireCompleteMutation. */
export type NewStaffQuestionnaireCompleteMutationPayload = {
  __typename?: 'NewStaffQuestionnaireCompleteMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  newStaffQuestionnaire: NewStaffQuestionnaire;
};

export enum NewStaffQuestionnaireMaritalStatusEnum {
  /** Married staff member */
  Married = 'MARRIED',
  /** Single staff member */
  Single = 'SINGLE',
  /** Spouse of staff applicant */
  Sosa = 'SOSA',
}

export enum NewStaffQuestionnaireNsoHousingEnum {
  /** Couple room */
  CoupleRoom = 'COUPLE_ROOM',
  /** Family room */
  FamilyRoom = 'FAMILY_ROOM',
  /** Local commuting (no on-site housing) */
  LocalCommuting = 'LOCAL_COMMUTING',
  /** Shared room */
  SharedRoom = 'SHARED_ROOM',
  /** Single room */
  SingleRoom = 'SINGLE_ROOM',
}

export enum NewStaffQuestionnaireNsoSessionsEnum {
  /** Institute of Biblical Studies and New Staff Orientation */
  IbsAndNso = 'IBS_AND_NSO',
  /** New Staff Orientation only */
  Nso = 'NSO',
}

/** Autogenerated input type of NewStaffQuestionnaireUpdateMutation */
export type NewStaffQuestionnaireUpdateMutationInput = {
  /** AccountList the questionnaire belongs to */
  accountListId: Scalars['ID']['input'];
  /** Questionnaire form data to save (partial saves are allowed) */
  attributes: NewStaffQuestionnaireAttributesInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of NewStaffQuestionnaireUpdateMutation. */
export type NewStaffQuestionnaireUpdateMutationPayload = {
  __typename?: 'NewStaffQuestionnaireUpdateMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  newStaffQuestionnaire: NewStaffQuestionnaire;
};

export enum NewStaffQuestionnaireVariantEnum {
  /** Single staff member, or a married couple both joining staff */
  SingleMarried = 'SINGLE_MARRIED',
  /** Spouse of staff applicant */
  Sosa = 'SOSA',
  /** Staff member with a senior-staff spouse */
  SpouseSeniorStaff = 'SPOUSE_SENIOR_STAFF',
}

/** Autogenerated input type of NewStaffScenarioGoalCreateMutation */
export type NewStaffScenarioGoalCreateMutationInput = {
  /** Scenario-goal data; all fields are optional */
  attributes?: InputMaybe<NewStaffGoalCalculationAttributesInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of NewStaffScenarioGoalCreateMutation. */
export type NewStaffScenarioGoalCreateMutationPayload = {
  __typename?: 'NewStaffScenarioGoalCreateMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  newStaffGoalCalculation: NewStaffGoalCalculation;
};

/** Autogenerated input type of NewStaffScenarioGoalDeleteMutation */
export type NewStaffScenarioGoalDeleteMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Scenario goal to delete */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of NewStaffScenarioGoalDeleteMutation. */
export type NewStaffScenarioGoalDeleteMutationPayload = {
  __typename?: 'NewStaffScenarioGoalDeleteMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

/** Autogenerated input type of NewStaffScenarioGoalSendMutation */
export type NewStaffScenarioGoalSendMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Address to email the worksheet to, such as a recruiter or coach */
  emailAddress: Scalars['String']['input'];
  /** Scenario goal whose worksheet should be emailed */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of NewStaffScenarioGoalSendMutation. */
export type NewStaffScenarioGoalSendMutationPayload = {
  __typename?: 'NewStaffScenarioGoalSendMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  newStaffGoalCalculation: NewStaffGoalCalculation;
};

export type Notification = {
  __typename?: 'Notification';
  cleared: Scalars['Boolean']['output'];
  contact: Contact;
  createdAt: Scalars['ISO8601DateTime']['output'];
  donation?: Maybe<Donation>;
  id: Scalars['ID']['output'];
  notificationType: NotificationType;
  occurredAt: Scalars['ISO8601DateTime']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** The connection type for UserNotification. */
export type NotificationConnection = {
  __typename?: 'NotificationConnection';
  /** A list of edges. */
  edges: Array<NotificationEdge>;
  /** A list of nodes. */
  nodes: Array<UserNotification>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total # of objects returned from this Plural Query */
  totalCount: Scalars['Int']['output'];
  /** Total # of pages, based on total count and pagesize */
  totalPageCount: Scalars['Int']['output'];
  unreadCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type NotificationEdge = {
  __typename?: 'NotificationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<UserNotification>;
};

export type NotificationPreference = {
  __typename?: 'NotificationPreference';
  accountListId: Scalars['String']['output'];
  app: Scalars['Boolean']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  email: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  notificationType: NotificationType;
  task: Scalars['Boolean']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  userId?: Maybe<Scalars['String']['output']>;
};

/** The connection type for NotificationPreference. */
export type NotificationPreferenceConnection = {
  __typename?: 'NotificationPreferenceConnection';
  /** A list of edges. */
  edges: Array<NotificationPreferenceEdge>;
  /** A list of nodes. */
  nodes: Array<NotificationPreference>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total # of objects returned from this Plural Query */
  totalCount: Scalars['Int']['output'];
  /** Total # of pages, based on total count and pagesize */
  totalPageCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type NotificationPreferenceEdge = {
  __typename?: 'NotificationPreferenceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<NotificationPreference>;
};

export type NotificationPreferenceUpdateInput = {
  app?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['Boolean']['input']>;
  notificationType: NotificationTypeTypeEnum;
  task?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated input type of NotificationPreferencesUpdateMutation */
export type NotificationPreferencesUpdateMutationInput = {
  accountListId: Scalars['ID']['input'];
  attributes: Array<NotificationPreferenceUpdateInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of NotificationPreferencesUpdateMutation. */
export type NotificationPreferencesUpdateMutationPayload = {
  __typename?: 'NotificationPreferencesUpdateMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  notificationPreferences: Array<NotificationPreference>;
};

export enum NotificationTimeUnitEnum {
  Days = 'DAYS',
  Hours = 'HOURS',
  Minutes = 'MINUTES',
}

export type NotificationType = {
  __typename?: 'NotificationType';
  createdAt: Scalars['ISO8601DateTime']['output'];
  descriptionTemplate: Scalars['String']['output'];
  emailDescriptionTemplate: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  type: NotificationTypeTypeEnum;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  userNotificationTitleTemplate: Scalars['String']['output'];
};

export enum NotificationTypeEnum {
  Both = 'BOTH',
  Email = 'EMAIL',
  Mobile = 'MOBILE',
}

export enum NotificationTypeTypeEnum {
  CallPartnerOncePerYear = 'CALL_PARTNER_ONCE_PER_YEAR',
  LargerGift = 'LARGER_GIFT',
  LongTimeFrameGift = 'LONG_TIME_FRAME_GIFT',
  MailchimpBounce = 'MAILCHIMP_BOUNCE',
  MailchimpUnsubscribe = 'MAILCHIMP_UNSUBSCRIBE',
  MissingAddressInNewsletter = 'MISSING_ADDRESS_IN_NEWSLETTER',
  MissingEmailInNewsletter = 'MISSING_EMAIL_IN_NEWSLETTER',
  NewAddress = 'NEW_ADDRESS',
  NewDesignationAccountSubscription = 'NEW_DESIGNATION_ACCOUNT_SUBSCRIPTION',
  NewPageSubscription = 'NEW_PAGE_SUBSCRIPTION',
  NewPartnerDuplicateMerged = 'NEW_PARTNER_DUPLICATE_MERGED',
  NewPartnerDuplicateNotMerged = 'NEW_PARTNER_DUPLICATE_NOT_MERGED',
  NewPartnerNoDuplicate = 'NEW_PARTNER_NO_DUPLICATE',
  RecontinuingGift = 'RECONTINUING_GIFT',
  RemindPartnerInAdvance = 'REMIND_PARTNER_IN_ADVANCE',
  SmallerGift = 'SMALLER_GIFT',
  SpecialGift = 'SPECIAL_GIFT',
  StartedGiving = 'STARTED_GIVING',
  StoppedGiving = 'STOPPED_GIVING',
  ThankPartnerOncePerYear = 'THANK_PARTNER_ONCE_PER_YEAR',
  UpcomingAnniversary = 'UPCOMING_ANNIVERSARY',
  UpcomingBirthday = 'UPCOMING_BIRTHDAY',
}

export type NumericRangeFilter = Filter & {
  __typename?: 'NumericRangeFilter';
  filterKey: Scalars['String']['output'];
  max: Scalars['Float']['output'];
  maxLabel: Scalars['String']['output'];
  min: Scalars['Float']['output'];
  minLabel: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

/** Range of numbers */
export type NumericRangeInput = {
  /** Maximum value of the range */
  max?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value of the range */
  min?: InputMaybe<Scalars['Float']['input']>;
};

/** Autogenerated input type of OktaSignInMutation */
export type OktaSignInMutationInput = {
  accessToken: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of OktaSignInMutation. */
export type OktaSignInMutationPayload = {
  __typename?: 'OktaSignInMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export type Option = {
  __typename?: 'Option';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type Organization = {
  __typename?: 'Organization';
  apiClass: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  disableNewUsers?: Maybe<Scalars['Boolean']['output']>;
  giftAidPercentage?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  oauth: Scalars['Boolean']['output'];
  organizationType?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type OrganizationAccount = {
  __typename?: 'OrganizationAccount';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  lastDownload?: Maybe<Scalars['ISO8601DateTime']['output']>;
  lastDownloadAttemptAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  lastDownloadedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  latestDonationDate?: Maybe<Scalars['ISO8601Date']['output']>;
  organization: Organization;
  person: Person;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  username?: Maybe<Scalars['String']['output']>;
};

export type OrganizationAccountCreateInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of OrganizationAccountCreateMutation */
export type OrganizationAccountCreateMutationInput = {
  /** attributes to create OrganizationAccount */
  attributes: OrganizationAccountCreateInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of OrganizationAccountCreateMutation. */
export type OrganizationAccountCreateMutationPayload = {
  __typename?: 'OrganizationAccountCreateMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  organizationAccount: OrganizationAccount;
};

/** Autogenerated input type of OrganizationAccountDeleteMutation */
export type OrganizationAccountDeleteMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of OrganizationAccount to delete */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of OrganizationAccountDeleteMutation. */
export type OrganizationAccountDeleteMutationPayload = {
  __typename?: 'OrganizationAccountDeleteMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type OrganizationAccountListCoaches = {
  __typename?: 'OrganizationAccountListCoaches';
  coachEmailAddresses?: Maybe<Array<Maybe<AccountListEmailAddresses>>>;
  coachFirstName?: Maybe<Scalars['String']['output']>;
  coachLastName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
};

/** Autogenerated input type of OrganizationAccountSyncMutation */
export type OrganizationAccountSyncMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** OrganizationAccount id */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of OrganizationAccountSyncMutation. */
export type OrganizationAccountSyncMutationPayload = {
  __typename?: 'OrganizationAccountSyncMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  organizationAccount: OrganizationAccount;
};

export type OrganizationAccountUpdateInput = {
  id: Scalars['ID']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of OrganizationAccountUpdateMutation */
export type OrganizationAccountUpdateMutationInput = {
  /** attributes to update OrganizationAccount */
  attributes: OrganizationAccountUpdateInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of OrganizationAccountUpdateMutation. */
export type OrganizationAccountUpdateMutationPayload = {
  __typename?: 'OrganizationAccountUpdateMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  organizationAccount: OrganizationAccount;
};

export type OrganizationAdminsInput = {
  organizationId: Scalars['ID']['input'];
};

/** The connection type for Organization. */
export type OrganizationConnection = {
  __typename?: 'OrganizationConnection';
  /** A list of edges. */
  edges: Array<OrganizationEdge>;
  /** A list of nodes. */
  nodes: Array<Organization>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total # of objects returned from this Plural Query */
  totalCount: Scalars['Int']['output'];
  /** Total # of pages, based on total count and pagesize */
  totalPageCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type OrganizationEdge = {
  __typename?: 'OrganizationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Organization>;
};

export type OrganizationInvitesInput = {
  organizationId: Scalars['ID']['input'];
};

export type Organizations = {
  __typename?: 'Organizations';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
};

export type OrganizationsAccountList = {
  __typename?: 'OrganizationsAccountList';
  accountListCoachInvites?: Maybe<Array<Maybe<AccountListInvites>>>;
  accountListCoaches?: Maybe<Array<Maybe<OrganizationAccountListCoaches>>>;
  accountListUsers?: Maybe<Array<Maybe<AccountListUsers>>>;
  accountListUsersInvites?: Maybe<Array<Maybe<AccountListInvites>>>;
  designationAccounts?: Maybe<Array<Maybe<AccountListDesignationAccounts>>>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  organizationCount?: Maybe<Scalars['Int']['output']>;
};

export type OrganizationsContact = {
  __typename?: 'OrganizationsContact';
  accountList?: Maybe<ContactPeopleAccountLists>;
  addresses: Array<Maybe<ContactAddresses>>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  people: Array<Maybe<ContactPeople>>;
  squareAvatar?: Maybe<Scalars['String']['output']>;
};

export type OverdueOrDueTodayTaskAnalytic = {
  __typename?: 'OverdueOrDueTodayTaskAnalytic';
  count: Scalars['Int']['output'];
  label: Scalars['String']['output'];
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type Pagination = {
  __typename?: 'Pagination';
  page: Scalars['Int']['output'];
  perPage: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

/** Partner giving analysis data */
export type PartnerGivingAnalysisContact = {
  __typename?: 'PartnerGivingAnalysisContact';
  donationPeriodAverage: Scalars['Float']['output'];
  donationPeriodCount: Scalars['Int']['output'];
  donationPeriodPercentRank: Scalars['Float']['output'];
  donationPeriodSum: Scalars['Int']['output'];
  firstDonationAmount?: Maybe<Scalars['Int']['output']>;
  firstDonationCurrency?: Maybe<Scalars['String']['output']>;
  firstDonationDate?: Maybe<Scalars['ISO8601Date']['output']>;
  id: Scalars['ID']['output'];
  lastDonationAmount?: Maybe<Scalars['Int']['output']>;
  lastDonationCurrency?: Maybe<Scalars['String']['output']>;
  lastDonationDate?: Maybe<Scalars['ISO8601Date']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  pledgeAmount?: Maybe<Scalars['Int']['output']>;
  pledgeCurrency?: Maybe<Scalars['String']['output']>;
  pledgeFrequency?: Maybe<PledgeFrequencyEnum>;
  status?: Maybe<StatusEnum>;
  totalDonations: Scalars['Int']['output'];
};

/** The connection type for PartnerGivingAnalysisContact. */
export type PartnerGivingAnalysisContactConnection = {
  __typename?: 'PartnerGivingAnalysisContactConnection';
  /** Sum of all donation_period_sum values across all contacts in the result set */
  donationPeriodTotalSum: Scalars['Int']['output'];
  /** A list of edges. */
  edges: Array<PartnerGivingAnalysisContactEdge>;
  /** A list of nodes. */
  nodes: Array<PartnerGivingAnalysisContact>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total # of objects returned from this Plural Query */
  totalCount: Scalars['Int']['output'];
  /** Total # of pages, based on total count and pagesize */
  totalPageCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PartnerGivingAnalysisContactEdge = {
  __typename?: 'PartnerGivingAnalysisContactEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PartnerGivingAnalysisContact>;
};

export type PartnerGivingAnalysisFilterSetInput = {
  /** Filter by Address No Longer Valid; Accepts values 'true', or 'false' */
  addressHistoric?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter contacts with addresses located within the lat lng bounds. Hash should contain a ne and sw lat lng pair. */
  addressLatLng?: InputMaybe<Scalars['String']['input']>;
  /** Filter by Primary Address; Accepts values 'true', or 'false' */
  addressPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter where address value is false; accepts "false" */
  addressValid?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by alma mater; Accepts multiple parameters, with value 'none', or an alma mater name */
  almaMater?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter where contact people have anniversary on date between provided date range */
  anniversary?: InputMaybe<DateRangeInput>;
  /** When filtering by tags this specifies if the filter should match contacts with any of the filtered tags if "true" or only contacts with all of the filtered tags if "false" */
  anyTags?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by Appeal; Accepts multiple parameters, with value 'no_appeals', or an appeal ID */
  appeal?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by Pledge Status. One of excluded, asked, not_received, received_not_processed, or processed. Must be used with appeal filter. */
  appealStatus?: InputMaybe<Scalars['String']['input']>;
  /** Filter where contact people have birthday on date between provided date range */
  birthday?: InputMaybe<DateRangeInput>;
  /** Filter by Church; Accepts multiple parameters, with value 'none', or a church name */
  church?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by City; Accepts multiple parameters, with value 'none', or a city name */
  city?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by where contact has address; Accepts values 'Yes', or 'No' */
  contactInfoAddr?: InputMaybe<Scalars['String']['input']>;
  /** Filter where contact people has an email; Accepts values 'Yes', or 'No' */
  contactInfoEmail?: InputMaybe<Scalars['String']['input']>;
  /** Filter where contact people has a Facebook Profile; Accepts values 'Yes', or 'No' */
  contactInfoFacebook?: InputMaybe<Scalars['String']['input']>;
  /** Filter where contact people has a mobile phone; Accepts values 'Yes', or 'No' */
  contactInfoMobile?: InputMaybe<Scalars['String']['input']>;
  /** Filter where contact people has a phone; Accepts values 'Yes', or 'No' */
  contactInfoPhone?: InputMaybe<Scalars['String']['input']>;
  /** Filter where contact people has a work phone; Accepts values 'Yes', or 'No' */
  contactInfoWorkPhone?: InputMaybe<Scalars['String']['input']>;
  /** Filter by Type; Accepts multiple parameters, with values 'person', and 'company' */
  contactType?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by Country; Accepts multiple parameters, with values 'none', or a country */
  country?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter contacts that were created in this date range */
  createdAt?: InputMaybe<DateRangeInput>;
  /** Filter by Designation Account; accepts multiple parameters, separated by comma */
  designationAccountId?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter by Gift Options; Accepts multiple parameters, with values 'none', 'one', 'first', and 'last' */
  donation?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by Exact Gift Amount; Accepts multiple parameters, with values like '9.99' */
  donationAmount?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by Gift Amount Range; Accepts object with max and min keys with decimal values { "max": "9.99", "min": "0.99" } */
  donationAmountRange?: InputMaybe<NumericRangeInput>;
  /** Filter by Gift Date; Accepts date range with text value like 'MM/DD/YYYY - MM/DD/YYYY' */
  donationDate?: InputMaybe<DateRangeInput>;
  /** Filters by donation period count; Accepts hash with min and max decimal values */
  donationPeriodAverage?: InputMaybe<NumericRangeInput>;
  /** Filters by donation period count; Accepts hash with min and max decimal values */
  donationPeriodCount?: InputMaybe<NumericRangeInput>;
  /** Filters by donation period count; Accepts hash with min and max decimal values */
  donationPeriodPercentRank?: InputMaybe<NumericRangeInput>;
  /** Filters by donation period count; Accepts hash with min and max decimal values */
  donationPeriodSum?: InputMaybe<NumericRangeInput>;
  /** Filter contacts that have any of the tags included in this filter; comma separated value for multiple */
  excludeTags?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter where contact gave more than they pledged within the provided date range */
  gaveMoreThanPledgedRange?: InputMaybe<DateRangeInput>;
  /** Filter contacts with ids included in this filter; comma separated value for multiple */
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter contacts by the date at which the contact started being late on payments */
  lateAt?: InputMaybe<DateRangeInput>;
  /** Filter by Likely To Give; Accepts multiple parameters, with values 'none', 'Least Likely', 'Likely', and 'Most Likely' */
  likely?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by Language; Accepts multiple parameters, */
  locale?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by Metro Area; Accepts multiple parameters, with values 'none', or a metro area name */
  metroArea?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter where contact name starts with the provided value */
  nameLike?: InputMaybe<Scalars['String']['input']>;
  /** Filter by Newsletter Recipients; Accepts values 'none', 'all', 'address', 'email', and 'both' */
  newsletter?: InputMaybe<ContactFilterNewsletterEnum>;
  /** Filter by Next Ask date within the provided date range */
  nextAsk?: InputMaybe<DateRangeInput>;
  /** Filter where contact has asked specifically not to receive appeals; accepts "true" */
  noAppeals?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter contacts with note contents; accepts hash with wildcard_note_search parameter { "wildcard_note_search": "value to search by" } */
  notes?: InputMaybe<ContactFilterNotesInput>;
  /** Filter where at least one contact person has opted out from email; Accepts values 'Yes', or 'No' */
  optOut?: InputMaybe<Scalars['String']['input']>;
  /** filter where contact's account list has a designation account belonging to an organization; Accepts IDs separated by comma */
  organizationId?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter contacts by pledge status. completed, outstanding, pending */
  pledge?: InputMaybe<Scalars['String']['input']>;
  /** Filter by Pledge Amount; Accepts multiple parameters, with values like '100.0' */
  pledgeAmount?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter where Pledge Amount increased in the provided date range */
  pledgeAmountIncreasedRange?: InputMaybe<DateRangeInput>;
  /** Filter by Pledge Currency; Accepts multiple parameters, with values like 'USD' */
  pledgeCurrency?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by Pledge Frequency; Accepts multiple parameters, with numeric values like '0.23076923076923' (Weekly), '0.46153846153846' (Every 2 Weeks), '1.0' (Monthly), '2.0' (Every 2 Months), '3.0', '4.0', '6.0', '12.0' (Yearly), and '24.0' (Every 2 Years) */
  pledgeFrequency?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by Late By; Accepts values '', '0_30' (Less than 30 days late), '30_60' (More than 30 days late), '60_90' (More than 60 days late), or '90' (More than 90 days late) */
  pledgeLateBy?: InputMaybe<Scalars['String']['input']>;
  /** Filter by Pledge Received; Accepts values 'true', or 'false' */
  pledgeReceived?: InputMaybe<ContactFilterPledgeReceivedEnum>;
  /** Filter contacts with addresses in particular state; accepts accepts values 'primary', 'active', 'inactive', or 'null' */
  primaryAddress?: InputMaybe<Scalars['String']['input']>;
  /** Filter by Referrer; Accepts multiple parameters, with values 'none', 'any', or a Contact ID */
  referrer?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by Referrer ID; Accepts Comma separated list of Contact IDs */
  referrerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter by Region; Accepts multiple parameters, with values 'none', or a region name */
  region?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by Action; Accepts multiple parameters, with values 'none', or an activity type like 'Call' */
  relatedTaskAction?: InputMaybe<Array<ContactFilterActivityTypeEnum>>;
  reverseAlmaMater?: InputMaybe<Scalars['Boolean']['input']>;
  reverseAppeal?: InputMaybe<Scalars['Boolean']['input']>;
  reverseChurch?: InputMaybe<Scalars['Boolean']['input']>;
  reverseCity?: InputMaybe<Scalars['Boolean']['input']>;
  reverseContactType?: InputMaybe<Scalars['Boolean']['input']>;
  reverseCountry?: InputMaybe<Scalars['Boolean']['input']>;
  reverseDesignationAccountId?: InputMaybe<Scalars['Boolean']['input']>;
  reverseDonation?: InputMaybe<Scalars['Boolean']['input']>;
  reverseDonationAmount?: InputMaybe<Scalars['Boolean']['input']>;
  reverseIds?: InputMaybe<Scalars['Boolean']['input']>;
  reverseLikely?: InputMaybe<Scalars['Boolean']['input']>;
  reverseLocale?: InputMaybe<Scalars['Boolean']['input']>;
  reverseMetroArea?: InputMaybe<Scalars['Boolean']['input']>;
  reversePledgeAmount?: InputMaybe<Scalars['Boolean']['input']>;
  reversePledgeCurrency?: InputMaybe<Scalars['Boolean']['input']>;
  reversePledgeFrequency?: InputMaybe<Scalars['Boolean']['input']>;
  reverseReferrer?: InputMaybe<Scalars['Boolean']['input']>;
  reverseRegion?: InputMaybe<Scalars['Boolean']['input']>;
  reverseRelatedTaskAction?: InputMaybe<Scalars['Boolean']['input']>;
  reverseSource?: InputMaybe<Scalars['Boolean']['input']>;
  reverseState?: InputMaybe<Scalars['Boolean']['input']>;
  reverseStatus?: InputMaybe<Scalars['Boolean']['input']>;
  reverseTags?: InputMaybe<Scalars['Boolean']['input']>;
  reverseTimezone?: InputMaybe<Scalars['Boolean']['input']>;
  reverseUserIds?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by Source; Accepts multiple parameters */
  source?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by starred, is either selected or unselected */
  starred?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter where contact started giving in the provided date range */
  startedGivingRange?: InputMaybe<DateRangeInput>;
  /** Filter by State; Accepts multiple parameters, with values 'none', or a state */
  state?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by Status; Accepts multiple parameters, with values 'active', 'hidden', 'null', 'Never Contacted', 'Ask in Future', 'Cultivate Relationship', 'Contact for Appointment', 'Appointment Scheduled', 'Call for Decision', 'Partner - Financial', 'Partner - Special', 'Partner - Pray', 'Not Interested', 'Unresponsive', 'Never Ask', 'Research Abandoned', and 'Expired Referral' */
  status?: InputMaybe<Array<ContactFilterStatusEnum>>;
  /** Filter by Status Valid; Accepts values 'true', or 'false' */
  statusValid?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter where contact stopped giving in the provided date range */
  stoppedGivingRange?: InputMaybe<DateRangeInput>;
  /** Filter by Tags; Accepts multiple parameters, with text values separated by comma */
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by Due Date; Accepts date range with text value like 'MM/DD/YYYY - MM/DD/YYYY' */
  taskDueDate?: InputMaybe<DateRangeInput>;
  /** Filter where contact's tasks have completed set to true; accepts "true" */
  tasksAllCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by Timezone; Accepts multiple parameters */
  timezone?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter contacts that were updated in this date range */
  updatedAt?: InputMaybe<DateTimeRangeInput>;
  /** Filter contacts with user_ids included in this filter; comma separated value for multiple */
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter contacts where name contains this filter */
  wildcardSearch?: InputMaybe<Scalars['String']['input']>;
};

/** Input arguments for partner giving analysis */
export type PartnerGivingAnalysisReportInput = {
  accountListId: Scalars['ID']['input'];
  designationAccountId?: InputMaybe<Array<Scalars['ID']['input']>>;
  filters?: InputMaybe<PartnerGivingAnalysisFilterSetInput>;
  sortBy?: InputMaybe<PartnerGivingAnalysisSortEnum>;
};

/** Sort options for partner giving analysis */
export enum PartnerGivingAnalysisSortEnum {
  /** Sort by donation period average ascending */
  DonationPeriodAverageAsc = 'DONATION_PERIOD_AVERAGE_ASC',
  /** Sort by donation period average descending */
  DonationPeriodAverageDesc = 'DONATION_PERIOD_AVERAGE_DESC',
  /** Sort by donation period count ascending */
  DonationPeriodCountAsc = 'DONATION_PERIOD_COUNT_ASC',
  /** Sort by donation period count descending */
  DonationPeriodCountDesc = 'DONATION_PERIOD_COUNT_DESC',
  /** Sort by donation period percent rank ascending */
  DonationPeriodPercentRankAsc = 'DONATION_PERIOD_PERCENT_RANK_ASC',
  /** Sort by donation period percent rank descending */
  DonationPeriodPercentRankDesc = 'DONATION_PERIOD_PERCENT_RANK_DESC',
  /** Sort by donation period sum ascending */
  DonationPeriodSumAsc = 'DONATION_PERIOD_SUM_ASC',
  /** Sort by donation period sum descending */
  DonationPeriodSumDesc = 'DONATION_PERIOD_SUM_DESC',
  /** Sort by first donation amount ascending */
  FirstDonationAmountAsc = 'FIRST_DONATION_AMOUNT_ASC',
  /** Sort by first donation amount descending */
  FirstDonationAmountDesc = 'FIRST_DONATION_AMOUNT_DESC',
  /** Sort by first donation date ascending */
  FirstDonationDateAsc = 'FIRST_DONATION_DATE_ASC',
  /** Sort by first donation date descending */
  FirstDonationDateDesc = 'FIRST_DONATION_DATE_DESC',
  /** Sort by last donation amount ascending */
  LastDonationAmountAsc = 'LAST_DONATION_AMOUNT_ASC',
  /** Sort by last donation amount descending */
  LastDonationAmountDesc = 'LAST_DONATION_AMOUNT_DESC',
  /** Sort by last donation date ascending */
  LastDonationDateAsc = 'LAST_DONATION_DATE_ASC',
  /** Sort by last donation date descending */
  LastDonationDateDesc = 'LAST_DONATION_DATE_DESC',
  /** Sort by name ascending */
  NameAsc = 'NAME_ASC',
  /** Sort by name descending */
  NameDesc = 'NAME_DESC',
  /** Sort by pledge amount ascending */
  PledgeAmountAsc = 'PLEDGE_AMOUNT_ASC',
  /** Sort by pledge amount descending */
  PledgeAmountDesc = 'PLEDGE_AMOUNT_DESC',
  /** Sort by status ascending */
  StatusAsc = 'STATUS_ASC',
  /** Sort by status descending */
  StatusDesc = 'STATUS_DESC',
  /** Sort by total donations ascending */
  TotalDonationsAsc = 'TOTAL_DONATIONS_ASC',
  /** Sort by total donations descending */
  TotalDonationsDesc = 'TOTAL_DONATIONS_DESC',
}

/** HCM payroll information */
export type PayrollDate = {
  __typename?: 'PayrollDate';
  /** Date that the payroll ends (last day of work) */
  endDate: Scalars['String']['output'];
  /** Date that the payroll is processed */
  regularProcessDate: Scalars['String']['output'];
  /** Date that the payroll starts (first day of work) */
  startDate: Scalars['String']['output'];
};

export type People = {
  __typename?: 'People';
  periods: Array<PeoplePeriod>;
};

export enum PeopleGroupSupportTypeEnum {
  /** Designation */
  Designation = 'DESIGNATION',
  /** None */
  None = 'NONE',
  /** Supported NOT RMO */
  SupportedNonRmo = 'SUPPORTED_NON_RMO',
  /** Supported RMO */
  SupportedRmo = 'SUPPORTED_RMO',
}

export type PeoplePeriod = {
  __typename?: 'PeoplePeriod';
  endDate: Scalars['ISO8601Date']['output'];
  people: Array<PersonWithParentContact>;
  startDate: Scalars['ISO8601Date']['output'];
};

/** Autogenerated input type of PeopleUpdateMutation */
export type PeopleUpdateMutationInput = {
  /** AccountList ID that the people are associated with */
  accountListId: Scalars['ID']['input'];
  /** attributes to update */
  attributes: Array<PersonUpdateInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of PeopleUpdateMutation. */
export type PeopleUpdateMutationPayload = {
  __typename?: 'PeopleUpdateMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  people: Array<Person>;
};

export type Person = {
  __typename?: 'Person';
  almaMater?: Maybe<Scalars['String']['output']>;
  anniversaryDay?: Maybe<Scalars['Int']['output']>;
  anniversaryMonth?: Maybe<Scalars['Int']['output']>;
  anniversaryYear?: Maybe<Scalars['Int']['output']>;
  avatar: Scalars['String']['output'];
  birthdayDay?: Maybe<Scalars['Int']['output']>;
  birthdayMonth?: Maybe<Scalars['Int']['output']>;
  birthdayYear?: Maybe<Scalars['Int']['output']>;
  contactId: Scalars['ID']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  deceased: Scalars['Boolean']['output'];
  emailAddresses: EmailAddressConnection;
  employer?: Maybe<Scalars['String']['output']>;
  facebookAccounts: FacebookAccountConnection;
  familyRelationships: FamilyRelationshipConnection;
  firstName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  legalFirstName?: Maybe<Scalars['String']['output']>;
  linkedinAccounts: LinkedinAccountConnection;
  maritalStatus?: Maybe<Scalars['String']['output']>;
  occupation?: Maybe<Scalars['String']['output']>;
  optoutEnewsletter: Scalars['Boolean']['output'];
  phoneNumbers: PhoneNumberConnection;
  primaryEmailAddress?: Maybe<EmailAddress>;
  primaryPhoneNumber?: Maybe<PhoneNumber>;
  suffix?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  twitterAccounts: TwitterAccountConnection;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  websites: WebsiteConnection;
};

export type PersonEmailAddressesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PersonFacebookAccountsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PersonFamilyRelationshipsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PersonLinkedinAccountsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PersonPhoneNumbersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PersonTwitterAccountsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PersonWebsitesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for Person. */
export type PersonConnection = {
  __typename?: 'PersonConnection';
  /** A list of edges. */
  edges: Array<PersonEdge>;
  /** A list of nodes. */
  nodes: Array<Person>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total # of objects returned from this Plural Query */
  totalCount: Scalars['Int']['output'];
  /** Total # of pages, based on total count and pagesize */
  totalPageCount: Scalars['Int']['output'];
};

export type PersonCreateInput = {
  almaMater?: InputMaybe<Scalars['String']['input']>;
  anniversaryDay?: InputMaybe<Scalars['Int']['input']>;
  anniversaryMonth?: InputMaybe<Scalars['Int']['input']>;
  anniversaryYear?: InputMaybe<Scalars['Int']['input']>;
  birthdayDay?: InputMaybe<Scalars['Int']['input']>;
  birthdayMonth?: InputMaybe<Scalars['Int']['input']>;
  birthdayYear?: InputMaybe<Scalars['Int']['input']>;
  contactId: Scalars['ID']['input'];
  deceased?: InputMaybe<Scalars['Boolean']['input']>;
  emailAddresses?: InputMaybe<Array<PersonEmailAddressInput>>;
  employer?: InputMaybe<Scalars['String']['input']>;
  facebookAccounts?: InputMaybe<Array<PersonFacebookAccountInput>>;
  familyRelationships?: InputMaybe<Array<PersonFamilyRelationshipInput>>;
  firstName: Scalars['String']['input'];
  gender?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  legalFirstName?: InputMaybe<Scalars['String']['input']>;
  linkedinAccounts?: InputMaybe<Array<PersonLinkedinAccountInput>>;
  maritalStatus?: InputMaybe<Scalars['String']['input']>;
  occupation?: InputMaybe<Scalars['String']['input']>;
  optoutEnewsletter?: InputMaybe<Scalars['Boolean']['input']>;
  phoneNumbers?: InputMaybe<Array<PersonPhoneNumberInput>>;
  suffix?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  twitterAccounts?: InputMaybe<Array<PersonTwitterAccountInput>>;
  websites?: InputMaybe<Array<PersonWebsiteInput>>;
};

/** Autogenerated input type of PersonCreateMutation */
export type PersonCreateMutationInput = {
  /** AccountList ID that the person is associated with */
  accountListId: Scalars['ID']['input'];
  /** attributes to create */
  attributes: PersonCreateInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of PersonCreateMutation. */
export type PersonCreateMutationPayload = {
  __typename?: 'PersonCreateMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  person: Person;
};

/** Autogenerated input type of PersonDeleteMutation */
export type PersonDeleteMutationInput = {
  /** AccountList ID that the person is associated with */
  accountListId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of person to delete */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of PersonDeleteMutation. */
export type PersonDeleteMutationPayload = {
  __typename?: 'PersonDeleteMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type PersonDuplicate = {
  __typename?: 'PersonDuplicate';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  ignore: Scalars['Boolean']['output'];
  reason: ReasonEnum;
  recordOne: Person;
  recordTwo: Person;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** The connection type for PersonDuplicate. */
export type PersonDuplicateConnection = {
  __typename?: 'PersonDuplicateConnection';
  /** A list of edges. */
  edges: Array<PersonDuplicateEdge>;
  /** A list of nodes. */
  nodes: Array<PersonDuplicate>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total # of objects returned from this Plural Query */
  totalCount: Scalars['Int']['output'];
  /** Total # of pages, based on total count and pagesize */
  totalPageCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PersonDuplicateEdge = {
  __typename?: 'PersonDuplicateEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PersonDuplicate>;
};

/** An edge in a connection. */
export type PersonEdge = {
  __typename?: 'PersonEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Person>;
};

export type PersonEmailAddressInput = {
  destroy?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  historic?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  primary?: InputMaybe<Scalars['Boolean']['input']>;
  validValues?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PersonFacebookAccountInput = {
  destroy?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type PersonFamilyRelationshipInput = {
  destroy?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  relatedPersonId?: InputMaybe<Scalars['ID']['input']>;
  relationship?: InputMaybe<Scalars['String']['input']>;
};

export type PersonFilterSetInput = {
  contactIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter by Contact Status; Accepts multiple parameters, with values 'active', 'hidden', 'null', 'Never Contacted', 'Ask in Future', 'Cultivate Relationship', 'Contact for Appointment', 'Appointment Scheduled', 'Call for Decision', 'Partner - Financial', 'Partner - Special', 'Partner - Pray', 'Not Interested', 'Unresponsive', 'Never Ask', 'Research Abandoned', and 'Expired Referral' */
  contactStatus?: InputMaybe<Array<ContactFilterStatusEnum>>;
  /** Filter by deceased; Accepts values "true" and "false" */
  deceased?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Filter by Email Address Invalid; A Person's Email
   * Address is invalid if the Email Address's valid_values
   * attribute is set to false, or if the Person has
   * multiple Email Addresses marked as primary;
   * Accepts value "false"
   *
   */
  emailAddressValid?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Filter by Phone Number Invalid; A Person's Phone
   * Number is invalid if the Phone Number's valid_values
   * attribute is set to false, or if the Person has
   * multiple Phone Numbers marked as primary;
   * Accepts value "false"
   *
   */
  phoneNumberValid?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by Updated At Date range; Accepts date range with text value like "MM/DD/YYYY - MM/DD/YYYY" */
  updatedAt?: InputMaybe<DateTimeRangeInput>;
  /** Filter by keyword, searches through name, email_addresses and phone_numbers */
  wildcardSearch?: InputMaybe<Scalars['String']['input']>;
};

export type PersonLinkedinAccountInput = {
  destroy?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  publicUrl?: InputMaybe<Scalars['String']['input']>;
};

export type PersonPhoneNumberInput = {
  destroy?: InputMaybe<Scalars['Boolean']['input']>;
  historic?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  primary?: InputMaybe<Scalars['Boolean']['input']>;
  validValues?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PersonTwitterAccountInput = {
  destroy?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  screenName?: InputMaybe<Scalars['String']['input']>;
};

export type PersonUpdateInput = {
  almaMater?: InputMaybe<Scalars['String']['input']>;
  anniversaryDay?: InputMaybe<Scalars['Int']['input']>;
  anniversaryMonth?: InputMaybe<Scalars['Int']['input']>;
  anniversaryYear?: InputMaybe<Scalars['Int']['input']>;
  birthdayDay?: InputMaybe<Scalars['Int']['input']>;
  birthdayMonth?: InputMaybe<Scalars['Int']['input']>;
  birthdayYear?: InputMaybe<Scalars['Int']['input']>;
  deceased?: InputMaybe<Scalars['Boolean']['input']>;
  emailAddresses?: InputMaybe<Array<PersonEmailAddressInput>>;
  employer?: InputMaybe<Scalars['String']['input']>;
  facebookAccounts?: InputMaybe<Array<PersonFacebookAccountInput>>;
  familyRelationships?: InputMaybe<Array<PersonFamilyRelationshipInput>>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  legalFirstName?: InputMaybe<Scalars['String']['input']>;
  linkedinAccounts?: InputMaybe<Array<PersonLinkedinAccountInput>>;
  maritalStatus?: InputMaybe<Scalars['String']['input']>;
  occupation?: InputMaybe<Scalars['String']['input']>;
  optoutEnewsletter?: InputMaybe<Scalars['Boolean']['input']>;
  phoneNumbers?: InputMaybe<Array<PersonPhoneNumberInput>>;
  suffix?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  twitterAccounts?: InputMaybe<Array<PersonTwitterAccountInput>>;
  websites?: InputMaybe<Array<PersonWebsiteInput>>;
};

/** Autogenerated input type of PersonUpdateMutation */
export type PersonUpdateMutationInput = {
  /** AccountList ID that the person is associated with */
  accountListId: Scalars['ID']['input'];
  /** attributes to update */
  attributes: PersonUpdateInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of PersonUpdateMutation. */
export type PersonUpdateMutationPayload = {
  __typename?: 'PersonUpdateMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  person: Person;
};

export type PersonWebsiteInput = {
  destroy?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type PersonWithParentContact = {
  __typename?: 'PersonWithParentContact';
  almaMater?: Maybe<Scalars['String']['output']>;
  anniversaryDay?: Maybe<Scalars['Int']['output']>;
  anniversaryMonth?: Maybe<Scalars['Int']['output']>;
  anniversaryYear?: Maybe<Scalars['Int']['output']>;
  avatar: Scalars['String']['output'];
  birthdayDay?: Maybe<Scalars['Int']['output']>;
  birthdayMonth?: Maybe<Scalars['Int']['output']>;
  birthdayYear?: Maybe<Scalars['Int']['output']>;
  contactId: Scalars['ID']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  deceased: Scalars['Boolean']['output'];
  emailAddresses: EmailAddressConnection;
  employer?: Maybe<Scalars['String']['output']>;
  facebookAccounts: FacebookAccountConnection;
  familyRelationships: FamilyRelationshipConnection;
  firstName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  legalFirstName?: Maybe<Scalars['String']['output']>;
  linkedinAccounts: LinkedinAccountConnection;
  maritalStatus?: Maybe<Scalars['String']['output']>;
  occupation?: Maybe<Scalars['String']['output']>;
  optoutEnewsletter: Scalars['Boolean']['output'];
  parentContact: Contact;
  phoneNumbers: PhoneNumberConnection;
  primaryEmailAddress?: Maybe<EmailAddress>;
  primaryPhoneNumber?: Maybe<PhoneNumber>;
  suffix?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  twitterAccounts: TwitterAccountConnection;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  websites: WebsiteConnection;
};

export type PersonWithParentContactEmailAddressesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PersonWithParentContactFacebookAccountsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PersonWithParentContactFamilyRelationshipsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PersonWithParentContactLinkedinAccountsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PersonWithParentContactPhoneNumbersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PersonWithParentContactTwitterAccountsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PersonWithParentContactWebsitesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type Phase = {
  __typename?: 'Phase';
  contactStatuses: Array<StatusEnum>;
  id: PhaseEnum;
  name: Scalars['String']['output'];
  results?: Maybe<Result>;
  tasks?: Maybe<Array<ActivityTypeEnum>>;
};

export enum PhaseEnum {
  Appointment = 'APPOINTMENT',
  Archive = 'ARCHIVE',
  Connection = 'CONNECTION',
  FollowUp = 'FOLLOW_UP',
  Initiation = 'INITIATION',
  PartnerCare = 'PARTNER_CARE',
}

export type PhoneAccountListAnalytics = {
  __typename?: 'PhoneAccountListAnalytics';
  appointments: Scalars['Int']['output'];
  attempted: Scalars['Int']['output'];
  completed: Scalars['Int']['output'];
  received: Scalars['Int']['output'];
  talkToInPerson: Scalars['Int']['output'];
};

export type PhoneNumber = {
  __typename?: 'PhoneNumber';
  createdAt: Scalars['ISO8601DateTime']['output'];
  historic: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  location?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  primary: Scalars['Boolean']['output'];
  /** The source of the email address, for example "MPDX" if it was entered by a user, or "Siebel" if it was imported from the US Donation System */
  source: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  validValues: Scalars['Boolean']['output'];
};

/** The connection type for PhoneNumber. */
export type PhoneNumberConnection = {
  __typename?: 'PhoneNumberConnection';
  /** A list of edges. */
  edges: Array<PhoneNumberEdge>;
  /** A list of nodes. */
  nodes: Array<PhoneNumber>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total # of objects returned from this Plural Query */
  totalCount: Scalars['Int']['output'];
  /** Total # of pages, based on total count and pagesize */
  totalPageCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PhoneNumberEdge = {
  __typename?: 'PhoneNumberEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PhoneNumber>;
};

export type Pledge = {
  __typename?: 'Pledge';
  amount: Scalars['Float']['output'];
  amountCurrency?: Maybe<Scalars['String']['output']>;
  appeal: Appeal;
  contact: Contact;
  createdAt: Scalars['ISO8601DateTime']['output'];
  expectedDate: Scalars['ISO8601Date']['output'];
  id: Scalars['ID']['output'];
  status?: Maybe<PledgeStatusEnum>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** The connection type for Pledge. */
export type PledgeConnection = {
  __typename?: 'PledgeConnection';
  /** A list of edges. */
  edges: Array<PledgeEdge>;
  /** A list of nodes. */
  nodes: Array<Pledge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total # of objects returned from this Plural Query */
  totalCount: Scalars['Int']['output'];
  /** Total # of pages, based on total count and pagesize */
  totalPageCount: Scalars['Int']['output'];
};

export type PledgeCreateInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  amountCurrency?: InputMaybe<Scalars['String']['input']>;
  /** Appeal ID that the pledge will be associated with */
  appealId?: InputMaybe<Scalars['ID']['input']>;
  /** Contact ID that the pledge will be associated with */
  contactId?: InputMaybe<Scalars['ID']['input']>;
  createdAt?: InputMaybe<Scalars['ISO8601Date']['input']>;
  expectedDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  overwrite?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<PledgeStatusEnum>;
  updatedAt?: InputMaybe<Scalars['ISO8601Date']['input']>;
  updatedInDbAt?: InputMaybe<Scalars['ISO8601Date']['input']>;
};

/** An edge in a connection. */
export type PledgeEdge = {
  __typename?: 'PledgeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Pledge>;
};

export enum PledgeFrequencyEnum {
  Annual = 'ANNUAL',
  Every_2Months = 'EVERY_2_MONTHS',
  Every_2Weeks = 'EVERY_2_WEEKS',
  Every_2Years = 'EVERY_2_YEARS',
  Every_4Months = 'EVERY_4_MONTHS',
  Every_6Months = 'EVERY_6_MONTHS',
  Monthly = 'MONTHLY',
  Quarterly = 'QUARTERLY',
  Weekly = 'WEEKLY',
}

export enum PledgeSortEnum {
  AmountAsc = 'AMOUNT_ASC',
  AmountDesc = 'AMOUNT_DESC',
  ContactNameAsc = 'CONTACT_NAME_ASC',
  ContactNameDesc = 'CONTACT_NAME_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  ExpectedDateAsc = 'EXPECTED_DATE_ASC',
  ExpectedDateDesc = 'EXPECTED_DATE_DESC',
}

export enum PledgeStatusEnum {
  NotReceived = 'NOT_RECEIVED',
  Processed = 'PROCESSED',
  ReceivedNotProcessed = 'RECEIVED_NOT_PROCESSED',
}

export type PledgeUpdateInput = {
  amount: Scalars['Float']['input'];
  amountCurrency?: InputMaybe<Scalars['String']['input']>;
  /** Appeal ID that the pledge will be associated with */
  appealId: Scalars['ID']['input'];
  /** Contact ID that the pledge will be associated with */
  contactId: Scalars['ID']['input'];
  createdAt?: InputMaybe<Scalars['ISO8601Date']['input']>;
  expectedDate: Scalars['ISO8601Date']['input'];
  id: Scalars['ID']['input'];
  overwrite?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<PledgeStatusEnum>;
  updatedAt?: InputMaybe<Scalars['ISO8601Date']['input']>;
  updatedInDbAt?: InputMaybe<Scalars['ISO8601Date']['input']>;
};

export type PrayerlettersAccount = {
  __typename?: 'PrayerlettersAccount';
  validToken: Scalars['Boolean']['output'];
};

export type PrayerlettersAccountInput = {
  accountListId: Scalars['ID']['input'];
};

export type Preference = {
  __typename?: 'Preference';
  contactsFilter?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  hourToSendNotifications?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  locale?: Maybe<Scalars['String']['output']>;
  localeDisplay?: Maybe<Scalars['String']['output']>;
  tabOrders?: Maybe<Scalars['String']['output']>;
  tasksFilter?: Maybe<Scalars['String']['output']>;
  timeZone?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export enum PreferredContactMethodEnum {
  Email = 'EMAIL',
  Facebook = 'FACEBOOK',
  Instagram = 'INSTAGRAM',
  PhoneCall = 'PHONE_CALL',
  Sms = 'SMS',
  WeChat = 'WE_CHAT',
  WhatsApp = 'WHATS_APP',
}

export type PrimaryBudgetCategory = {
  __typename?: 'PrimaryBudgetCategory';
  category: PrimaryBudgetCategoryEnum;
  createdAt: Scalars['ISO8601DateTime']['output'];
  directInput?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  subBudgetCategories: Array<SubBudgetCategory>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export enum PrimaryBudgetCategoryEnum {
  AccountTransfers = 'ACCOUNT_TRANSFERS',
  CellPhoneWorkLine = 'CELL_PHONE_WORK_LINE',
  Clothing = 'CLOTHING',
  CreditCardProcessingCharges = 'CREDIT_CARD_PROCESSING_CHARGES',
  Debt = 'DEBT',
  Food = 'FOOD',
  Giving = 'GIVING',
  HouseholdOther = 'HOUSEHOLD_OTHER',
  Housing = 'HOUSING',
  Insurance = 'INSURANCE',
  InternetServiceProviderFee = 'INTERNET_SERVICE_PROVIDER_FEE',
  MealsAndPerDiem = 'MEALS_AND_PER_DIEM',
  Medical = 'MEDICAL',
  MeetingsRetreatsConferences = 'MEETINGS_RETREATS_CONFERENCES',
  MinistryAndMedicalMileage = 'MINISTRY_AND_MEDICAL_MILEAGE',
  MinistryOther = 'MINISTRY_OTHER',
  MinistryPartnerDevelopment = 'MINISTRY_PARTNER_DEVELOPMENT',
  MinistryTravel = 'MINISTRY_TRAVEL',
  OutsideIncome = 'OUTSIDE_INCOME',
  Personal = 'PERSONAL',
  Recreation = 'RECREATION',
  ReimbursableMedicalExpenses = 'REIMBURSABLE_MEDICAL_EXPENSES',
  Saving = 'SAVING',
  SpecialNeedsGoal = 'SPECIAL_NEEDS_GOAL',
  SummerAssignmentExpenses = 'SUMMER_ASSIGNMENT_EXPENSES',
  SuppliesAndMaterials = 'SUPPLIES_AND_MATERIALS',
  Transportation = 'TRANSPORTATION',
  UsStaffConference = 'US_STAFF_CONFERENCE',
  Utilities = 'UTILITIES',
}

export type PrimaryBudgetCategoryUpdateInput = {
  /** direct input attribute, clear with null */
  directInput?: InputMaybe<Scalars['Float']['input']>;
  /** ID of the primary budget category */
  id: Scalars['ID']['input'];
};

/** Autogenerated input type of PrimaryBudgetCategoryUpdateMutation */
export type PrimaryBudgetCategoryUpdateMutationInput = {
  /** AccountList ID that the primary budget category is associated with */
  accountListId: Scalars['ID']['input'];
  /** attributes to update */
  attributes: PrimaryBudgetCategoryUpdateInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of PrimaryBudgetCategoryUpdateMutation. */
export type PrimaryBudgetCategoryUpdateMutationPayload = {
  __typename?: 'PrimaryBudgetCategoryUpdateMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  primaryBudgetCategory: PrimaryBudgetCategory;
};

export type ProgressiveApprovalTier = {
  __typename?: 'ProgressiveApprovalTier';
  /** Human-readable approximate expected wait time for approval */
  approvalTimeframe: Scalars['String']['output'];
  /** Title of the person who approves these requests */
  approver: Scalars['String']['output'];
  /** Combined salary requests above this amount for couples require this tier of approval */
  combinedCap: Scalars['Int']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  /** Salary requests above this amount for singles require this tier of approval */
  individualCap: Scalars['Int']['output'];
  /** Enum identifier for this approval tier */
  tier: ProgressiveApprovalTierEnum;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export enum ProgressiveApprovalTierEnum {
  BoardCompensationCommittee = 'BOARD_COMPENSATION_COMMITTEE',
  DivisionHead = 'DIVISION_HEAD',
  ManagementCompensationCommittee = 'MANAGEMENT_COMPENSATION_COMMITTEE',
  VicePresident = 'VICE_PRESIDENT',
}

/** Reason the progressive approval tier reached its level */
export enum ProgressiveApprovalTierReasonEnum {
  /** User has a board cap exception */
  BoardCapException = 'BOARD_CAP_EXCEPTION',
  /** Couple's combined amount exceeds their combined salary cap */
  OverCombinedCap = 'OVER_COMBINED_CAP',
  /** Spouse's amount exceeds their individual salary cap */
  OverSpouseCap = 'OVER_SPOUSE_CAP',
  /** User's amount exceeds their individual salary cap */
  OverUserCap = 'OVER_USER_CAP',
}

/** A staff member's payroll history by fiscal quarter */
export type QuarterlyPayrollHistory = {
  __typename?: 'QuarterlyPayrollHistory';
  /** Fiscal quarters falling entirely within the history range */
  completedQuarters: Array<CompletedQuarterPayroll>;
  /** The staff member's monthly gross salary */
  monthlyGrossSalary?: Maybe<Scalars['Float']['output']>;
  /** The quarter where the staff member's payroll started (only if payroll started mid-quarter) */
  startingQuarter?: Maybe<StartingQuarterPayroll>;
};

export type Query = {
  __typename?: 'Query';
  _service: _Service;
  /** AccountList with a given ID */
  accountList: AccountList;
  accountListAnalytics: AccountListAnalytics;
  /** AccountListCoaches belonging to an AccountList */
  accountListCoaches: UserScopedToAccountListConnection;
  accountListDonorAccounts?: Maybe<Array<AccountListDonorAccount>>;
  /** AccountListInvite belonging to an AccountList */
  accountListInvites: AccountListInviteConnection;
  /** AccountListPledges belonging to an AccountList */
  accountListPledges: PledgeConnection;
  /** AccountListUsers belonging to an AccountList */
  accountListUsers: AccountListUserConnection;
  /** All current user AccountLists */
  accountLists: AccountListConnection;
  /** Address with a given ID */
  address: Address;
  /** All current user Addresses filterable by contactIds and validValues */
  addresses: AddressConnection;
  /** Announcements to display to the user via modal or banner */
  announcements: AnnouncementConnection;
  /** Appeal with a given ID */
  appeal: Appeal;
  /** AppealContacts belonging to an Appeal */
  appealContacts: AppealContactConnection;
  /** All Appeals filterable by primary */
  appeals: AppealConnection;
  appointmentResults: Array<ReportsAppointmentResultsPeriod>;
  canUserExportData: CanUserExportData;
  /** CoachingAccountList with a given ID */
  coachingAccountList: CoachingAccountList;
  /** CoachingAccountListPledges belonging to an AccountList viewed by a coach */
  coachingAccountListPledges: PledgeConnection;
  /** All current user CoachingAccountLists */
  coachingAccountLists: CoachingAccountListConnection;
  coachingAnswerSets: Array<CoachingAnswerSet>;
  /** List of constants */
  constant: Constant;
  /** Contact with a given ID */
  contact: Contact;
  /** Contact duplicates belonging to an AccountList alphabetically by last name */
  contactDuplicates: ContactDuplicateConnection;
  /** Contacts belonging to an AccountList */
  contacts: ContactConnection;
  /** Return the most recent incomplete coaching answer set, creating a new one if necessary */
  currentCoachingAnswerSet: CoachingAnswerSet;
  designationAccounts: Array<DesignationAccountsGroup>;
  /** DesignationSupportCalculation with nested relationships */
  designationSupportCalculation: DesignationSupportCalculation;
  /** DesignationSupportCalculations belonging to the current user */
  designationSupportCalculations: DesignationSupportCalculationConnection;
  /** Donation with a given ID */
  donation: Donation;
  /** Donations belonging to an AccountList */
  donations: DonationConnection;
  /** The current effective (approved, effective date in the past) salary request */
  effectiveSalaryRequest?: Maybe<SalaryRequest>;
  entryHistories?: Maybe<Array<EntryHistoriesGroup>>;
  expectedMonthlyTotalReport: ExpectedMonthlyTotalReport;
  /** FinancialAccount with a given ID */
  financialAccount: FinancialAccount;
  financialAccountEntries: FinancialAccountEntriesResponse;
  financialAccountSummary: Array<Maybe<FinancialAccountSummaryResponse>>;
  /** FinancialAccounts belonging to an AccountList */
  financialAccounts: FinancialAccountConnection;
  getAccountListCoaches?: Maybe<Array<Maybe<AccountListCoaches>>>;
  getDesignationDisplayNames?: Maybe<Array<Maybe<DesignationWithDisplayName>>>;
  getOrganizations: AllOrganizations;
  /** GoalCalculation with nested relationships */
  goalCalculation: GoalCalculation;
  /** GoalCalculations belonging to an AccountList */
  goalCalculations: GoalCalculationConnection;
  googleAccountIntegrations: Array<Maybe<GoogleAccountIntegration>>;
  googleAccounts: Array<Maybe<GoogleAccountAttributes>>;
  /** Fetch HCM data for a person and their spouse, defaulting to yourself */
  hcm: Array<Hcm>;
  /** Fetch individual multipliers data for a specified year */
  individualMultiplier?: Maybe<IndividualMultiplier>;
  /** Most recent additional salary request matching one of the provided statuses */
  latestAdditionalSalaryRequest?: Maybe<AdditionalSalaryRequest>;
  /** Most recent salary request matching one of the provided statuses */
  latestSalaryRequest?: Maybe<SalaryRequest>;
  mailchimpAccount?: Maybe<Array<Maybe<MailchimpAccount>>>;
  /** Fetch the user's managed staff list. A report of more than 100 staff is refused (FILTER_REQUIRED); narrow by name, team, department, assignment category, person type or negative months. */
  managedStaff: MpdManagedStaffConnection;
  /** Fetch every department the user's managed staff are in, including staff on no team. Drives the department filter on the managed staff report */
  managedStaffDepartments: Array<Scalars['String']['output']>;
  /** Fetch the distinct team names the user's managed staff are on, each with the departments of the staff on teams of that name. Drives the team filter on the managed staff report and narrows the department filter once a team is picked */
  managedStaffTeams: Array<MpdStaffTeamOption>;
  /** Applicant-selectable root ministries from OneApp, each exposing its sub-ministries */
  ministries: Array<Ministry>;
  /** Fetch a single Ministry Housing Allowance Request */
  ministryHousingAllowanceRequest?: Maybe<MinistryHousingAllowanceRequest>;
  /** Fetch all of the user's or spouse's Ministry Housing Allowance Requests */
  ministryHousingAllowanceRequests: MinistryHousingAllowanceRequestConnection;
  /** Fetch Ministry Partner Reminders for an AccountList */
  ministryPartnerReminders: Array<MinistryPartnerReminder>;
  /** Fetch a staff member's payroll history broken down by month */
  monthlyPayrollHistory: Array<MonthlyPayrollHistory>;
  /** Fetch a staff member's payroll summary broken down by month */
  monthlyPayrollSummary: Array<MonthlyPayrollSummary>;
  /** A single new-staff training cohort (MPD Goals team or coordinator only) */
  newStaffCohort: NewStaffCohort;
  /** MPDX users OneApp says may coach this cohort, for the admin table picker (MPD Goals team or coordinator only) */
  newStaffCohortAssignableCoaches: Array<NewStaffCohortAttendeeCoach>;
  /** New-staff training cohorts, newest first (MPD Goals team or coordinator only; paginated, default 25) */
  newStaffCohorts: NewStaffCohortConnection;
  /** The most recent new staff goal calculation for an account list, or one of your own scenario goals by id when account_list_id is omitted */
  newStaffGoalCalculation?: Maybe<NewStaffGoalCalculation>;
  /** The in-progress new staff questionnaire for an account list, if one exists */
  newStaffQuestionnaire?: Maybe<NewStaffQuestionnaire>;
  /** The current user's scenario goals — goal calculations not tied to an account list */
  newStaffScenarioGoals: NewStaffGoalCalculationConnection;
  /** Find Notification Preferences by AccountList */
  notificationPreferences: NotificationPreferenceConnection;
  /** NotificationType translated into the locale of the current user */
  notificationTypes: Array<NotificationType>;
  organizationAdmins: Array<Maybe<AdminList>>;
  organizationInvites: Array<Maybe<Invite>>;
  /** list of organizations available to be connected with MPDX */
  organizations: Array<Organization>;
  /** Partner giving analysis data */
  partnerGivingAnalysis: PartnerGivingAnalysisContactConnection;
  /** Fetch payroll time periods with processing dates from HCM API */
  payrollDates: Array<PayrollDate>;
  /** People belonging to an AccountList */
  people: PersonConnection;
  /** Person with a given ID */
  person: Person;
  /** Person duplicates belonging to an AccountList */
  personDuplicates: PersonDuplicateConnection;
  prayerlettersAccount?: Maybe<Array<Maybe<PrayerlettersAccount>>>;
  /** Fetch a staff member's payroll history broken down by fiscal quarter */
  quarterlyPayrollHistory: QuarterlyPayrollHistory;
  reportPledgeHistories?: Maybe<Array<Maybe<ReportsPledgeHistories>>>;
  /** Tasks activity completed by AccountList in the related periods */
  reportsActivityResults: ActivityResults;
  /** Donations received by AccountList in the related periods */
  reportsDonationHistories: DonationHistories;
  /** Fetches donor currency donations report data by donor currency */
  reportsDonorCurrencyDonations?: Maybe<DonorCurrencyDonations>;
  /** People associated with AccountList with an anniversary in the related periods */
  reportsPeopleWithAnniversaries: People;
  /** People associated with AccountList with a birthday in the related periods */
  reportsPeopleWithBirthdays: People;
  /** Fetches donor currency donations report data by salary currency */
  reportsSalaryCurrencyDonations?: Maybe<SalaryCurrencyDonations>;
  /** Savings fund transfers associated with the user's account */
  reportsSavingsFundTransfer: Array<SavingsFundTransfer>;
  /** Staff expenses associated with user's account */
  reportsStaffExpenses: StaffExpenses;
  /** Tag Histories Report */
  reportsTagHistories: TagHistories;
  /** Fetch salary info for a specified year */
  salaryInfo?: Maybe<SalaryInfo>;
  /** Retrieve a salary request by ID */
  salaryRequest: SalaryRequest;
  searchOrganizationsAccountLists: SearchOrganizationsAccountListsResponse;
  searchOrganizationsContacts: SearchOrganizationsContactsResponse;
  /** Staff account associated with user's account */
  staffAccount?: Maybe<StaffAccount>;
  /** Task with a given ID */
  task: Task;
  taskAnalytics: TaskAnalytics;
  /** Tasks belonging to an AccountList */
  tasks: TaskConnection;
  /** Fetch tenure data for a specified year */
  tenure?: Maybe<Tenure>;
  /** Current User */
  user: User;
  /** Notifications to show the user */
  userNotifications: NotificationConnection;
  /** Key Value store for custom frontend data */
  userOption?: Maybe<Option>;
  /** Key Value store for custom frontend data */
  userOptions: Array<Option>;
  /** OrganizationAccounts used to import data into MPDX */
  userOrganizationAccounts: Array<OrganizationAccount>;
};

export type QueryAccountListArgs = {
  id: Scalars['ID']['input'];
};

export type QueryAccountListAnalyticsArgs = {
  accountListId: Scalars['ID']['input'];
  dateRange?: InputMaybe<Scalars['String']['input']>;
};

export type QueryAccountListCoachesArgs = {
  accountListId: Scalars['ID']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryAccountListDonorAccountsArgs = {
  accountListId: Scalars['ID']['input'];
  searchTerm: Scalars['String']['input'];
};

export type QueryAccountListInvitesArgs = {
  accountListId: Scalars['ID']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inviteType?: InputMaybe<InviteTypeEnum>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryAccountListPledgesArgs = {
  accountListId: Scalars['ID']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  appealId?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  contactId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<PledgeSortEnum>;
  status?: InputMaybe<PledgeStatusEnum>;
};

export type QueryAccountListUsersArgs = {
  accountListId: Scalars['ID']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryAccountListsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryAddressArgs = {
  accountListId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type QueryAddressesArgs = {
  accountListId: Scalars['ID']['input'];
  addressableId?: InputMaybe<Array<Scalars['ID']['input']>>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  validValues?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryAnnouncementsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryAppealArgs = {
  accountListId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type QueryAppealContactsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  appealId: Scalars['ID']['input'];
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  pledgedToAppeal?: InputMaybe<Scalars['Boolean']['input']>;
  sortBy?: InputMaybe<ContactSortEnum>;
};

export type QueryAppealsArgs = {
  accountListId: Scalars['ID']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  primary?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryAppointmentResultsArgs = {
  accountListId: Scalars['ID']['input'];
  endDate?: InputMaybe<Scalars['String']['input']>;
  range: Scalars['String']['input'];
};

export type QueryCanUserExportDataArgs = {
  accountListId: Scalars['ID']['input'];
};

export type QueryCoachingAccountListArgs = {
  id: Scalars['ID']['input'];
};

export type QueryCoachingAccountListPledgesArgs = {
  accountListId: Scalars['ID']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  contactId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<PledgeSortEnum>;
};

export type QueryCoachingAccountListsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryCoachingAnswerSetsArgs = {
  accountListId: Scalars['ID']['input'];
  completed?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryContactArgs = {
  accountListId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type QueryContactDuplicatesArgs = {
  accountListId: Scalars['ID']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  contactIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ignore?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryContactsArgs = {
  accountListId: Scalars['ID']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  contactsFilter?: InputMaybe<ContactFilterSetInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<ContactSortEnum>;
};

export type QueryCurrentCoachingAnswerSetArgs = {
  accountListId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export type QueryDesignationAccountsArgs = {
  accountListId: Scalars['ID']['input'];
};

export type QueryDesignationSupportCalculationArgs = {
  id: Scalars['ID']['input'];
};

export type QueryDesignationSupportCalculationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryDonationArgs = {
  accountListId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type QueryDonationsArgs = {
  accountListId: Scalars['ID']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  appealId?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  designationAccountId?: InputMaybe<Array<Scalars['ID']['input']>>;
  donationDate?: InputMaybe<DateRangeInput>;
  donorAccountId?: InputMaybe<Array<Scalars['ID']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryEntryHistoriesArgs = {
  accountListId: Scalars['ID']['input'];
  financialAccountIds: Array<Scalars['ID']['input']>;
};

export type QueryExpectedMonthlyTotalReportArgs = {
  accountListId: Scalars['ID']['input'];
  designationAccountId?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type QueryFinancialAccountArgs = {
  accountListId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type QueryFinancialAccountEntriesArgs = {
  input: FinancialAccountEntriesInput;
};

export type QueryFinancialAccountSummaryArgs = {
  input: FinancialAccountSummaryInput;
};

export type QueryFinancialAccountsArgs = {
  accountListId: Scalars['ID']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  designationAccountId?: InputMaybe<Array<Scalars['ID']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryGetDesignationDisplayNamesArgs = {
  accountListId: Scalars['ID']['input'];
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
};

export type QueryGoalCalculationArgs = {
  accountListId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type QueryGoalCalculationsArgs = {
  accountListId: Scalars['ID']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isCurrent?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryGoogleAccountIntegrationsArgs = {
  input: GoogleAccountIntegrationsInput;
};

export type QueryHcmArgs = {
  effectiveDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  personNumber?: InputMaybe<Scalars['String']['input']>;
  refresh?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryIndividualMultiplierArgs = {
  year: Scalars['Int']['input'];
};

export type QueryLatestAdditionalSalaryRequestArgs = {
  isSpouse?: InputMaybe<Scalars['Boolean']['input']>;
  status: Array<AsrStatusEnum>;
};

export type QueryLatestSalaryRequestArgs = {
  status: Array<SalaryRequestStatusEnum>;
};

export type QueryMailchimpAccountArgs = {
  input: MailchimpAccountInput;
};

export type QueryManagedStaffArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  assignmentCategoryGroup?: InputMaybe<MpdAssignmentCategoryGroupEnum>;
  before?: InputMaybe<Scalars['String']['input']>;
  departments?: InputMaybe<Array<Scalars['String']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  negativeLastMonth?: InputMaybe<Scalars['Boolean']['input']>;
  negativeThreeMonths?: InputMaybe<Scalars['Boolean']['input']>;
  teamNames?: InputMaybe<Array<Scalars['String']['input']>>;
  userPersonTypes?: InputMaybe<Array<MpdUserPersonTypeEnum>>;
};

export type QueryMinistryHousingAllowanceRequestArgs = {
  id: Scalars['ID']['input'];
};

export type QueryMinistryHousingAllowanceRequestsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryMinistryPartnerRemindersArgs = {
  accountListId: Scalars['ID']['input'];
  designationNumber: Scalars['String']['input'];
};

export type QueryMonthlyPayrollHistoryArgs = {
  staffAccountId?: InputMaybe<Scalars['String']['input']>;
};

export type QueryMonthlyPayrollSummaryArgs = {
  staffAccountId?: InputMaybe<Scalars['String']['input']>;
};

export type QueryNewStaffCohortArgs = {
  id: Scalars['ID']['input'];
};

export type QueryNewStaffCohortAssignableCoachesArgs = {
  attendeeId?: InputMaybe<Scalars['ID']['input']>;
  cohortId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryNewStaffCohortsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryNewStaffGoalCalculationArgs = {
  accountListId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryNewStaffQuestionnaireArgs = {
  accountListId: Scalars['ID']['input'];
};

export type QueryNewStaffScenarioGoalsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<NewStaffGoalCalculationSortEnum>;
};

export type QueryNotificationPreferencesArgs = {
  accountListId: Scalars['ID']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryOrganizationAdminsArgs = {
  input: OrganizationAdminsInput;
};

export type QueryOrganizationInvitesArgs = {
  input: OrganizationInvitesInput;
};

export type QueryPartnerGivingAnalysisArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input: PartnerGivingAnalysisReportInput;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryPeopleArgs = {
  accountListId: Scalars['ID']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  peopleFilter?: InputMaybe<PersonFilterSetInput>;
};

export type QueryPersonArgs = {
  accountListId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type QueryPersonDuplicatesArgs = {
  accountListId: Scalars['ID']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ignore?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryPrayerlettersAccountArgs = {
  input: PrayerlettersAccountInput;
};

export type QueryQuarterlyPayrollHistoryArgs = {
  historyRange?: InputMaybe<MpdHistoryRangeEnum>;
  staffAccountId?: InputMaybe<Scalars['String']['input']>;
  userPersonType?: InputMaybe<MpdUserPersonTypeEnum>;
};

export type QueryReportPledgeHistoriesArgs = {
  accountListId: Scalars['ID']['input'];
  endDate?: InputMaybe<Scalars['String']['input']>;
  range?: InputMaybe<Scalars['String']['input']>;
};

export type QueryReportsActivityResultsArgs = {
  accountListId: Scalars['ID']['input'];
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  range?: InputMaybe<Scalars['String']['input']>;
};

export type QueryReportsDonationHistoriesArgs = {
  accountListId: Scalars['ID']['input'];
  designationAccountId?: InputMaybe<Array<Scalars['ID']['input']>>;
  donorAccountId?: InputMaybe<Array<Scalars['ID']['input']>>;
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  range?: InputMaybe<Scalars['String']['input']>;
};

export type QueryReportsDonorCurrencyDonationsArgs = {
  accountListId: Scalars['ID']['input'];
  designationAccountId?: InputMaybe<Array<Scalars['ID']['input']>>;
  donorAccountId?: InputMaybe<Array<Scalars['ID']['input']>>;
  endDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  range?: InputMaybe<Scalars['String']['input']>;
};

export type QueryReportsPeopleWithAnniversariesArgs = {
  accountListId: Scalars['ID']['input'];
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  range?: InputMaybe<Scalars['String']['input']>;
};

export type QueryReportsPeopleWithBirthdaysArgs = {
  accountListId: Scalars['ID']['input'];
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  range?: InputMaybe<Scalars['String']['input']>;
};

export type QueryReportsSalaryCurrencyDonationsArgs = {
  accountListId: Scalars['ID']['input'];
  designationAccountId?: InputMaybe<Array<Scalars['ID']['input']>>;
  donorAccountId?: InputMaybe<Array<Scalars['ID']['input']>>;
  endDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  range?: InputMaybe<Scalars['String']['input']>;
};

export type QueryReportsSavingsFundTransferArgs = {
  fundTypeName?: InputMaybe<Array<Scalars['String']['input']>>;
  subCategoryName?: InputMaybe<Array<Scalars['String']['input']>>;
  transactedAtEnd?: InputMaybe<Scalars['ISO8601Date']['input']>;
  transactedAtStart?: InputMaybe<Scalars['ISO8601Date']['input']>;
};

export type QueryReportsStaffExpensesArgs = {
  endMonth?: InputMaybe<Scalars['ISO8601Date']['input']>;
  fundTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  staffAccountId?: InputMaybe<Scalars['String']['input']>;
  startMonth?: InputMaybe<Scalars['ISO8601Date']['input']>;
};

export type QueryReportsTagHistoriesArgs = {
  accountListId: Scalars['ID']['input'];
  association?: InputMaybe<ReportsTagHistoriesAssociationEnum>;
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  range?: InputMaybe<Scalars['String']['input']>;
};

export type QuerySalaryInfoArgs = {
  year: Scalars['Int']['input'];
};

export type QuerySalaryRequestArgs = {
  id: Scalars['ID']['input'];
};

export type QuerySearchOrganizationsAccountListsArgs = {
  input: SearchOrganizationsAccountListsInput;
};

export type QuerySearchOrganizationsContactsArgs = {
  input: SearchOrganizationsContactsInput;
};

export type QueryTaskArgs = {
  accountListId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type QueryTaskAnalyticsArgs = {
  accountListId: Scalars['ID']['input'];
};

export type QueryTasksArgs = {
  accountListId: Scalars['ID']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<TaskSortEnum>;
  tasksFilter?: InputMaybe<TaskFilterSetInput>;
};

export type QueryTenureArgs = {
  year: Scalars['Int']['input'];
};

export type QueryUserNotificationsArgs = {
  accountListId?: InputMaybe<Scalars['ID']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryUserOptionArgs = {
  key: Scalars['String']['input'];
};

export type QueryUserOptionsArgs = {
  key?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type RadioFilter = Filter & {
  __typename?: 'RadioFilter';
  defaultSelection?: Maybe<Scalars['String']['output']>;
  filterKey: Scalars['String']['output'];
  options?: Maybe<Array<FilterOption>>;
  title: Scalars['String']['output'];
};

export enum ReasonEnum {
  SameDonorAccountNumber = 'SAME_DONOR_ACCOUNT_NUMBER',
  SimilarEmailAddresses = 'SIMILAR_EMAIL_ADDRESSES',
  SimilarNames = 'SIMILAR_NAMES',
  SimilarPhoneNumbers = 'SIMILAR_PHONE_NUMBERS',
}

/** Autogenerated input type of RecurringTransferCreateMutation */
export type RecurringTransferCreateMutationInput = {
  amount: Scalars['Float']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  destinationFundTypeName: Scalars['String']['input'];
  recurringEnd?: InputMaybe<Scalars['ISO8601Date']['input']>;
  recurringStart: Scalars['ISO8601Date']['input'];
  sourceFundTypeName: Scalars['String']['input'];
};

/** Autogenerated return type of RecurringTransferCreateMutation. */
export type RecurringTransferCreateMutationPayload = {
  __typename?: 'RecurringTransferCreateMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

/** Autogenerated input type of RecurringTransferDeleteMutation */
export type RecurringTransferDeleteMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of recurring transfer to delete */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of RecurringTransferDeleteMutation. */
export type RecurringTransferDeleteMutationPayload = {
  __typename?: 'RecurringTransferDeleteMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

/** Autogenerated input type of RecurringTransferUpdateMutation */
export type RecurringTransferUpdateMutationInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of recurring transfer to update */
  id: Scalars['ID']['input'];
  recurringEnd?: InputMaybe<Scalars['ISO8601Date']['input']>;
  recurringStart?: InputMaybe<Scalars['ISO8601Date']['input']>;
};

/** Autogenerated return type of RecurringTransferUpdateMutation. */
export type RecurringTransferUpdateMutationPayload = {
  __typename?: 'RecurringTransferUpdateMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type Referral = {
  __typename?: 'Referral';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  referredBy: Contact;
  referredTo: Contact;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** The connection type for Referral. */
export type ReferralConnection = {
  __typename?: 'ReferralConnection';
  /** A list of edges. */
  edges: Array<ReferralEdge>;
  /** A list of nodes. */
  nodes: Array<Referral>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total # of objects returned from this Plural Query */
  totalCount: Scalars['Int']['output'];
  /** Total # of pages, based on total count and pagesize */
  totalPageCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ReferralEdge = {
  __typename?: 'ReferralEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Referral>;
};

export type ReportsAppointmentResultsPeriod = {
  __typename?: 'ReportsAppointmentResultsPeriod';
  appointmentsScheduled: Scalars['Int']['output'];
  endDate: Scalars['ISO8601DateTime']['output'];
  groupAppointments: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  individualAppointments: Scalars['Int']['output'];
  monthlyDecrease: Scalars['Float']['output'];
  monthlyIncrease: Scalars['Float']['output'];
  newMonthlyPartners: Scalars['Int']['output'];
  newSpecialPledges: Scalars['Int']['output'];
  pledgeIncrease: Scalars['Float']['output'];
  specialGifts: Scalars['Float']['output'];
  startDate: Scalars['ISO8601DateTime']['output'];
  type: Scalars['String']['output'];
  weeklyIndividualAppointmentGoal: Scalars['Int']['output'];
};

export type ReportsPledgeHistories = {
  __typename?: 'ReportsPledgeHistories';
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  endDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  pledged?: Maybe<Scalars['Float']['output']>;
  received?: Maybe<Scalars['Float']['output']>;
  startDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  updatedInDbAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export enum ReportsTagHistoriesAssociationEnum {
  Contacts = 'CONTACTS',
  Tasks = 'TASKS',
}

export type Result = {
  __typename?: 'Result';
  resultOptions?: Maybe<Array<ResultOption>>;
  tags?: Maybe<Array<IdValue>>;
};

export enum ResultEnum {
  Attempted = 'ATTEMPTED',
  AttemptedLeftMessage = 'ATTEMPTED_LEFT_MESSAGE',
  Completed = 'COMPLETED',
  Done = 'DONE',
  /** special type when filtered by will return any task with no result */
  None = 'NONE',
  Received = 'RECEIVED',
}

export type ResultOption = {
  __typename?: 'ResultOption';
  dbResult?: Maybe<Array<TaskResultPair>>;
  name: DisplayResultEnum;
  suggestedContactStatus?: Maybe<StatusEnum>;
  suggestedNextActions?: Maybe<Array<ActivityTypeEnum>>;
  value?: Maybe<Scalars['String']['output']>;
};

export type SalaryCurrencyDonations = {
  __typename?: 'SalaryCurrencyDonations';
  /** Associated account list */
  accountList: AccountList;
  /** Donations grouped by currency */
  currencyGroups: Scalars['JSON']['output'];
  /** Default currency for the account list */
  defaultCurrency: Scalars['String']['output'];
  /** Information about donors */
  donorInfos: Array<DonorInfo>;
  /** Months in the report */
  months: Array<Scalars['String']['output']>;
};

export type SalaryInfo = {
  __typename?: 'SalaryInfo';
  annualBase: Scalars['Float']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  maxAdoptionInt: Scalars['Float']['output'];
  maxAdoptionUss: Scalars['Float']['output'];
  maxAutoPurchaseInt: Scalars['Float']['output'];
  maxAutoPurchaseUss: Scalars['Float']['output'];
  maxCollegeInt: Scalars['Float']['output'];
  maxCollegeUss: Scalars['Float']['output'];
  maxFamilyInt: Scalars['Float']['output'];
  maxFamilyNyc: Scalars['Float']['output'];
  maxFamilyUss: Scalars['Float']['output'];
  maxHousingDownPaymentInt: Scalars['Float']['output'];
  maxHousingDownPaymentUss: Scalars['Float']['output'];
  maxSingleInt: Scalars['Float']['output'];
  maxSingleNyc: Scalars['Float']['output'];
  maxSingleUss: Scalars['Float']['output'];
  minRequiredSalary: Scalars['Float']['output'];
  secaEstimate: Scalars['Float']['output'];
  secaestAt403bInt: Scalars['Float']['output'];
  secaestNo403bInt: Scalars['Float']['output'];
  secaestPt403bInt: Scalars['Float']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  year: Scalars['Int']['output'];
};

export type SalaryRequest = {
  __typename?: 'SalaryRequest';
  additionalInfo?: Maybe<Scalars['String']['output']>;
  /** Timestamp when the request was approved */
  approvedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  calculations: SalaryRequestCalculations;
  /** Timestamp when the request was canceled */
  canceledAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Timestamp when changes were requested for the request */
  changesRequestedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Start date of the payroll when this request will take effect */
  effectiveDate?: Maybe<Scalars['ISO8601Date']['output']>;
  emailAddress?: Maybe<Scalars['String']['output']>;
  feedback?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  location?: Maybe<Scalars['String']['output']>;
  manuallySplitCap: Scalars['Boolean']['output'];
  mhaAmount?: Maybe<Scalars['Float']['output']>;
  personNumber: Scalars['String']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** The progressive approval tier required based on requested gross salary */
  progressiveApprovalTier?: Maybe<ProgressiveApprovalTier>;
  /** Reason why the progressive approval is required */
  progressiveApprovalTierReason?: Maybe<ProgressiveApprovalTierReasonEnum>;
  salary?: Maybe<Scalars['Float']['output']>;
  salaryCap?: Maybe<Scalars['Float']['output']>;
  /**
   * Indicates whether the couple's combined individual caps exceed their combined cap
   * and they need to split their combined cap between each other
   */
  splitCapRequired: Scalars['Boolean']['output'];
  spouseCalculations?: Maybe<SalaryRequestCalculations>;
  spouseMhaAmount?: Maybe<Scalars['Float']['output']>;
  spouseSalary?: Maybe<Scalars['Float']['output']>;
  spouseSalaryCap?: Maybe<Scalars['Float']['output']>;
  status: SalaryRequestStatusEnum;
  /** Timestamp when the request was submitted */
  submittedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type SalaryRequestCalculations = {
  __typename?: 'SalaryRequestCalculations';
  /**
   * Additional salary
   * Line 2 (annual base * individual multiplier)
   */
  additionalSalary: Scalars['Float']['output'];
  /**
   * Annual base salary
   * Line 1
   */
  annualBase: Scalars['Float']['output'];
  /**
   * Annual compensation rate
   * Line 22 (line 20 + line 21)
   */
  annualCompensation: Scalars['Float']['output'];
  /**
   * Salary subtotal with SECA
   * Line 7 (line 5 + line 6)
   */
  capWithSeca: Scalars['Float']['output'];
  /** Maximum combined allowable salary for the household */
  combinedCap: Scalars['Float']['output'];
  /**
   * Amount contributing to 403(b)
   * Line 21 (line 14 - 12)
   */
  contributing403bAmount: Scalars['Float']['output'];
  /**
   * Fraction of paycheck dedicated to 403(b) contributions
   * Line 8a
   */
  contributing403bFraction: Scalars['Float']['output'];
  /**
   * Amount contributing to Roth 403(b)
   * Line 21b
   */
  contributingRothAmount: Scalars['Float']['output'];
  /**
   * Amount contributing to tax-deferred 403(b)
   * Line 21a
   */
  contributingTaxDeferredAmount: Scalars['Float']['output'];
  /**
   * Maximum allowable salary based on calculated cap or chosen cap and clipped to the individual cap
   * (or the board cap as-is when the user has one)
   * Line 9b
   */
  effectiveCap: Scalars['Float']['output'];
  /** Salary cap exception for the individual */
  exceptionCap?: Maybe<Scalars['Float']['output']>;
  /**
   * Maximum combined allowable salary for a couple or widow/widower
   * Line 9 help text
   */
  familyCap: Scalars['Float']['output'];
  /**
   * Salary adjustment based on geographic cost of living
   * Line 3 (line 2 * geographic multiplier)
   */
  geographicAdjustment: Scalars['Float']['output'];
  /**
   * Geographic cost of living multiplier based on salary request location
   * Line 3 help text
   */
  geographicMultiplier: Scalars['Float']['output'];
  /**
   * Maximum allowable salary for this individual
   * Equals the family cap if they are a widow/widower and equals the individual cap otherwise
   * Line 9 help text
   */
  hardCap: Scalars['Float']['output'];
  /**
   * Maximum allowable salary for an individual
   * Line 9 help text
   */
  individualCap: Scalars['Float']['output'];
  /**
   * Salary multiplier based on marital status, number of dependents, and age
   * Line 2 help text
   */
  individualMultiplier: Scalars['Float']['output'];
  /** Minimum requested salary that will meet the minimum required salary */
  minimumRequestedSalary: Scalars['Float']['output'];
  /**
   * Minimum salary required to fulfill IRS requirements
   * MHA and SECA do not count towards this minimum
   * Lines 15 and 19
   */
  minimumRequiredSalary: Scalars['Float']['output'];
  /**
   * Fraction of paycheck not dedicated to 403(b) contributions
   * Line 8b (1 - 403(b) fraction)
   */
  non403bFraction: Scalars['Float']['output'];
  /**
   * Salary subtotal without SECA
   * Line 5 (line 3 + line 4)
   */
  oldSalaryCap: Scalars['Float']['output'];
  /**
   * SECA amount for salary subtotal
   * Line 6 (line 5 * estimated seca fraction)
   */
  oldSecaAmount: Scalars['Float']['output'];
  /**
   * Calculated maximum allowable salary without considering the individual cap
   * Line 9a (line 7 / line 8b)
   */
  personalFactorsCap: Scalars['Float']['output'];
  /**
   * Salary requested above the minimum excluding MHA
   * Line 18 (line 16 - line 17)
   */
  requestedAboveMha: Scalars['Float']['output'];
  /**
   * Salary requested above the minimum
   * Line 16 (line 12 - line 15)
   */
  requestedAboveMinimum: Scalars['Float']['output'];
  /**
   * Requested gross salary including SECA and 403(b) contributions
   * Line 14 (line 12 / [1 - 403(b) fraction])
   */
  requestedGross: Scalars['Float']['output'];
  /**
   * MHA amount requested in this salary request
   * Line 17
   */
  requestedMha: Scalars['Float']['output'];
  /**
   * SECA amount of requested salary
   * Line 11
   */
  requestedSeca: Scalars['Float']['output'];
  /**
   * Requested salary with SECA
   * Line 12
   */
  requestedWithSeca: Scalars['Float']['output'];
  /** Requested gross salary plus ytdAsrAmount */
  requestedYtdGross: Scalars['Float']['output'];
  /**
   * Estimated fraction of paycheck dedicated to SECA
   * Line 6a
   */
  secaEstimatedFraction: Scalars['Float']['output'];
  /**
   * Taxable annual compensation rate
   * Line 20 (line 18 + 19)
   */
  taxableCompensation: Scalars['Float']['output'];
  /**
   * Salary adjustment based on tenure
   * Line 4
   */
  tenureAdjustment: Scalars['Float']['output'];
  /** Portion of ytdAsrAmount that has been requested but is awaiting approval or payment */
  unpaidAsrAmount: Scalars['Float']['output'];
  /**
   * This year's additional salary that counts toward the user's salary cap: HCM's year-to-date
   * additional salary (all payroll systems, not counting current-year backpay on paid ASRs) plus the non-backpay portion
   * of pending, action required and approved-but-unpaid ASRs and of paid ASRs whose pay date HCM's year-to-date hasn't
   * reached.
   */
  ytdAsrAmount: Scalars['Float']['output'];
};

export type SalaryRequestCreateInput = {
  additionalInfo?: InputMaybe<Scalars['String']['input']>;
  effectiveDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  manuallySplitCap?: InputMaybe<Scalars['Boolean']['input']>;
  mhaAmount?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  salary?: InputMaybe<Scalars['Float']['input']>;
  salaryCap?: InputMaybe<Scalars['Float']['input']>;
  spouseMhaAmount?: InputMaybe<Scalars['Float']['input']>;
  spouseSalary?: InputMaybe<Scalars['Float']['input']>;
  spouseSalaryCap?: InputMaybe<Scalars['Float']['input']>;
};

/** Autogenerated input type of SalaryRequestCreateMutation */
export type SalaryRequestCreateMutationInput = {
  attributes?: InputMaybe<SalaryRequestCreateInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of SalaryRequestCreateMutation. */
export type SalaryRequestCreateMutationPayload = {
  __typename?: 'SalaryRequestCreateMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  salaryRequest: SalaryRequest;
};

/** Autogenerated input type of SalaryRequestDeleteMutation */
export type SalaryRequestDeleteMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the salary request to delete */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of SalaryRequestDeleteMutation. */
export type SalaryRequestDeleteMutationPayload = {
  __typename?: 'SalaryRequestDeleteMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export enum SalaryRequestStatusEnum {
  ActionRequired = 'ACTION_REQUIRED',
  Approved = 'APPROVED',
  Canceled = 'CANCELED',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING',
}

/** Autogenerated input type of SalaryRequestSubmitMutation */
export type SalaryRequestSubmitMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the salary request to submit */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of SalaryRequestSubmitMutation. */
export type SalaryRequestSubmitMutationPayload = {
  __typename?: 'SalaryRequestSubmitMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  salaryRequest: SalaryRequest;
};

export type SalaryRequestUpdateInput = {
  additionalInfo?: InputMaybe<Scalars['String']['input']>;
  effectiveDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  location?: InputMaybe<Scalars['String']['input']>;
  manuallySplitCap?: InputMaybe<Scalars['Boolean']['input']>;
  mhaAmount?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  salary?: InputMaybe<Scalars['Float']['input']>;
  salaryCap?: InputMaybe<Scalars['Float']['input']>;
  spouseMhaAmount?: InputMaybe<Scalars['Float']['input']>;
  spouseSalary?: InputMaybe<Scalars['Float']['input']>;
  spouseSalaryCap?: InputMaybe<Scalars['Float']['input']>;
};

/** Autogenerated input type of SalaryRequestUpdateMutation */
export type SalaryRequestUpdateMutationInput = {
  attributes: SalaryRequestUpdateInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of SalaryRequestUpdateMutation. */
export type SalaryRequestUpdateMutationPayload = {
  __typename?: 'SalaryRequestUpdateMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  salaryRequest: SalaryRequest;
};

export type SaveCoachingAnswerInput = {
  answerId?: InputMaybe<Scalars['String']['input']>;
  answerSetId: Scalars['String']['input'];
  questionId: Scalars['String']['input'];
  response: Scalars['String']['input'];
};

export type SavingsFundTransfer = {
  __typename?: 'SavingsFundTransfer';
  fund?: Maybe<SavingsFundTransferFund>;
  recurringTransfer?: Maybe<SavingsFundTransferRecurringTransfer>;
  scheduledTransfer?: Maybe<SavingsFundTransferScheduledTransfer>;
  subCategory?: Maybe<SavingsFundTransferSubCategory>;
  transaction?: Maybe<SavingsFundTransferTransaction>;
  transfer: Transfer;
};

/** Why a recurring transfer month could not be completed */
export enum SavingsFundTransferFailureReasonCode {
  /** The staff account was inactive */
  InactiveAccount = 'INACTIVE_ACCOUNT',
  /** The transfer would have taken the fund below its deficit limit */
  InsufficientFunds = 'INSUFFICIENT_FUNDS',
  /** The account had no fund for the source or destination fund type */
  MissingFundType = 'MISSING_FUND_TYPE',
  /** No transfer attempt ran before the retry window closed */
  NotAttempted = 'NOT_ATTEMPTED',
  /** Any other reason, including codes this API does not recognize yet */
  Other = 'OTHER',
  /** The transfer date fell in a period that was already settled */
  SettledPeriod = 'SETTLED_PERIOD',
}

export type SavingsFundTransferFund = {
  __typename?: 'SavingsFundTransferFund';
  balance: Scalars['Float']['output'];
  fundType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type SavingsFundTransferRecurringTransfer = {
  __typename?: 'SavingsFundTransferRecurringTransfer';
  active: Scalars['Boolean']['output'];
  amount: Scalars['Float']['output'];
  failures: Array<SavingsFundTransferRecurringTransferFailure>;
  id: Scalars['ID']['output'];
  recurringEnd?: Maybe<Scalars['ISO8601Date']['output']>;
  recurringStart: Scalars['ISO8601Date']['output'];
};

export type SavingsFundTransferRecurringTransferFailure = {
  __typename?: 'SavingsFundTransferRecurringTransferFailure';
  occurrence: Scalars['ISO8601Date']['output'];
  reasonCode: SavingsFundTransferFailureReasonCode;
};

export type SavingsFundTransferScheduledTransfer = {
  __typename?: 'SavingsFundTransferScheduledTransfer';
  amount: Scalars['Float']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  transactedAt: Scalars['ISO8601DateTime']['output'];
};

export type SavingsFundTransferSubCategory = {
  __typename?: 'SavingsFundTransferSubCategory';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type SavingsFundTransferTransaction = {
  __typename?: 'SavingsFundTransferTransaction';
  amount: Scalars['Float']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  transactedAt: Scalars['ISO8601DateTime']['output'];
};

export type SearchOrganizationsAccountListsInput = {
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  search: Scalars['String']['input'];
};

export type SearchOrganizationsAccountListsResponse = {
  __typename?: 'SearchOrganizationsAccountListsResponse';
  accountLists: Array<Maybe<OrganizationsAccountList>>;
  pagination: Pagination;
};

export type SearchOrganizationsContactsInput = {
  organizationId: Scalars['ID']['input'];
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  search: Scalars['String']['input'];
};

export type SearchOrganizationsContactsResponse = {
  __typename?: 'SearchOrganizationsContactsResponse';
  contacts: Array<Maybe<OrganizationsContact>>;
  pagination: Pagination;
};

export enum SecaStatusEnum {
  /** Employee is subject to FICA tax instead of SECA tax */
  Fica = 'FICA',
  /** Employee is exempt from SECA tax */
  Optout = 'OPTOUT',
  /** Employee is subject to SECA tax */
  Seca = 'SECA',
}

export enum SendNewsletterEnum {
  Both = 'BOTH',
  Email = 'EMAIL',
  None = 'NONE',
  Physical = 'PHYSICAL',
}

export type SendToChalklineInput = {
  accountListId: Scalars['ID']['input'];
};

export type SetActiveDesignationAccountInput = {
  accountListId: Scalars['ID']['input'];
  active: Scalars['Boolean']['input'];
  designationAccountId: Scalars['ID']['input'];
};

export type SetActiveFinancialAccountInput = {
  accountListId: Scalars['ID']['input'];
  active: Scalars['Boolean']['input'];
  financialAccountId: Scalars['ID']['input'];
};

export type SetActiveFinancialAccountRest = {
  __typename?: 'SetActiveFinancialAccountRest';
  active: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
};

export type StaffAccount = {
  __typename?: 'StaffAccount';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  status: StaffAccountStatusEnum;
};

export enum StaffAccountStatusEnum {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  PartiallyActive = 'PARTIALLY_ACTIVE',
}

export enum StaffExpenseCategoryEnum {
  AccountTransfer = 'ACCOUNT_TRANSFER',
  AdditionalSalary = 'ADDITIONAL_SALARY',
  Assessment = 'ASSESSMENT',
  Benefits = 'BENEFITS',
  Donation = 'DONATION',
  HealthcareReimbursement = 'HEALTHCARE_REIMBURSEMENT',
  MinistryReimbursement = 'MINISTRY_REIMBURSEMENT',
  Other = 'OTHER',
  Salary = 'SALARY',
  StaffExpense = 'STAFF_EXPENSE',
  Transfer = 'TRANSFER',
  Unknown = 'UNKNOWN',
}

export type StaffExpenses = {
  __typename?: 'StaffExpenses';
  /** The staff account ID from SAA */
  accountId: Scalars['ID']['output'];
  /** The ending balance for the period */
  endBalance?: Maybe<Scalars['Float']['output']>;
  /** Array of fund information with balances and categories */
  funds: Array<Fund>;
  /** The name of the staff account */
  name: Scalars['String']['output'];
  /** The starting balance for the period */
  startBalance?: Maybe<Scalars['Float']['output']>;
  /** The status of the staff account */
  status: Scalars['String']['output'];
  /** Array of years the staff account has transactions in */
  transactionYears: Array<Scalars['Int']['output']>;
};

export enum StaffExpensesSubCategoryEnum {
  /** Account transfer */
  AccountTransfer = 'ACCOUNT_TRANSFER',
  /** Account transfer - Internal gift */
  AccountTransferInternalGift = 'ACCOUNT_TRANSFER_INTERNAL_GIFT',
  /** Additional salary */
  AdditionalSalary = 'ADDITIONAL_SALARY',
  /** Salary - Bereavement */
  Bereavement = 'BEREAVEMENT',
  /** Salary - Bonuses */
  Bonuses = 'BONUSES',
  /** Salary - Civic duty */
  CivicDuty = 'CIVIC_DUTY',
  /** Assessment - Credit card fee */
  CreditCardFee = 'CREDIT_CARD_FEE',
  /** Salary - 403b pretax deduction */
  Deduction_403BPretax = 'DEDUCTION_403B_PRETAX',
  /** Salary - 403b roth deduction */
  Deduction_403BRoth = 'DEDUCTION_403B_ROTH',
  /** Salary - Medical deduction */
  DeductionMedical = 'DEDUCTION_MEDICAL',
  /** Transfer - Deposit */
  Deposit = 'DEPOSIT',
  /** Salary - Disability earnings */
  DisabilityEarnings = 'DISABILITY_EARNINGS',
  /** Benefits - Disability insurance */
  DisabilityInsurance = 'DISABILITY_INSURANCE',
  /** Donation */
  Donation = 'DONATION',
  /** Donation - Internal gift */
  DonationInternalGift = 'DONATION_INTERNAL_GIFT',
  /** Salary - Double time pay */
  DoubleTimePay = 'DOUBLE_TIME_PAY',
  /** Salary - Numeric earnings */
  EarningsNumeric = 'EARNINGS_NUMERIC',
  /** Salary - Emergency weather pay */
  EmergencyWeatherPay = 'EMERGENCY_WEATHER_PAY',
  /** Salary - Expense reimbursement */
  ExpenseReimbursement = 'EXPENSE_REIMBURSEMENT',
  /** Healthcare reimbursement */
  HealthcareReimbursement = 'HEALTHCARE_REIMBURSEMENT',
  /** Benefits - Health & welfare */
  HealthWelfare = 'HEALTH_WELFARE',
  /** Salary - Health & wellness credits */
  HealthWellnessCredits = 'HEALTH_WELLNESS_CREDITS',
  /** Salary - Holiday pay */
  HolidayPay = 'HOLIDAY_PAY',
  /** Salary - Housing allowances */
  HousingAllowances = 'HOUSING_ALLOWANCES',
  /** Benefits - Imputed income */
  ImputedIncome = 'IMPUTED_INCOME',
  /** Salary - International payments */
  InternationalPayments = 'INTERNATIONAL_PAYMENTS',
  /** Benefits - Leave insurance */
  LeaveInsurance = 'LEAVE_INSURANCE',
  /** Benefits - Life insurance */
  LifeInsurance = 'LIFE_INSURANCE',
  /** Benefits - Medical deduction */
  MedicalDeduction = 'MEDICAL_DEDUCTION',
  /** Salary - Medical leave */
  MedicalLeave = 'MEDICAL_LEAVE',
  /** Benefits - Ministry benefits */
  MinistryBenefits = 'MINISTRY_BENEFITS',
  /** Ministry reimbursement */
  MinistryReimbursement = 'MINISTRY_REIMBURSEMENT',
  /** Salary - Ministry team pay */
  MinistryTeamPay = 'MINISTRY_TEAM_PAY',
  /** Donation - Non-cash */
  NonCash = 'NON_CASH',
  /** Benefits - Numeric deduction */
  NumericDeduction = 'NUMERIC_DEDUCTION',
  /** Other */
  Other = 'OTHER',
  /** Assessment - Other assessment */
  OtherAssessment = 'OTHER_ASSESSMENT',
  /** Salary - Other direct payment */
  OtherDirectPayment = 'OTHER_DIRECT_PAYMENT',
  /** Benefits - Other ER charges */
  OtherErCharges = 'OTHER_ER_CHARGES',
  /** Salary - Other leave */
  OtherLeave = 'OTHER_LEAVE',
  /** Salary - Other standard earnings */
  OtherStandardEarnings = 'OTHER_STANDARD_EARNINGS',
  /** Staff expense - Out of pocket */
  OutOfPocket = 'OUT_OF_POCKET',
  /** Salary - Overtime pay */
  OvertimePay = 'OVERTIME_PAY',
  /** Salary - Paid time off */
  PaidTimeOff = 'PAID_TIME_OFF',
  /** Salary - Parental/family leave */
  ParentalFamilyLeave = 'PARENTAL_FAMILY_LEAVE',
  /** Benefits - Payroll taxes */
  PayrollTaxes = 'PAYROLL_TAXES',
  /** Staff expense - PA card */
  PaCard = 'PA_CARD',
  /** Benefits - Program based */
  ProgramBased = 'PROGRAM_BASED',
  /** Staff expense - Purchase */
  Purchase = 'PURCHASE',
  /** Staff expense - Registration */
  Registration = 'REGISTRATION',
  /** Salary - Regular pay */
  RegularPay = 'REGULAR_PAY',
  /** Salary - Relocation */
  Relocation = 'RELOCATION',
  /** Benefits - Retirement contributions */
  RetirementContributions = 'RETIREMENT_CONTRIBUTIONS',
  /** Salary - Retroactive pay */
  RetroactivePay = 'RETROACTIVE_PAY',
  /** Salary - Sabbatical ministry */
  SabbaticalMinistry = 'SABBATICAL_MINISTRY',
  /** Salary - Salary advance */
  SalaryAdvance = 'SALARY_ADVANCE',
  /** Salary - Service awards */
  ServiceAwards = 'SERVICE_AWARDS',
  /** Salary - Severance separation */
  SeveranceSeparation = 'SEVERANCE_SEPARATION',
  /** Salary - Short term assignment */
  ShortTermAssignment = 'SHORT_TERM_ASSIGNMENT',
  /** Salary - Sick leave */
  SickLeave = 'SICK_LEAVE',
  /** Salary - Special pay */
  SpecialPay = 'SPECIAL_PAY',
  /** Staff expense - Staffcard */
  Staffcard = 'STAFFCARD',
  /** Assessment - Staff assessment */
  StaffAssessment = 'STAFF_ASSESSMENT',
  /** Staff expense - Summer mission */
  SummerMission = 'SUMMER_MISSION',
  /** Salary - Tax federal */
  TaxFederal = 'TAX_FEDERAL',
  /** Salary - Tax state */
  TaxState = 'TAX_STATE',
  /** Transfer */
  Transfer = 'TRANSFER',
  /** Unknown */
  Unknown = 'UNKNOWN',
  /** Salary - Unpaid leave */
  UnpaidLeave = 'UNPAID_LEAVE',
  /** Transfer - Withdrawal */
  Withdrawal = 'WITHDRAWAL',
  /** Benefits - Workers compensation */
  WorkersCompensation = 'WORKERS_COMPENSATION',
}

export type StaffInfo = {
  __typename?: 'StaffInfo';
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  age?: Maybe<Scalars['Int']['output']>;
  assignmentCategory?: Maybe<AssignmentCategoryEnum>;
  assignmentId?: Maybe<Scalars['String']['output']>;
  assignmentLength?: Maybe<AssignmentLengthEnum>;
  assignmentStatus?: Maybe<AssignmentStatusEnum>;
  /** Healthcare plan the user is enrolled in; null for anyone who is not RMO staff */
  benefitsPlan?: Maybe<BenefitsPlan>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  /** Dependents on the household's healthcare plan, as HCM holds it for the household's primary healthcare user */
  dependentChildrenWithHealthcareBenefits?: Maybe<Scalars['Int']['output']>;
  emailAddress?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isInternational?: Maybe<Scalars['Boolean']['output']>;
  lastName: Scalars['String']['output'];
  maritalStatus?: Maybe<MaritalStatusEnum>;
  peopleGroupSupportType?: Maybe<PeopleGroupSupportTypeEnum>;
  personNumber: Scalars['String']['output'];
  preferredName?: Maybe<Scalars['String']['output']>;
  primaryPhoneNumber?: Maybe<Scalars['String']['output']>;
  secaStatus?: Maybe<SecaStatusEnum>;
  state?: Maybe<Scalars['String']['output']>;
  tenure?: Maybe<Scalars['Int']['output']>;
  userPersonType?: Maybe<UserPersonTypeEnum>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

/** The quarter the staff member's payroll started in, broken down by month */
export type StartingQuarterPayroll = {
  __typename?: 'StartingQuarterPayroll';
  /** The fiscal year */
  fiscalYear: Scalars['Int']['output'];
  /** The months in the starting quarter */
  months: Array<MpdStartingQuarterMonthlyBreakdown>;
  /** The fiscal quarter number (1-4) */
  quarter: Scalars['Int']['output'];
};

export enum StatusEnum {
  AppointmentScheduled = 'APPOINTMENT_SCHEDULED',
  AskInFuture = 'ASK_IN_FUTURE',
  CallForDecision = 'CALL_FOR_DECISION',
  ContactForAppointment = 'CONTACT_FOR_APPOINTMENT',
  CultivateRelationship = 'CULTIVATE_RELATIONSHIP',
  ExpiredReferral = 'EXPIRED_REFERRAL',
  NeverAsk = 'NEVER_ASK',
  NeverContacted = 'NEVER_CONTACTED',
  NotInterested = 'NOT_INTERESTED',
  PartnerFinancial = 'PARTNER_FINANCIAL',
  PartnerPray = 'PARTNER_PRAY',
  PartnerSpecial = 'PARTNER_SPECIAL',
  ResearchAbandoned = 'RESEARCH_ABANDONED',
  ResearchContactInfo = 'RESEARCH_CONTACT_INFO',
  Unresponsive = 'UNRESPONSIVE',
}

export type StatusesConstant = {
  __typename?: 'StatusesConstant';
  id: StatusEnum;
  value: Scalars['String']['output'];
};

export enum StyleEnum {
  /** announcement should be colored as dangerous */
  Danger = 'danger',
  /** announcement should not have coloring */
  Default = 'default',
  /** announcement should be colored as an informational */
  Info = 'info',
  /** announcement should be colored as successful */
  Success = 'success',
  /** announcement should be colored as a warning */
  Warning = 'warning',
}

export type SubBudgetCategory = {
  __typename?: 'SubBudgetCategory';
  amount: Scalars['Float']['output'];
  category?: Maybe<SubBudgetCategoryEnum>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type SubBudgetCategoryCreateInput = {
  amount: Scalars['Float']['input'];
  label: Scalars['String']['input'];
  primaryBudgetCategoryId: Scalars['ID']['input'];
};

/** Autogenerated input type of SubBudgetCategoryCreateMutation */
export type SubBudgetCategoryCreateMutationInput = {
  /** AccountList ID that the sub budget category will be associated with */
  accountListId: Scalars['ID']['input'];
  /** Attributes for the sub budget category */
  attributes: SubBudgetCategoryCreateInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of SubBudgetCategoryCreateMutation. */
export type SubBudgetCategoryCreateMutationPayload = {
  __typename?: 'SubBudgetCategoryCreateMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  subBudgetCategory: SubBudgetCategory;
};

/** Autogenerated input type of SubBudgetCategoryDeleteMutation */
export type SubBudgetCategoryDeleteMutationInput = {
  /** AccountList ID that the sub budget category is associated with */
  accountListId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the sub budget category to delete */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of SubBudgetCategoryDeleteMutation. */
export type SubBudgetCategoryDeleteMutationPayload = {
  __typename?: 'SubBudgetCategoryDeleteMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export enum SubBudgetCategoryEnum {
  ClothingAdultsClothing = 'CLOTHING_ADULTS_CLOTHING',
  ClothingChildrenClothing = 'CLOTHING_CHILDREN_CLOTHING',
  DebtCarPayment = 'DEBT_CAR_PAYMENT',
  DebtCreditCardPayments = 'DEBT_CREDIT_CARD_PAYMENTS',
  DebtMedicalBillPayments = 'DEBT_MEDICAL_BILL_PAYMENTS',
  DebtSpouseStudentLoanPayment = 'DEBT_SPOUSE_STUDENT_LOAN_PAYMENT',
  DebtStaffStudentLoanPayment = 'DEBT_STAFF_STUDENT_LOAN_PAYMENT',
  DebtTaxBillPayments = 'DEBT_TAX_BILL_PAYMENTS',
  FoodEatingOut = 'FOOD_EATING_OUT',
  FoodGroceries = 'FOOD_GROCERIES',
  GivingGiving = 'GIVING_GIVING',
  HousingHoa = 'HOUSING_HOA',
  HousingMortgageRent = 'HOUSING_MORTGAGE_RENT',
  HousingRealEstateTaxes = 'HOUSING_REAL_ESTATE_TAXES',
  HousingRepairsMaint = 'HOUSING_REPAIRS_MAINT',
  InsuranceAutoInsurance = 'INSURANCE_AUTO_INSURANCE',
  InsuranceDisabilityInsurance = 'INSURANCE_DISABILITY_INSURANCE',
  InsuranceHealthInsurance = 'INSURANCE_HEALTH_INSURANCE',
  InsuranceHomeownerRenterInsurance = 'INSURANCE_HOMEOWNER_RENTER_INSURANCE',
  InsuranceLifeInsurance = 'INSURANCE_LIFE_INSURANCE',
  MealsAndPerDiemMealsPerDiem = 'MEALS_AND_PER_DIEM_MEALS_PER_DIEM',
  MedicalDentist = 'MEDICAL_DENTIST',
  MedicalDoctorBills = 'MEDICAL_DOCTOR_BILLS',
  MedicalMedication = 'MEDICAL_MEDICATION',
  MedicalOptometrist = 'MEDICAL_OPTOMETRIST',
  MedicalVitaminsSupplements = 'MEDICAL_VITAMINS_SUPPLEMENTS',
  MeetingsRetreatsConferencesConferenceCosts = 'MEETINGS_RETREATS_CONFERENCES_CONFERENCE_COSTS',
  MinistryAndMedicalMileageMinistryMiles = 'MINISTRY_AND_MEDICAL_MILEAGE_MINISTRY_MILES',
  MinistryPartnerDevelopmentMpdMaterials = 'MINISTRY_PARTNER_DEVELOPMENT_MPD_MATERIALS',
  MinistryTravelNonDrivingAirfare = 'MINISTRY_TRAVEL_NON_DRIVING_AIRFARE',
  Other = 'OTHER',
  OutsideIncomeNonStaffSpouse = 'OUTSIDE_INCOME_NON_STAFF_SPOUSE',
  OutsideIncomeOutsideIncomeOther = 'OUTSIDE_INCOME_OUTSIDE_INCOME_OTHER',
  OutsideIncomeProperty = 'OUTSIDE_INCOME_PROPERTY',
  OutsideIncomeRetirementSocialSecurity = 'OUTSIDE_INCOME_RETIREMENT_SOCIAL_SECURITY',
  PersonalChildcareBabysitting = 'PERSONAL_CHILDCARE_BABYSITTING',
  PersonalChildBabySupplies = 'PERSONAL_CHILD_BABY_SUPPLIES',
  PersonalCosmeticsHair = 'PERSONAL_COSMETICS_HAIR',
  PersonalFurniture = 'PERSONAL_FURNITURE',
  PersonalGifts = 'PERSONAL_GIFTS',
  PersonalHerPocketMoney = 'PERSONAL_HER_POCKET_MONEY',
  PersonalHisPocketMoney = 'PERSONAL_HIS_POCKET_MONEY',
  PersonalMisc = 'PERSONAL_MISC',
  PersonalPetSupplies = 'PERSONAL_PET_SUPPLIES',
  PersonalToiletries = 'PERSONAL_TOILETRIES',
  RecreationEntertainment = 'RECREATION_ENTERTAINMENT',
  RecreationVacation = 'RECREATION_VACATION',
  SavingEmergencyFund = 'SAVING_EMERGENCY_FUND',
  SavingNonCruRetirement = 'SAVING_NON_CRU_RETIREMENT',
  SuppliesAndMaterialsMinistrySuppliesMaterials = 'SUPPLIES_AND_MATERIALS_MINISTRY_SUPPLIES_MATERIALS',
  TransportationAutoGas = 'TRANSPORTATION_AUTO_GAS',
  TransportationLicenseTaxes = 'TRANSPORTATION_LICENSE_TAXES',
  TransportationRepairsTires = 'TRANSPORTATION_REPAIRS_TIRES',
  UtilitiesElectricity = 'UTILITIES_ELECTRICITY',
  UtilitiesGas = 'UTILITIES_GAS',
  UtilitiesInternet = 'UTILITIES_INTERNET',
  UtilitiesPhoneMobile = 'UTILITIES_PHONE_MOBILE',
  UtilitiesTrash = 'UTILITIES_TRASH',
  UtilitiesWater = 'UTILITIES_WATER',
}

export type SubBudgetCategoryUpdateInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['ID']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of SubBudgetCategoryUpdateMutation */
export type SubBudgetCategoryUpdateMutationInput = {
  /** AccountList ID that the sub budget category is associated with */
  accountListId: Scalars['ID']['input'];
  /** Attributes to update */
  attributes: SubBudgetCategoryUpdateInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of SubBudgetCategoryUpdateMutation. */
export type SubBudgetCategoryUpdateMutationPayload = {
  __typename?: 'SubBudgetCategoryUpdateMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  subBudgetCategory: SubBudgetCategory;
};

export type SubCategory = {
  __typename?: 'SubCategory';
  averagePerMonth: Scalars['Float']['output'];
  breakdownByMonth: Array<BreakdownByMonthWithTransactions>;
  subCategory: StaffExpensesSubCategoryEnum;
  total: Scalars['Float']['output'];
};

export type SyncGoogleAccountInput = {
  googleAccountId: Scalars['ID']['input'];
  googleIntegrationId: Scalars['ID']['input'];
  integrationName: Scalars['String']['input'];
};

export type SyncMailchimpAccountInput = {
  accountListId: Scalars['ID']['input'];
};

export type SyncPrayerlettersAccountInput = {
  accountListId: Scalars['ID']['input'];
};

export type Tag = {
  __typename?: 'Tag';
  count: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type TagHistories = {
  __typename?: 'TagHistories';
  periods: Array<TagHistoriesPeriod>;
};

export type TagHistoriesPeriod = {
  __typename?: 'TagHistoriesPeriod';
  endDate: Scalars['ISO8601Date']['output'];
  startDate: Scalars['ISO8601Date']['output'];
  tags: Array<Tag>;
};

export type Task = {
  __typename?: 'Task';
  activityType?: Maybe<ActivityTypeEnum>;
  comments: CommentConnection;
  completedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  contactIds: Array<Scalars['String']['output']>;
  contacts: ContactConnection;
  createdAt: Scalars['ISO8601DateTime']['output'];
  displayResult?: Maybe<DisplayResultEnum>;
  id: Scalars['ID']['output'];
  location?: Maybe<Scalars['String']['output']>;
  nextAction?: Maybe<ActivityTypeEnum>;
  notificationTimeBefore?: Maybe<Scalars['Int']['output']>;
  notificationTimeUnit?: Maybe<NotificationTimeUnitEnum>;
  notificationType?: Maybe<NotificationTypeEnum>;
  result?: Maybe<ResultEnum>;
  /** Indicates if a user has starred the task */
  starred: Scalars['Boolean']['output'];
  startAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  subject: Scalars['String']['output'];
  tagList: Array<Scalars['String']['output']>;
  taskPhase?: Maybe<PhaseEnum>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  user?: Maybe<UserScopedToAccountList>;
};

export type TaskCommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type TaskContactsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type TaskAnalytics = {
  __typename?: 'TaskAnalytics';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  lastElectronicNewsletterCompletedAt?: Maybe<
    Scalars['ISO8601DateTime']['output']
  >;
  lastPhysicalNewsletterCompletedAt?: Maybe<
    Scalars['ISO8601DateTime']['output']
  >;
  tasksOverdueOrDueTodayCounts: Array<OverdueOrDueTodayTaskAnalytic>;
  totalTasksDueCount: Scalars['Int']['output'];
  type: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  updatedInDbAt: Scalars['ISO8601DateTime']['output'];
};

export type TaskCommentCreateInput = {
  body: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated input type of TaskCommentCreateMutation */
export type TaskCommentCreateMutationInput = {
  /** AccountList ID that the comment is associated with */
  accountListId: Scalars['ID']['input'];
  /** attributes to create */
  attributes: TaskCommentCreateInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Task ID that the comment is associated with */
  taskId: Scalars['ID']['input'];
};

/** Autogenerated return type of TaskCommentCreateMutation. */
export type TaskCommentCreateMutationPayload = {
  __typename?: 'TaskCommentCreateMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  comment: Comment;
};

/** The connection type for Task. */
export type TaskConnection = {
  __typename?: 'TaskConnection';
  /** A list of edges. */
  edges: Array<TaskEdge>;
  /** A list of nodes. */
  nodes: Array<Task>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total # of objects returned from this Plural Query */
  totalCount: Scalars['Int']['output'];
  /** Total # of pages, based on total count and pagesize */
  totalPageCount: Scalars['Int']['output'];
};

export type TaskCreateInput = {
  activityType?: InputMaybe<ActivityTypeEnum>;
  /** Comment to add to new task */
  comment?: InputMaybe<Scalars['String']['input']>;
  completedAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  contactIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  displayResult?: InputMaybe<DisplayResultEnum>;
  location?: InputMaybe<Scalars['String']['input']>;
  nextAction?: InputMaybe<ActivityTypeEnum>;
  notificationTimeBefore?: InputMaybe<Scalars['Int']['input']>;
  notificationTimeUnit?: InputMaybe<NotificationTimeUnitEnum>;
  notificationType?: InputMaybe<NotificationTypeEnum>;
  result?: InputMaybe<ResultEnum>;
  starred?: InputMaybe<Scalars['Boolean']['input']>;
  startAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  subject: Scalars['String']['input'];
  tagList?: InputMaybe<Array<Scalars['String']['input']>>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated input type of TaskCreateMutation */
export type TaskCreateMutationInput = {
  /** AccountList ID that the task is associated with */
  accountListId: Scalars['ID']['input'];
  /** attributes to create */
  attributes: TaskCreateInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of TaskCreateMutation. */
export type TaskCreateMutationPayload = {
  __typename?: 'TaskCreateMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  task: Task;
};

/** Autogenerated input type of TaskDeleteMutation */
export type TaskDeleteMutationInput = {
  /** AccountList ID that the task is associated with */
  accountListId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of task to delete */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of TaskDeleteMutation. */
export type TaskDeleteMutationPayload = {
  __typename?: 'TaskDeleteMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

/** An edge in a connection. */
export type TaskEdge = {
  __typename?: 'TaskEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Task>;
};

export type TaskFilterSetInput = {
  /** Filter by Action; Accepts multiple parameters, with values "Call", "Appointment", "Email", "Text Message", "Facebook Message", "Letter", "Newsletter", "Pre Call Letter", "Reminder Letter", "Support Letter", "Thank", "To Do", "Talk to In Person", or "Prayer Request" */
  activityType?: InputMaybe<Array<ActivityTypeEnum>>;
  /** When filtering by tags this specifies if the filter should match tasks with any of the filtered tags if "true" or only tasks with all of the filtered tags if "false" */
  anyTags?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by Completed; Accepts values "true", or "false" */
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter Tasks by completed at date given a date range */
  completedAt?: InputMaybe<DateTimeRangeInput>;
  /** Filter by Appeal; Accepts multiple parameters, with value 'no_appeals', or an appeal ID */
  contactAppeal?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by Church; Accepts multiple parameters, with value 'none', or a church name */
  contactChurch?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by City; Accepts multiple parameters, with value 'none', or a city name */
  contactCity?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by Country; Accepts multiple parameters, with values 'none', or a country */
  contactCountry?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by Designation Account; accepts multiple parameters, separated by comma */
  contactDesignationAccountId?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter by Contact IDs; Accepts multiple parameters, with Contact IDs */
  contactIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter where contact has address; Accepts values 'Yes', or 'No' */
  contactInfoAddr?: InputMaybe<Scalars['String']['input']>;
  /** Filter where contact people have email addresses; Accepts values 'Yes', or 'No' */
  contactInfoEmail?: InputMaybe<Scalars['String']['input']>;
  /** Filter where contact people have mobile phones; Accepts values 'Yes', or 'No' */
  contactInfoMobile?: InputMaybe<Scalars['String']['input']>;
  /** Filter where contact people have home phones; Accepts values 'Yes', or 'No' */
  contactInfoPhone?: InputMaybe<Scalars['String']['input']>;
  /** Filter where contact people have work phones; Accepts values 'Yes', or 'No' */
  contactInfoWorkPhone?: InputMaybe<Scalars['String']['input']>;
  /** Filter by Likely To Give; Accepts multiple parameters, with values 'none', 'Least Likely', 'Likely', and 'Most Likely' */
  contactLikely?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by Metro Area; Accepts multiple parameters, with values 'none', or a metro area name */
  contactMetroArea?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by Newsletter Recipients; Accepts values 'none', 'all', 'address', 'email', and 'both' */
  contactNewsletter?: InputMaybe<Scalars['String']['input']>;
  /** Filter by Pledge Frequency; Accepts multiple parameters, with numeric values like '0.23076923076923' (Weekly), '0.46153846153846' (Every 2 Weeks), '1.0' (Monthly), '2.0' (Every 2 Months), '3.0', '4.0', '6.0', '12.0' (Yearly), and '24.0' (Every 2 Years) */
  contactPledgeFrequency?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by Referrer; Accepts multiple parameters, with values 'none', 'any', or a Contact ID */
  contactReferrer?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by Region; Accepts multiple parameters, with values 'none', or a region name */
  contactRegion?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by State; Accepts multiple parameters, with values 'none', or a state */
  contactState?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by Status; Accepts multiple parameters, with values 'active', 'hidden', 'null', 'Never Contacted', 'Ask in Future', 'Cultivate Relationship', 'Contact for Appointment', 'Appointment Scheduled', 'Call for Decision', 'Partner - Financial', 'Partner - Special', 'Partner - Pray', 'Not Interested', 'Unresponsive', 'Never Ask', 'Research Abandoned', and 'Expired Referral' */
  contactStatus?: InputMaybe<Array<ContactFilterStatusEnum>>;
  /** Filter by Contact Tags; Accepts multiple parameters, with text values separated by comma */
  contactTags?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by Timezone; Accepts multiple parameters */
  contactTimezone?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by Type; Accepts multiple parameters, with values 'person', and 'company' */
  contactType?: InputMaybe<Array<Scalars['String']['input']>>;
  createdAt?: InputMaybe<DateRangeInput>;
  /** Filter by Date Range; Accepts values "last_month", "last_year", "last_two_years", "last_week", "overdue", "today", "tomorrow", "future", "upcoming" and "no_date" */
  dateRange?: InputMaybe<Scalars['String']['input']>;
  /** Filter tasks that have any of the tags included in this filter; comma separated value for multiple */
  excludeTags?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter tasks with ids included in this filter; comma separated value for multiple */
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter by Next Action; Accepts multiple parameters */
  nextAction?: InputMaybe<Array<ActivityTypeEnum>>;
  /** Filter by overdue; Accepts values "true", or "false" */
  overdue?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by Result; Accepts multiple parameters */
  result?: InputMaybe<Array<ResultEnum>>;
  reverseActivityType?: InputMaybe<Scalars['Boolean']['input']>;
  reverseContactAppeal?: InputMaybe<Scalars['Boolean']['input']>;
  reverseContactChurch?: InputMaybe<Scalars['Boolean']['input']>;
  reverseContactCity?: InputMaybe<Scalars['Boolean']['input']>;
  reverseContactCountry?: InputMaybe<Scalars['Boolean']['input']>;
  reverseContactDesignationAccountId?: InputMaybe<Scalars['Boolean']['input']>;
  reverseContactIds?: InputMaybe<Scalars['Boolean']['input']>;
  reverseContactLikely?: InputMaybe<Scalars['Boolean']['input']>;
  reverseContactMetroArea?: InputMaybe<Scalars['Boolean']['input']>;
  reverseContactPledgeFrequency?: InputMaybe<Scalars['Boolean']['input']>;
  reverseContactReferrer?: InputMaybe<Scalars['Boolean']['input']>;
  reverseContactRegion?: InputMaybe<Scalars['Boolean']['input']>;
  reverseContactState?: InputMaybe<Scalars['Boolean']['input']>;
  reverseContactStatus?: InputMaybe<Scalars['Boolean']['input']>;
  reverseContactTags?: InputMaybe<Scalars['Boolean']['input']>;
  reverseContactTimezone?: InputMaybe<Scalars['Boolean']['input']>;
  reverseContactType?: InputMaybe<Scalars['Boolean']['input']>;
  reverseNextAction?: InputMaybe<Scalars['Boolean']['input']>;
  reverseResult?: InputMaybe<Scalars['Boolean']['input']>;
  reverseTags?: InputMaybe<Scalars['Boolean']['input']>;
  reverseUserIds?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by starred; Accepts values "true", or "false" */
  starred?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter Tasks by start at date given a date range */
  startAt?: InputMaybe<DateTimeRangeInput>;
  /** Filter by Tags; Accepts multiple parameters, with text values separated by comma */
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter tasks that were updated in this date range */
  updatedAt?: InputMaybe<DateTimeRangeInput>;
  /** Filter tasks with user_ids included in this filter; comma separated value for multiple */
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter tasks where subject contains this filter */
  wildcardSearch?: InputMaybe<Scalars['String']['input']>;
};

export type TaskResultPair = {
  __typename?: 'TaskResultPair';
  result?: Maybe<ResultEnum>;
  task?: Maybe<ActivityTypeEnum>;
};

export enum TaskSortEnum {
  /** sort by created_at ASC */
  CreatedAtAsc = 'CREATED_AT_ASC',
  /** sort by created_at DESC */
  CreatedAtDesc = 'CREATED_AT_DESC',
  /** most recently overdue first, then completed at descending, then start at ascending, then tasks with no due date */
  DefaultSortParam = 'DEFAULT_SORT_PARAM',
  /** sort by start_at ASC */
  StartAtAsc = 'START_AT_ASC',
  /** sort by start_at DESC */
  StartAtDesc = 'START_AT_DESC',
}

export type TaskUpdateInput = {
  activityType?: InputMaybe<ActivityTypeEnum>;
  completedAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  contactIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  displayResult?: InputMaybe<DisplayResultEnum>;
  id: Scalars['ID']['input'];
  location?: InputMaybe<Scalars['String']['input']>;
  nextAction?: InputMaybe<ActivityTypeEnum>;
  notificationTimeBefore?: InputMaybe<Scalars['Int']['input']>;
  notificationTimeUnit?: InputMaybe<NotificationTimeUnitEnum>;
  notificationType?: InputMaybe<NotificationTypeEnum>;
  result?: InputMaybe<ResultEnum>;
  starred?: InputMaybe<Scalars['Boolean']['input']>;
  startAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  tagList?: InputMaybe<Array<Scalars['String']['input']>>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated input type of TaskUpdateMutation */
export type TaskUpdateMutationInput = {
  /** AccountList ID that the task is associated with */
  accountListId: Scalars['ID']['input'];
  /** attributes to update */
  attributes: TaskUpdateInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of TaskUpdateMutation. */
export type TaskUpdateMutationPayload = {
  __typename?: 'TaskUpdateMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  task: Task;
};

/** Autogenerated input type of TasksCreateMutation */
export type TasksCreateMutationInput = {
  /** AccountList ID that the tasks are associated with */
  accountListId: Scalars['ID']['input'];
  /** Attributes of created tasks */
  attributes: TaskCreateInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of TasksCreateMutation. */
export type TasksCreateMutationPayload = {
  __typename?: 'TasksCreateMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  tasks: Array<Task>;
};

/** Autogenerated input type of TasksDeleteMutation */
export type TasksDeleteMutationInput = {
  /** AccountList ID that the task is associated with */
  accountListId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** IDs of task to delete */
  ids: Array<Scalars['String']['input']>;
};

/** Autogenerated return type of TasksDeleteMutation. */
export type TasksDeleteMutationPayload = {
  __typename?: 'TasksDeleteMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  ids: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of TasksUpdateMutation */
export type TasksUpdateMutationInput = {
  /** AccountList ID that the task is associated with */
  accountListId: Scalars['ID']['input'];
  /** attributes to update */
  attributes: Array<TaskUpdateInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of TasksUpdateMutation. */
export type TasksUpdateMutationPayload = {
  __typename?: 'TasksUpdateMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  tasks: Array<Task>;
};

export type Tenure = {
  __typename?: 'Tenure';
  createdAt: Scalars['ISO8601DateTime']['output'];
  fifteenToNineteenYears: Scalars['Float']['output'];
  fiveToNineYears: Scalars['Float']['output'];
  fortyFivePlusYears: Scalars['Float']['output'];
  fortyToFortyFourYears: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  tenToFourteenYears: Scalars['Float']['output'];
  thirtyFiveToThirtyNineYears: Scalars['Float']['output'];
  thirtyToThirtyFourYears: Scalars['Float']['output'];
  twentyFiveToTwentyNineYears: Scalars['Float']['output'];
  twentyToTwentyFourYears: Scalars['Float']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  year: Scalars['Int']['output'];
  zeroToFourYears: Scalars['Float']['output'];
};

export type TextFilter = Filter & {
  __typename?: 'TextFilter';
  filterKey: Scalars['String']['output'];
  options?: Maybe<Array<FilterOption>>;
  title: Scalars['String']['output'];
};

export type TextMessageAccountListAnalytics = {
  __typename?: 'TextMessageAccountListAnalytics';
  received: Scalars['Int']['output'];
  sent: Scalars['Int']['output'];
};

export type Time = {
  __typename?: 'Time';
  key?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type Total = {
  __typename?: 'Total';
  /** donation total without currency conversion */
  amount: Scalars['Float']['output'];
  /** donation total converted half-way through period */
  convertedAmount: Scalars['Float']['output'];
  currency: Scalars['String']['output'];
};

export type TransactionCategory = {
  __typename?: 'TransactionCategory';
  averagePerMonth: Scalars['Float']['output'];
  breakdownByMonth: Array<BreakdownByMonth>;
  category: StaffExpenseCategoryEnum;
  subcategories: Array<SubCategory>;
  total: Scalars['Float']['output'];
};

export type Transfer = {
  __typename?: 'Transfer';
  destinationFundTypeName: Scalars['String']['output'];
  sourceFundTypeName: Scalars['String']['output'];
};

/** Autogenerated input type of TransferCreateMutation */
export type TransferCreateMutationInput = {
  /** Amount to transfer */
  amount: Scalars['Float']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Description for the transfer */
  description: Scalars['String']['input'];
  /** Fund type to transfer to */
  destinationFundTypeName: Scalars['String']['input'];
  /** Fund type to transfer from */
  sourceFundTypeName: Scalars['String']['input'];
  /** Date the transfer will be transacted */
  transactedAt: Scalars['ISO8601Date']['input'];
};

/** Autogenerated return type of TransferCreateMutation. */
export type TransferCreateMutationPayload = {
  __typename?: 'TransferCreateMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type TwitterAccount = {
  __typename?: 'TwitterAccount';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  screenName?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** The connection type for TwitterAccount. */
export type TwitterAccountConnection = {
  __typename?: 'TwitterAccountConnection';
  /** A list of edges. */
  edges: Array<TwitterAccountEdge>;
  /** A list of nodes. */
  nodes: Array<TwitterAccount>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total # of objects returned from this Plural Query */
  totalCount: Scalars['Int']['output'];
  /** Total # of pages, based on total count and pagesize */
  totalPageCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type TwitterAccountEdge = {
  __typename?: 'TwitterAccountEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<TwitterAccount>;
};

export enum TypeEnum {
  Contact = 'Contact',
  Person = 'Person',
}

export type UpdateGoogleIntegrationInput = {
  googleAccountId: Scalars['ID']['input'];
  googleIntegration: GoogleAccountIntegrationInput;
  googleIntegrationId: Scalars['ID']['input'];
};

export type UpdateMailchimpAccountInput = {
  accountListId: Scalars['ID']['input'];
  mailchimpAccount: UpdateMailchimpAccountInputAccount;
  mailchimpAccountId: Scalars['ID']['input'];
};

export type UpdateMailchimpAccountInputAccount = {
  autoLogCampaigns: Scalars['Boolean']['input'];
  primaryListId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated input type of UpdateMinistryPartnerReminders */
export type UpdateMinistryPartnerRemindersInput = {
  /** AccountList ID that the design number is associated with */
  accountListId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Designation number to update reminders for */
  designationNumber: Scalars['String']['input'];
  /** Array of reminder updates to apply */
  updates: Array<MinistryPartnerReminderUpdateInput>;
};

/** Autogenerated return type of UpdateMinistryPartnerReminders. */
export type UpdateMinistryPartnerRemindersPayload = {
  __typename?: 'UpdateMinistryPartnerRemindersPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Number of reminders updated */
  updatedCount: Scalars['Int']['output'];
};

export enum UsStaffGroupEnum {
  Intern = 'INTERN',
  NationalExpat = 'NATIONAL_EXPAT',
  NewInternationalStaff = 'NEW_INTERNATIONAL_STAFF',
  NewStaff = 'NEW_STAFF',
  NewStaffStint = 'NEW_STAFF_STINT',
  PaidWithDesignation = 'PAID_WITH_DESIGNATION',
  PartTimeFieldStaff = 'PART_TIME_FIELD_STAFF',
  SeniorInternationalStaff = 'SENIOR_INTERNATIONAL_STAFF',
  SeniorStaff = 'SENIOR_STAFF',
  SeniorStaffStint = 'SENIOR_STAFF_STINT',
}

export type User = {
  __typename?: 'User';
  admin: Scalars['Boolean']['output'];
  administrativeOrganizations: OrganizationConnection;
  almaMater?: Maybe<Scalars['String']['output']>;
  anniversaryDay?: Maybe<Scalars['Int']['output']>;
  anniversaryMonth?: Maybe<Scalars['Int']['output']>;
  anniversaryYear?: Maybe<Scalars['Int']['output']>;
  avatar: Scalars['String']['output'];
  birthdayDay?: Maybe<Scalars['Int']['output']>;
  birthdayMonth?: Maybe<Scalars['Int']['output']>;
  birthdayYear?: Maybe<Scalars['Int']['output']>;
  /** Whether this user may open the MPD Goal admin table (MPD Goals team or MPD coordinator) */
  canViewNewStaffCohorts: Scalars['Boolean']['output'];
  contactId: Scalars['ID']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  deceased: Scalars['Boolean']['output'];
  defaultAccountList?: Maybe<Scalars['String']['output']>;
  developer: Scalars['Boolean']['output'];
  emailAddresses: EmailAddressConnection;
  employer?: Maybe<Scalars['String']['output']>;
  facebookAccounts: FacebookAccountConnection;
  familyRelationships: FamilyRelationshipConnection;
  firstName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Key Accounts used to authenticate this user */
  keyAccounts: Array<KeyAccount>;
  lastName?: Maybe<Scalars['String']['output']>;
  legalFirstName?: Maybe<Scalars['String']['output']>;
  linkedinAccounts: LinkedinAccountConnection;
  localeDisplay?: Maybe<Scalars['String']['output']>;
  maritalStatus?: Maybe<Scalars['String']['output']>;
  mpdSupervisorAdmin: Scalars['Boolean']['output'];
  occupation?: Maybe<Scalars['String']['output']>;
  optoutEnewsletter: Scalars['Boolean']['output'];
  phoneNumbers: PhoneNumberConnection;
  preferences?: Maybe<Preference>;
  primaryDesignation?: Maybe<Scalars['String']['output']>;
  primaryEmailAddress?: Maybe<EmailAddress>;
  primaryPhoneNumber?: Maybe<PhoneNumber>;
  setup?: Maybe<UserSetupStageEnum>;
  spouseUsStaffGroup?: Maybe<UsStaffGroupEnum>;
  staffAccountId?: Maybe<Scalars['String']['output']>;
  suffix?: Maybe<Scalars['String']['output']>;
  supervisesStaff: Scalars['Boolean']['output'];
  title?: Maybe<Scalars['String']['output']>;
  twitterAccounts: TwitterAccountConnection;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  usStaffGroup?: Maybe<UsStaffGroupEnum>;
  userType: UserTypeEnum;
  websites: WebsiteConnection;
};

export type UserAdministrativeOrganizationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type UserEmailAddressesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type UserFacebookAccountsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type UserFamilyRelationshipsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type UserLinkedinAccountsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type UserPhoneNumbersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type UserTwitterAccountsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type UserWebsitesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated input type of UserDeleteMutation */
export type UserDeleteMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  reason: Scalars['String']['input'];
  resettedUserEmail?: InputMaybe<Scalars['String']['input']>;
  resettedUserId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UserDeleteMutation. */
export type UserDeleteMutationPayload = {
  __typename?: 'UserDeleteMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

/** Autogenerated input type of UserGeographicLocationUpdateMutation */
export type UserGeographicLocationUpdateMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Geographic location to store on the current user's primary account list */
  geographicLocation: Scalars['String']['input'];
};

/** Autogenerated return type of UserGeographicLocationUpdateMutation. */
export type UserGeographicLocationUpdateMutationPayload = {
  __typename?: 'UserGeographicLocationUpdateMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The updated geographic location */
  geographicLocation: Scalars['String']['output'];
};

/** Autogenerated input type of UserKeySignInMutation */
export type UserKeySignInMutationInput = {
  casTicket: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UserKeySignInMutation. */
export type UserKeySignInMutationPayload = {
  __typename?: 'UserKeySignInMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export type UserNotification = {
  __typename?: 'UserNotification';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  notification: Notification;
  read: Scalars['Boolean']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Autogenerated input type of UserOptionDeleteMutation */
export type UserOptionDeleteMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of UserOptionDeleteMutation. */
export type UserOptionDeleteMutationPayload = {
  __typename?: 'UserOptionDeleteMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export enum UserPersonTypeEnum {
  /** Employee - Hourly */
  EmployeeHourly = 'EMPLOYEE_HOURLY',
  /** Employee - International Intern */
  EmployeeInternationalIntern = 'EMPLOYEE_INTERNATIONAL_INTERN',
  /** Employee - National Staff (Expat) */
  EmployeeNationalStaffExpat = 'EMPLOYEE_NATIONAL_STAFF_EXPAT',
  /** Employee - PTFS */
  EmployeePtfs = 'EMPLOYEE_PTFS',
  /** Employee - Salaried */
  EmployeeSalaried = 'EMPLOYEE_SALARIED',
  /** Employee - Staff */
  EmployeeStaff = 'EMPLOYEE_STAFF',
  /** Employee - Staff - non-RMO Spouse */
  EmployeeStaffNonRmoSpouse = 'EMPLOYEE_STAFF_NON_RMO_SPOUSE',
  /** Employee - US Intern */
  EmployeeUsIntern = 'EMPLOYEE_US_INTERN',
  /** Non-worker - Continuation of Coverage */
  NonworkerContinuationOfCoverage = 'NONWORKER_CONTINUATION_OF_COVERAGE',
  /** Non-worker - National Staff */
  NonworkerNationalStaff = 'NONWORKER_NATIONAL_STAFF',
  /** Non-worker - NMBHR */
  NonworkerNmbhr = 'NONWORKER_NMBHR',
  /** Non-worker - Non-Employee */
  NonworkerNonEmployee = 'NONWORKER_NON_EMPLOYEE',
  /** Non-worker - Retiree */
  NonworkerRetiree = 'NONWORKER_RETIREE',
  /** Non-worker - Staff */
  NonworkerStaff = 'NONWORKER_STAFF',
  /** Non-worker - Staff Emeritus */
  NonworkerStaffEmeritus = 'NONWORKER_STAFF_EMERITUS',
  /** Non-worker - Subsidiary */
  NonworkerSubsidiary = 'NONWORKER_SUBSIDIARY',
  /** Non-worker - Volunteer */
  NonworkerVolunteer = 'NONWORKER_VOLUNTEER',
  /** Pending - Hourly */
  PendingHourly = 'PENDING_HOURLY',
  /** Pending - International Intern */
  PendingInternationalIntern = 'PENDING_INTERNATIONAL_INTERN',
  /** Pending - PTFS */
  PendingPtfs = 'PENDING_PTFS',
  /** Pending - Salaried */
  PendingSalaried = 'PENDING_SALARIED',
  /** Pending - Staff */
  PendingStaff = 'PENDING_STAFF',
  /** Pending - Staff - non-RMO Spouse */
  PendingStaffNonRmoSpouse = 'PENDING_STAFF_NON_RMO_SPOUSE',
  /** Pending - US Intern */
  PendingUsIntern = 'PENDING_US_INTERN',
}

export type UserPreferenceUpdateInput = {
  contactsFilter?: InputMaybe<Scalars['String']['input']>;
  hourToSendNotifications?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  localeDisplay?: InputMaybe<Scalars['String']['input']>;
  tabOrders?: InputMaybe<Scalars['String']['input']>;
  tasksFilter?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of UserPreferenceUpdateMutation */
export type UserPreferenceUpdateMutationInput = {
  /** attrs to update */
  attributes: UserPreferenceUpdateInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UserPreferenceUpdateMutation. */
export type UserPreferenceUpdateMutationPayload = {
  __typename?: 'UserPreferenceUpdateMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  preference: Preference;
};

/** this is a User but visible fields are significantly limited. */
export type UserScopedToAccountList = {
  __typename?: 'UserScopedToAccountList';
  createdAt: Scalars['ISO8601DateTime']['output'];
  emailAddresses: EmailAddressConnection;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  phoneNumbers: PhoneNumberConnection;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** this is a User but visible fields are significantly limited. */
export type UserScopedToAccountListEmailAddressesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** this is a User but visible fields are significantly limited. */
export type UserScopedToAccountListPhoneNumbersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for UserScopedToAccountList. */
export type UserScopedToAccountListConnection = {
  __typename?: 'UserScopedToAccountListConnection';
  /** A list of edges. */
  edges: Array<UserScopedToAccountListEdge>;
  /** A list of nodes. */
  nodes: Array<UserScopedToAccountList>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total # of objects returned from this Plural Query */
  totalCount: Scalars['Int']['output'];
  /** Total # of pages, based on total count and pagesize */
  totalPageCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type UserScopedToAccountListEdge = {
  __typename?: 'UserScopedToAccountListEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<UserScopedToAccountList>;
};

export enum UserSetupStageEnum {
  NoAccountLists = 'NO_ACCOUNT_LISTS',
  NoDefaultAccountList = 'NO_DEFAULT_ACCOUNT_LIST',
  NoOrganizationAccount = 'NO_ORGANIZATION_ACCOUNT',
}

export enum UserTypeEnum {
  /** Staff affiliated only with Cru ministries outside the US */
  GlobalStaff = 'GLOBAL_STAFF',
  /** Staff affiliated with both US and global Cru organizations */
  HybridStaff = 'HYBRID_STAFF',
  /** User not affiliated with any Cru organization */
  NonCru = 'NON_CRU',
  /** Staff affiliated only with US Cru organizations */
  UsStaff = 'US_STAFF',
}

export type UserUpdateInput = {
  almaMater?: InputMaybe<Scalars['String']['input']>;
  anniversaryDay?: InputMaybe<Scalars['Int']['input']>;
  anniversaryMonth?: InputMaybe<Scalars['Int']['input']>;
  anniversaryYear?: InputMaybe<Scalars['Int']['input']>;
  birthdayDay?: InputMaybe<Scalars['Int']['input']>;
  birthdayMonth?: InputMaybe<Scalars['Int']['input']>;
  birthdayYear?: InputMaybe<Scalars['Int']['input']>;
  deceased?: InputMaybe<Scalars['Boolean']['input']>;
  defaultAccountList?: InputMaybe<Scalars['String']['input']>;
  emailAddresses?: InputMaybe<Array<PersonEmailAddressInput>>;
  employer?: InputMaybe<Scalars['String']['input']>;
  facebookAccounts?: InputMaybe<Array<PersonFacebookAccountInput>>;
  familyRelationships?: InputMaybe<Array<PersonFamilyRelationshipInput>>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  legalFirstName?: InputMaybe<Scalars['String']['input']>;
  linkedinAccounts?: InputMaybe<Array<PersonLinkedinAccountInput>>;
  maritalStatus?: InputMaybe<Scalars['String']['input']>;
  occupation?: InputMaybe<Scalars['String']['input']>;
  optoutEnewsletter?: InputMaybe<Scalars['Boolean']['input']>;
  phoneNumbers?: InputMaybe<Array<PersonPhoneNumberInput>>;
  suffix?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  twitterAccounts?: InputMaybe<Array<PersonTwitterAccountInput>>;
  websites?: InputMaybe<Array<PersonWebsiteInput>>;
};

/** Autogenerated input type of UserUpdateMutation */
export type UserUpdateMutationInput = {
  /** attrs to update */
  attributes?: InputMaybe<UserUpdateInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UserUpdateMutation. */
export type UserUpdateMutationPayload = {
  __typename?: 'UserUpdateMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  user: User;
};

export type Website = {
  __typename?: 'Website';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

/** The connection type for Website. */
export type WebsiteConnection = {
  __typename?: 'WebsiteConnection';
  /** A list of edges. */
  edges: Array<WebsiteEdge>;
  /** A list of nodes. */
  nodes: Array<Website>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total # of objects returned from this Plural Query */
  totalCount: Scalars['Int']['output'];
  /** Total # of pages, based on total count and pagesize */
  totalPageCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type WebsiteEdge = {
  __typename?: 'WebsiteEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Website>;
};

export type WinnersAndLosers = {
  loserId: Scalars['ID']['input'];
  winnerId: Scalars['ID']['input'];
};

export type YearToDate = {
  __typename?: 'YearToDate';
  additionalSalaryPaymentsReceived?: Maybe<Scalars['Float']['output']>;
  bonus?: Maybe<Scalars['Float']['output']>;
  grossEarnings?: Maybe<Scalars['Float']['output']>;
  mhaReceived?: Maybe<Scalars['Float']['output']>;
  preTaxFourOThreeBContributions?: Maybe<Scalars['Float']['output']>;
  rothFourOThreeBContributions?: Maybe<Scalars['Float']['output']>;
  taxableDeductions?: Maybe<Scalars['Float']['output']>;
};

/** The sdl representing the federated service capabilities. Includes federation directives, removes federation types, and includes rest of full schema after schema directives have been applied */
export type _Service = {
  __typename?: '_Service';
  sdl?: Maybe<Scalars['String']['output']>;
};
